import * as ar from "react";
import fe, { useMemo as Ae, useReducer as cr, useEffect as G, useContext as xe, useRef as K, useState as A, useLayoutEffect as Pe, createContext as fo, useCallback as Jt, cloneElement as ho, memo as Et, createElement as po } from "react";
import { createPortal as jn } from "react-dom";
import { useSearchParams as mo, Link as Ct, generatePath as wn, useParams as bn, Navigate as go } from "react-router-dom";
function xo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var at = { exports: {} }, We = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sn;
function vo() {
  if (Sn) return We;
  Sn = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(o, s, l) {
    var a = null;
    if (l !== void 0 && (a = "" + l), s.key !== void 0 && (a = "" + s.key), "key" in s) {
      l = {};
      for (var c in s)
        c !== "key" && (l[c] = s[c]);
    } else l = s;
    return s = l.ref, {
      $$typeof: e,
      type: o,
      key: a,
      ref: s !== void 0 ? s : null,
      props: l
    };
  }
  return We.Fragment = t, We.jsx = n, We.jsxs = n, We;
}
var Ue = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $n;
function yo() {
  return $n || ($n = 1, process.env.NODE_ENV !== "production" && function() {
    function e(f) {
      if (f == null) return null;
      if (typeof f == "function")
        return f.$$typeof === R ? null : f.displayName || f.name || null;
      if (typeof f == "string") return f;
      switch (f) {
        case C:
          return "Fragment";
        case H:
          return "Portal";
        case N:
          return "Profiler";
        case V:
          return "StrictMode";
        case j:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof f == "object")
        switch (typeof f.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), f.$$typeof) {
          case de:
            return (f.displayName || "Context") + ".Provider";
          case ie:
            return (f._context.displayName || "Context") + ".Consumer";
          case y:
            var $ = f.render;
            return f = f.displayName, f || (f = $.displayName || $.name || "", f = f !== "" ? "ForwardRef(" + f + ")" : "ForwardRef"), f;
          case k:
            return $ = f.displayName || null, $ !== null ? $ : e(f.type) || "Memo";
          case U:
            $ = f._payload, f = f._init;
            try {
              return e(f($));
            } catch {
            }
        }
      return null;
    }
    function t(f) {
      return "" + f;
    }
    function n(f) {
      try {
        t(f);
        var $ = !1;
      } catch {
        $ = !0;
      }
      if ($) {
        $ = console;
        var S = $.error, D = typeof Symbol == "function" && Symbol.toStringTag && f[Symbol.toStringTag] || f.constructor.name || "Object";
        return S.call(
          $,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          D
        ), t(f);
      }
    }
    function o() {
    }
    function s() {
      if (Z === 0) {
        le = console.log, ee = console.info, oe = console.warn, he = console.error, me = console.group, ot = console.groupCollapsed, st = console.groupEnd;
        var f = {
          configurable: !0,
          enumerable: !0,
          value: o,
          writable: !0
        };
        Object.defineProperties(console, {
          info: f,
          log: f,
          warn: f,
          error: f,
          group: f,
          groupCollapsed: f,
          groupEnd: f
        });
      }
      Z++;
    }
    function l() {
      if (Z--, Z === 0) {
        var f = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: q({}, f, { value: le }),
          info: q({}, f, { value: ee }),
          warn: q({}, f, { value: oe }),
          error: q({}, f, { value: he }),
          group: q({}, f, { value: me }),
          groupCollapsed: q({}, f, { value: ot }),
          groupEnd: q({}, f, { value: st })
        });
      }
      0 > Z && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function a(f) {
      if (He === void 0)
        try {
          throw Error();
        } catch (S) {
          var $ = S.stack.trim().match(/\n( *(at )?)/);
          He = $ && $[1] || "", it = -1 < S.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < S.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + He + f + it;
    }
    function c(f, $) {
      if (!f || Ve) return "";
      var S = Re.get(f);
      if (S !== void 0) return S;
      Ve = !0, S = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var D = null;
      D = W.H, W.H = null, s();
      try {
        var J = {
          DetermineComponentFrameRoot: function() {
            try {
              if ($) {
                var $e = function() {
                  throw Error();
                };
                if (Object.defineProperty($e.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct($e, []);
                  } catch (_e) {
                    var lt = _e;
                  }
                  Reflect.construct(f, [], $e);
                } else {
                  try {
                    $e.call();
                  } catch (_e) {
                    lt = _e;
                  }
                  f.call($e.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (_e) {
                  lt = _e;
                }
                ($e = f()) && typeof $e.catch == "function" && $e.catch(function() {
                });
              }
            } catch (_e) {
              if (_e && lt && typeof _e.stack == "string")
                return [_e.stack, lt.stack];
            }
            return [null, null];
          }
        };
        J.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var Y = Object.getOwnPropertyDescriptor(
          J.DetermineComponentFrameRoot,
          "name"
        );
        Y && Y.configurable && Object.defineProperty(
          J.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var F = J.DetermineComponentFrameRoot(), ke = F[0], Fe = F[1];
        if (ke && Fe) {
          var ae = ke.split(`
`), Me = Fe.split(`
`);
          for (F = Y = 0; Y < ae.length && !ae[Y].includes(
            "DetermineComponentFrameRoot"
          ); )
            Y++;
          for (; F < Me.length && !Me[F].includes(
            "DetermineComponentFrameRoot"
          ); )
            F++;
          if (Y === ae.length || F === Me.length)
            for (Y = ae.length - 1, F = Me.length - 1; 1 <= Y && 0 <= F && ae[Y] !== Me[F]; )
              F--;
          for (; 1 <= Y && 0 <= F; Y--, F--)
            if (ae[Y] !== Me[F]) {
              if (Y !== 1 || F !== 1)
                do
                  if (Y--, F--, 0 > F || ae[Y] !== Me[F]) {
                    var qe = `
` + ae[Y].replace(
                      " at new ",
                      " at "
                    );
                    return f.displayName && qe.includes("<anonymous>") && (qe = qe.replace("<anonymous>", f.displayName)), typeof f == "function" && Re.set(f, qe), qe;
                  }
                while (1 <= Y && 0 <= F);
              break;
            }
        }
      } finally {
        Ve = !1, W.H = D, l(), Error.prepareStackTrace = S;
      }
      return ae = (ae = f ? f.displayName || f.name : "") ? a(ae) : "", typeof f == "function" && Re.set(f, ae), ae;
    }
    function h(f) {
      if (f == null) return "";
      if (typeof f == "function") {
        var $ = f.prototype;
        return c(
          f,
          !(!$ || !$.isReactComponent)
        );
      }
      if (typeof f == "string") return a(f);
      switch (f) {
        case j:
          return a("Suspense");
        case w:
          return a("SuspenseList");
      }
      if (typeof f == "object")
        switch (f.$$typeof) {
          case y:
            return f = c(f.render, !1), f;
          case k:
            return h(f.type);
          case U:
            $ = f._payload, f = f._init;
            try {
              return h(f($));
            } catch {
            }
        }
      return "";
    }
    function p() {
      var f = W.A;
      return f === null ? null : f.getOwner();
    }
    function _(f) {
      if (z.call(f, "key")) {
        var $ = Object.getOwnPropertyDescriptor(f, "key").get;
        if ($ && $.isReactWarning) return !1;
      }
      return f.key !== void 0;
    }
    function g(f, $) {
      function S() {
        T || (T = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          $
        ));
      }
      S.isReactWarning = !0, Object.defineProperty(f, "key", {
        get: S,
        configurable: !0
      });
    }
    function i() {
      var f = e(this.type);
      return M[f] || (M[f] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), f = this.props.ref, f !== void 0 ? f : null;
    }
    function d(f, $, S, D, J, Y) {
      return S = Y.ref, f = {
        $$typeof: O,
        type: f,
        key: $,
        props: Y,
        _owner: J
      }, (S !== void 0 ? S : null) !== null ? Object.defineProperty(f, "ref", {
        enumerable: !1,
        get: i
      }) : Object.defineProperty(f, "ref", { enumerable: !1, value: null }), f._store = {}, Object.defineProperty(f._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(f, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.freeze && (Object.freeze(f.props), Object.freeze(f)), f;
    }
    function u(f, $, S, D, J, Y) {
      if (typeof f == "string" || typeof f == "function" || f === C || f === N || f === V || f === j || f === w || f === L || typeof f == "object" && f !== null && (f.$$typeof === U || f.$$typeof === k || f.$$typeof === de || f.$$typeof === ie || f.$$typeof === y || f.$$typeof === te || f.getModuleId !== void 0)) {
        var F = $.children;
        if (F !== void 0)
          if (D)
            if (Q(F)) {
              for (D = 0; D < F.length; D++)
                x(F[D], f);
              Object.freeze && Object.freeze(F);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else x(F, f);
      } else
        F = "", (f === void 0 || typeof f == "object" && f !== null && Object.keys(f).length === 0) && (F += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), f === null ? D = "null" : Q(f) ? D = "array" : f !== void 0 && f.$$typeof === O ? (D = "<" + (e(f.type) || "Unknown") + " />", F = " Did you accidentally export a JSX literal instead of a component?") : D = typeof f, console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          D,
          F
        );
      if (z.call($, "key")) {
        F = e(f);
        var ke = Object.keys($).filter(function(ae) {
          return ae !== "key";
        });
        D = 0 < ke.length ? "{key: someKey, " + ke.join(": ..., ") + ": ...}" : "{key: someKey}", B[F + D] || (ke = 0 < ke.length ? "{" + ke.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          D,
          F,
          ke,
          F
        ), B[F + D] = !0);
      }
      if (F = null, S !== void 0 && (n(S), F = "" + S), _($) && (n($.key), F = "" + $.key), "key" in $) {
        S = {};
        for (var Fe in $)
          Fe !== "key" && (S[Fe] = $[Fe]);
      } else S = $;
      return F && g(
        S,
        typeof f == "function" ? f.displayName || f.name || "Unknown" : f
      ), d(f, F, Y, J, p(), S);
    }
    function x(f, $) {
      if (typeof f == "object" && f && f.$$typeof !== Nt) {
        if (Q(f))
          for (var S = 0; S < f.length; S++) {
            var D = f[S];
            m(D) && v(D, $);
          }
        else if (m(f))
          f._store && (f._store.validated = 1);
        else if (f === null || typeof f != "object" ? S = null : (S = P && f[P] || f["@@iterator"], S = typeof S == "function" ? S : null), typeof S == "function" && S !== f.entries && (S = S.call(f), S !== f))
          for (; !(f = S.next()).done; )
            m(f.value) && v(f.value, $);
      }
    }
    function m(f) {
      return typeof f == "object" && f !== null && f.$$typeof === O;
    }
    function v(f, $) {
      if (f._store && !f._store.validated && f.key == null && (f._store.validated = 1, $ = b($), !X[$])) {
        X[$] = !0;
        var S = "";
        f && f._owner != null && f._owner !== p() && (S = null, typeof f._owner.tag == "number" ? S = e(f._owner.type) : typeof f._owner.name == "string" && (S = f._owner.name), S = " It was passed a child from " + S + ".");
        var D = W.getCurrentStack;
        W.getCurrentStack = function() {
          var J = h(f.type);
          return D && (J += D() || ""), J;
        }, console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          $,
          S
        ), W.getCurrentStack = D;
      }
    }
    function b(f) {
      var $ = "", S = p();
      return S && (S = e(S.type)) && ($ = `

Check the render method of \`` + S + "`."), $ || (f = e(f)) && ($ = `

Check the top-level render call using <` + f + ">."), $;
    }
    var E = fe, O = Symbol.for("react.transitional.element"), H = Symbol.for("react.portal"), C = Symbol.for("react.fragment"), V = Symbol.for("react.strict_mode"), N = Symbol.for("react.profiler"), ie = Symbol.for("react.consumer"), de = Symbol.for("react.context"), y = Symbol.for("react.forward_ref"), j = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), k = Symbol.for("react.memo"), U = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), P = Symbol.iterator, R = Symbol.for("react.client.reference"), W = E.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, z = Object.prototype.hasOwnProperty, q = Object.assign, te = Symbol.for("react.client.reference"), Q = Array.isArray, Z = 0, le, ee, oe, he, me, ot, st;
    o.__reactDisabledLog = !0;
    var He, it, Ve = !1, Re = new (typeof WeakMap == "function" ? WeakMap : Map)(), Nt = Symbol.for("react.client.reference"), T, M = {}, B = {}, X = {};
    Ue.Fragment = C, Ue.jsx = function(f, $, S, D, J) {
      return u(f, $, S, !1, D, J);
    }, Ue.jsxs = function(f, $, S, D, J) {
      return u(f, $, S, !0, D, J);
    };
  }()), Ue;
}
var En;
function ko() {
  return En || (En = 1, process.env.NODE_ENV === "production" ? at.exports = vo() : at.exports = yo()), at.exports;
}
var r = ko();
const Td = ({ isSelected: e, ...t }) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ...t,
    children: [
      /* @__PURE__ */ r.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "15",
          height: "15",
          rx: "3",
          style: {
            stroke: e ? "#00997D" : "var(--fiken-color-black-500)"
          },
          strokeWidth: "2",
          strokeLinejoin: "round"
        }
      ),
      e && /* @__PURE__ */ r.jsx("path", { d: "M5 8L8 11L12 5", stroke: "#00997D", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ]
  }
), _o = "_circle_1voe1_1", Cn = {
  circle: _o
}, dn = ({
  style: e = { color: "var(--fiken-color-grey-900)", backgroundColor: "var(--fiken-color-grey-300)" },
  variant: t = HTMLSpanElement,
  children: n
}) => {
  const o = { ...e };
  return t === HTMLSpanElement ? /* @__PURE__ */ r.jsx("span", { className: Cn.circle, style: o, children: /* @__PURE__ */ r.jsx("span", { children: n }) }) : /* @__PURE__ */ r.jsx("div", { className: Cn.circle, style: o, children: /* @__PURE__ */ r.jsx("span", { children: n }) });
}, jo = () => /* @__PURE__ */ r.jsx(dn, { style: { backgroundColor: "var(--fiken-color-green-700)" }, children: /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "12", viewBox: "0 0 16 12", fill: "none", children: /* @__PURE__ */ r.jsx(
  "path",
  {
    d: "M2 6.60606L5.57447 10L14 2",
    stroke: "var(--fiken-color-green-300)",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) }) }), Md = () => /* @__PURE__ */ r.jsx(dn, { style: { backgroundColor: "var(--fiken-color-purple-900)" }, children: /* @__PURE__ */ r.jsxs("svg", { width: "18", height: "4", viewBox: "0 0 18 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ r.jsx("circle", { cx: "2", cy: "2", r: "2", fill: "#EFEAFF" }),
  /* @__PURE__ */ r.jsx("circle", { cx: "9", cy: "2", r: "2", fill: "#EFEAFF" }),
  /* @__PURE__ */ r.jsx("circle", { cx: "16", cy: "2", r: "2", fill: "#EFEAFF" })
] }) }), Od = () => /* @__PURE__ */ r.jsx(dn, { style: { backgroundColor: "var(--fiken-color-purple-800)" }, children: /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ r.jsx("path", { d: "M1.20825 5H8.79159", stroke: "#EFEAFF" }),
      /* @__PURE__ */ r.jsx("path", { d: "M5 1.2085L8.79167 5.00016L5 8.79183", stroke: "#EFEAFF" })
    ]
  }
) }), wo = "_copyAnchorLink_v0f1b_1", bo = {
  copyAnchorLink: wo
}, So = (e) => {
  if (e.animate !== void 0) {
    const t = {
      opacity: 0,
      transform: "scale(0)",
      backgroundColor: "#0a0b0c"
    }, n = {
      opacity: 1,
      backgroundColor: "#eeeeee",
      transform: "scale(2)"
    };
    e.animate([t, n], { duration: 600 }).play();
  }
}, $o = async (e) => {
  const t = document.createElement("textarea"), n = t.style;
  n.position = "fixed", n.top = "0", n.left = "0", n.width = "2em", n.height = "2em", n.padding = "0", n.border = "none", n.outline = "none", n.boxShadow = "none", n.background = "transparent", t.value = e, document.body.appendChild(t), t.focus(), t.select();
  try {
    document.execCommand("copy");
  } catch (o) {
    console.error("Document.execCommand() fungerte ikke", o);
  }
  document.body.removeChild(t);
}, Eo = async (e) => {
  const { clipboard: t } = navigator;
  t !== void 0 ? await t.writeText(e) : await $o(e);
}, Co = async (e) => {
  const { origin: t, pathname: n } = window.location, o = `${t}${n}${e}`;
  await Eo(o);
}, ur = ({ children: e, id: t, closest: n }) => {
  const s = Ae(() => ({
    width: "40px",
    height: "40px",
    borderRadius: "100%",
    position: "absolute",
    right: 0
  }), []), l = ({ target: a }) => {
    var g;
    const c = a.firstElementChild, h = new URLSearchParams(window.location.search), p = h === null ? "" : `?${h}`;
    So(c);
    const _ = ((g = c.closest(n)) == null ? void 0 : g.dataset.hash) ?? t;
    _ !== void 0 && Co(_.startsWith("#") ? `${p}${_}` : `${p}#${_}`);
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("span", { style: { display: "block", paddingRight: "1rem", maxWidth: "calc(100% - 40px" }, children: e }),
    /* @__PURE__ */ r.jsx("span", { className: bo.copyAnchorLink, onClick: l, children: /* @__PURE__ */ r.jsx("span", { style: s }) })
  ] });
}, dr = (e) => {
  const t = document.querySelector(e);
  if (t !== null) {
    const n = t.getBoundingClientRect().top, { marginTop: o } = window.getComputedStyle(t), s = n + window.scrollY + -parseInt(o), l = document.querySelector("header");
    if (l !== null) {
      const { height: a } = window.getComputedStyle(l);
      window.scrollTo({ top: s - parseInt(a), behavior: "smooth" });
    } else
      window.scrollTo({ top: s, behavior: "smooth" });
  }
};
var Lo = typeof global == "object" && global && global.Object === Object && global, To = typeof self == "object" && self && self.Object === Object && self, fr = Lo || To || Function("return this")(), kt = fr.Symbol, hr = Object.prototype, Mo = hr.hasOwnProperty, Oo = hr.toString, ze = kt ? kt.toStringTag : void 0;
function Io(e) {
  var t = Mo.call(e, ze), n = e[ze];
  try {
    e[ze] = void 0;
    var o = !0;
  } catch {
  }
  var s = Oo.call(e);
  return o && (t ? e[ze] = n : delete e[ze]), s;
}
var No = Object.prototype, Ao = No.toString;
function Ro(e) {
  return Ao.call(e);
}
var Fo = "[object Null]", Bo = "[object Undefined]", Ln = kt ? kt.toStringTag : void 0;
function Do(e) {
  return e == null ? e === void 0 ? Bo : Fo : Ln && Ln in Object(e) ? Io(e) : Ro(e);
}
function Po(e) {
  return e != null && typeof e == "object";
}
var Ho = "[object Symbol]";
function Vo(e) {
  return typeof e == "symbol" || Po(e) && Do(e) == Ho;
}
var qo = /\s/;
function Wo(e) {
  for (var t = e.length; t-- && qo.test(e.charAt(t)); )
    ;
  return t;
}
var Uo = /^\s+/;
function zo(e) {
  return e && e.slice(0, Wo(e) + 1).replace(Uo, "");
}
function _t(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Tn = NaN, Go = /^[-+]0x[0-9a-f]+$/i, Yo = /^0b[01]+$/i, Ko = /^0o[0-7]+$/i, Xo = parseInt;
function Mn(e) {
  if (typeof e == "number")
    return e;
  if (Vo(e))
    return Tn;
  if (_t(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = _t(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = zo(e);
  var n = Yo.test(e);
  return n || Ko.test(e) ? Xo(e.slice(2), n ? 2 : 8) : Go.test(e) ? Tn : +e;
}
var At = function() {
  return fr.Date.now();
}, Zo = "Expected a function", Jo = Math.max, Qo = Math.min;
function es(e, t, n) {
  var o, s, l, a, c, h, p = 0, _ = !1, g = !1, i = !0;
  if (typeof e != "function")
    throw new TypeError(Zo);
  t = Mn(t) || 0, _t(n) && (_ = !!n.leading, g = "maxWait" in n, l = g ? Jo(Mn(n.maxWait) || 0, t) : l, i = "trailing" in n ? !!n.trailing : i);
  function d(C) {
    var V = o, N = s;
    return o = s = void 0, p = C, a = e.apply(N, V), a;
  }
  function u(C) {
    return p = C, c = setTimeout(v, t), _ ? d(C) : a;
  }
  function x(C) {
    var V = C - h, N = C - p, ie = t - V;
    return g ? Qo(ie, l - N) : ie;
  }
  function m(C) {
    var V = C - h, N = C - p;
    return h === void 0 || V >= t || V < 0 || g && N >= l;
  }
  function v() {
    var C = At();
    if (m(C))
      return b(C);
    c = setTimeout(v, x(C));
  }
  function b(C) {
    return c = void 0, i && o ? d(C) : (o = s = void 0, a);
  }
  function E() {
    c !== void 0 && clearTimeout(c), p = 0, o = h = s = c = void 0;
  }
  function O() {
    return c === void 0 ? a : b(At());
  }
  function H() {
    var C = At(), V = m(C);
    if (o = arguments, s = this, h = C, V) {
      if (c === void 0)
        return u(h);
      if (g)
        return clearTimeout(c), c = setTimeout(v, t), d(h);
    }
    return c === void 0 && (c = setTimeout(v, t)), a;
  }
  return H.cancel = E, H.flush = O, H;
}
var ts = "Expected a function";
function ns(e, t, n) {
  var o = !0, s = !0;
  if (typeof e != "function")
    throw new TypeError(ts);
  return _t(n) && (o = "leading" in n ? !0 : o, s = "trailing" in n ? !!n.trailing : s), es(e, t, {
    leading: o,
    maxWait: t,
    trailing: s
  });
}
const rs = Object.freeze({
  xxLarge: 1400,
  xLarge: 1200,
  large: 992,
  medium: 768,
  small: 576
}), ve = fe.createContext(null), os = {
  width: 0,
  clipPathHeight: 45,
  isDesktop: !1,
  isMobile: !1,
  isTablet: !1,
  isReady: !1,
  breakpoint: rs
}, Id = ({ children: e }) => {
  const t = (l, a) => ({ ...l, ...a }), [n, o] = cr(t, os), s = ns(
    ({ target: l }) => {
      const { innerWidth: a, location: c } = l, h = a < 640, p = a >= 640 && a < 1140, _ = a >= 1140, g = Math.min(Math.round(a * 45 / 1440), 45);
      o({ width: a, isMobile: h, isTablet: p, isDesktop: _, isReady: !0, clipPathHeight: g, location: c });
    },
    100,
    { leading: !0 }
  );
  return G(() => (s({ target: window }), window.addEventListener("resize", s), () => {
    window.removeEventListener("resize", s);
  }), [e]), /* @__PURE__ */ r.jsx(ve.Provider, { value: n, children: e });
}, pr = (e = void 0) => {
  const t = xe(ve).location;
  G(() => {
    if (t !== void 0) {
      const { hash: n } = t;
      if (n.length > 0) {
        const o = `[data-hash="${n.replace(/#/, "")}"]`, s = document.querySelector(o);
        let l = 0;
        const a = setInterval(() => {
          s !== null && (dr(o), e !== void 0 && e.callback(o), clearInterval(a)), l > 10 && clearInterval(a), l++;
        }, 100);
        return () => clearInterval(a);
      }
    }
  }, [t]);
}, ss = "_articleContent_15myx_1", is = "_topHeader_15myx_4", ls = "_column_15myx_24", ct = {
  articleContent: ss,
  topHeader: is,
  column: ls
}, as = "_innledning_zoblk_1", On = {
  innledning: as
};
function In(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Nn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? In(Object(n), !0).forEach(function(o) {
      cs(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : In(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function cs(e, t, n) {
  return (t = us(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function us(e) {
  var t = ds(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ds(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function jt(e) {
  return e._type === "span" && "text" in e && typeof e.text == "string" && (typeof e.marks > "u" || Array.isArray(e.marks) && e.marks.every((t) => typeof t == "string"));
}
function mr(e) {
  return (
    // A block doesn't _have_ to be named 'block' - to differentiate between
    // allowed child types and marks, one might name them differently
    typeof e._type == "string" && // Toolkit-types like nested spans are @-prefixed
    e._type[0] !== "@" && // `markDefs` isn't _required_ per say, but if it's there, it needs to be an array
    (!("markDefs" in e) || !e.markDefs || Array.isArray(e.markDefs) && // Every mark definition needs to have an `_key` to be mappable in child spans
    e.markDefs.every((t) => typeof t._key == "string")) && // `children` is required and needs to be an array
    "children" in e && Array.isArray(e.children) && // All children are objects with `_type` (usually spans, but can contain other stuff)
    e.children.every((t) => typeof t == "object" && "_type" in t)
  );
}
function gr(e) {
  return mr(e) && "listItem" in e && typeof e.listItem == "string" && (typeof e.level > "u" || typeof e.level == "number");
}
function xr(e) {
  return e._type === "@list";
}
function vr(e) {
  return e._type === "@span";
}
function yr(e) {
  return e._type === "@text";
}
const An = ["strong", "em", "code", "underline", "strike-through"];
function fs(e, t, n) {
  if (!jt(e) || !e.marks) return [];
  if (!e.marks.length) return [];
  const o = e.marks.slice(), s = {};
  return o.forEach((l) => {
    s[l] = 1;
    for (let a = t + 1; a < n.length; a++) {
      const c = n[a];
      if (c && jt(c) && Array.isArray(c.marks) && c.marks.indexOf(l) !== -1) s[l]++;
      else break;
    }
  }), o.sort((l, a) => hs(s, l, a));
}
function hs(e, t, n) {
  const o = e[t], s = e[n];
  if (o !== s) return s - o;
  const l = An.indexOf(t), a = An.indexOf(n);
  return l !== a ? l - a : t.localeCompare(n);
}
function ps(e) {
  var t, n;
  const {
    children: o
  } = e, s = (t = e.markDefs) != null ? t : [];
  if (!o || !o.length) return [];
  const l = o.map(fs), a = {
    _type: "@span",
    children: [],
    markType: "<unknown>"
  };
  let c = [a];
  for (let h = 0; h < o.length; h++) {
    const p = o[h];
    if (!p) continue;
    const _ = l[h] || [];
    let g = 1;
    if (c.length > 1) for (g; g < c.length; g++) {
      const d = ((n = c[g]) == null ? void 0 : n.markKey) || "", u = _.indexOf(d);
      if (u === -1) break;
      _.splice(u, 1);
    }
    c = c.slice(0, g);
    let i = c[c.length - 1];
    if (i) {
      for (const d of _) {
        const u = s == null ? void 0 : s.find((v) => v._key === d), x = u ? u._type : d, m = {
          _type: "@span",
          _key: p._key,
          children: [],
          markDef: u,
          markType: x,
          markKey: d
        };
        i.children.push(m), c.push(m), i = m;
      }
      if (jt(p)) {
        const d = p.text.split(`
`);
        for (let u = d.length; u-- > 1; ) d.splice(u, 0, `
`);
        i.children = i.children.concat(d.map((u) => ({
          _type: "@text",
          text: u
        })));
      } else i.children = i.children.concat(p);
    }
  }
  return a.children;
}
function ms(e, t) {
  const n = [];
  let o;
  for (let s = 0; s < e.length; s++) {
    const l = e[s];
    if (l) {
      if (!gr(l)) {
        n.push(l), o = void 0;
        continue;
      }
      if (!o) {
        o = ut(l, s, t), n.push(o);
        continue;
      }
      if (gs(l, o)) {
        o.children.push(l);
        continue;
      }
      if ((l.level || 1) > o.level) {
        const a = ut(l, s, t);
        if (t === "html") {
          const c = o.children[o.children.length - 1], h = Nn(Nn({}, c), {}, {
            children: [...c.children, a]
          });
          o.children[o.children.length - 1] = h;
        } else o.children.push(a);
        o = a;
        continue;
      }
      if ((l.level || 1) < o.level) {
        const a = n[n.length - 1], c = a && Qt(a, l);
        if (c) {
          o = c, o.children.push(l);
          continue;
        }
        o = ut(l, s, t), n.push(o);
        continue;
      }
      if (l.listItem !== o.listItem) {
        const a = n[n.length - 1], c = a && Qt(a, {
          level: l.level || 1
        });
        if (c && c.listItem === l.listItem) {
          o = c, o.children.push(l);
          continue;
        } else {
          o = ut(l, s, t), n.push(o);
          continue;
        }
      }
      console.warn("Unknown state encountered for block", l), n.push(l);
    }
  }
  return n;
}
function gs(e, t) {
  return (e.level || 1) === t.level && e.listItem === t.listItem;
}
function ut(e, t, n) {
  return {
    _type: "@list",
    _key: `${e._key || `${t}`}-parent`,
    mode: n,
    level: e.level || 1,
    listItem: e.listItem,
    children: [e]
  };
}
function Qt(e, t) {
  const n = t.level || 1, o = t.listItem || "normal", s = typeof t.listItem == "string";
  if (xr(e) && (e.level || 1) === n && s && (e.listItem || "normal") === o) return e;
  if (!("children" in e)) return;
  const l = e.children[e.children.length - 1];
  return l && !jt(l) ? Qt(l, t) : void 0;
}
function kr(e) {
  let t = "";
  return e.children.forEach((n) => {
    yr(n) ? t += n.text : vr(n) && (t += kr(n));
  }), t;
}
const xs = "html", vs = ["block", "list", "listItem", "marks", "types"], ys = ["listItem"], ks = ["_key"];
function Rn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function ge(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rn(Object(n), !0).forEach(function(o) {
      _s(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rn(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function _s(e, t, n) {
  return (t = js(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function js(e) {
  var t = ws(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ws(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function en(e, t) {
  if (e == null) return {};
  var n, o, s = bs(e, t);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (o = 0; o < l.length; o++) n = l[o], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (s[n] = e[n]);
  }
  return s;
}
function bs(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.includes(o)) continue;
    n[o] = e[o];
  }
  return n;
}
const Ss = {
  number: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("ol", {
    children: e
  }),
  bullet: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("ul", {
    children: e
  })
}, $s = ({
  children: e
}) => /* @__PURE__ */ r.jsx("li", {
  children: e
}), Es = ({
  children: e,
  value: t
}) => /* @__PURE__ */ r.jsx("a", {
  href: t == null ? void 0 : t.href,
  children: e
}), Cs = {
  textDecoration: "underline"
}, Ls = {
  em: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("em", {
    children: e
  }),
  strong: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("strong", {
    children: e
  }),
  code: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("code", {
    children: e
  }),
  underline: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("span", {
    style: Cs,
    children: e
  }),
  "strike-through": ({
    children: e
  }) => /* @__PURE__ */ r.jsx("del", {
    children: e
  }),
  link: Es
}, nt = (e, t) => `[@portabletext/react] Unknown ${e}, specify a component for it in the \`components.${t}\` prop`, _r = (e) => nt(`block type "${e}"`, "types"), Ts = (e) => nt(`mark type "${e}"`, "marks"), Ms = (e) => nt(`block style "${e}"`, "block"), Os = (e) => nt(`list style "${e}"`, "list"), Is = (e) => nt(`list item style "${e}"`, "listItem");
function Ns(e) {
  console.warn(e);
}
const Fn = {
  display: "none"
}, As = ({
  value: e,
  isInline: t
}) => {
  const n = _r(e._type);
  return t ? /* @__PURE__ */ r.jsx("span", {
    style: Fn,
    children: n
  }) : /* @__PURE__ */ r.jsx("div", {
    style: Fn,
    children: n
  });
}, Rs = ({
  markType: e,
  children: t
}) => /* @__PURE__ */ r.jsx("span", {
  className: `unknown__pt__mark__${e}`,
  children: t
}), Fs = ({
  children: e
}) => /* @__PURE__ */ r.jsx("p", {
  children: e
}), Bs = ({
  children: e
}) => /* @__PURE__ */ r.jsx("ul", {
  children: e
}), Ds = ({
  children: e
}) => /* @__PURE__ */ r.jsx("li", {
  children: e
}), Ps = () => /* @__PURE__ */ r.jsx("br", {}), Hs = {
  normal: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("p", {
    children: e
  }),
  blockquote: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("blockquote", {
    children: e
  }),
  h1: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("h1", {
    children: e
  }),
  h2: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("h2", {
    children: e
  }),
  h3: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("h3", {
    children: e
  }),
  h4: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("h4", {
    children: e
  }),
  h5: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("h5", {
    children: e
  }),
  h6: ({
    children: e
  }) => /* @__PURE__ */ r.jsx("h6", {
    children: e
  })
}, Bn = {
  types: {},
  block: Hs,
  marks: Ls,
  list: Ss,
  listItem: $s,
  hardBreak: Ps,
  unknownType: As,
  unknownMark: Rs,
  unknownList: Bs,
  unknownListItem: Ds,
  unknownBlockStyle: Fs
};
function Vs(e, t) {
  const {
    block: n,
    list: o,
    listItem: s,
    marks: l,
    types: a
  } = t, c = en(t, vs);
  return ge(ge({}, e), {}, {
    block: Ge(e, t, "block"),
    list: Ge(e, t, "list"),
    listItem: Ge(e, t, "listItem"),
    marks: Ge(e, t, "marks"),
    types: Ge(e, t, "types")
  }, c);
}
function Ge(e, t, n) {
  const o = t[n], s = e[n];
  return typeof o == "function" || o && typeof s == "function" ? o : o ? ge(ge({}, s), o) : s;
}
function jr({
  value: e,
  components: t,
  listNestingMode: n,
  onMissingComponent: o = Ns
}) {
  const s = o || Ws, l = Array.isArray(e) ? e : [e], a = ms(l, n || xs), c = Ae(() => t ? Vs(Bn, t) : Bn, [t]), h = Ae(() => qs(c, s), [c, s]), p = a.map((_, g) => h({
    node: _,
    index: g,
    isInline: !1,
    renderNode: h
  }));
  return /* @__PURE__ */ r.jsx(r.Fragment, {
    children: p
  });
}
const qs = (e, t) => {
  function n(g) {
    const {
      node: i,
      index: d,
      isInline: u
    } = g, x = i._key || `node-${d}`;
    return xr(i) ? l(i, d, x) : gr(i) ? s(i, d, x) : vr(i) ? a(i, d, x) : o(i) ? _(i, d, x, u) : mr(i) ? c(i, d, x, u) : yr(i) ? h(i, x) : p(i, d, x, u);
  }
  function o(g) {
    return g._type in e.types;
  }
  function s(g, i, d) {
    const u = Dn({
      node: g,
      index: i,
      isInline: !1,
      renderNode: n
    }), x = e.listItem, m = (typeof x == "function" ? x : x[g.listItem]) || e.unknownListItem;
    if (m === e.unknownListItem) {
      const b = g.listItem || "bullet";
      t(Is(b), {
        type: b,
        nodeType: "listItemStyle"
      });
    }
    let v = u.children;
    if (g.style && g.style !== "normal") {
      const {
        listItem: b
      } = g, E = en(g, ys);
      v = n({
        node: E,
        index: i,
        isInline: !1
      });
    }
    return /* @__PURE__ */ r.jsx(m, {
      value: g,
      index: i,
      isInline: !1,
      renderNode: n,
      children: v
    }, d);
  }
  function l(g, i, d) {
    const u = g.children.map((v, b) => n({
      node: v._key ? v : ge(ge({}, v), {}, {
        _key: `li-${i}-${b}`
      }),
      index: b,
      isInline: !1
    })), x = e.list, m = (typeof x == "function" ? x : x[g.listItem]) || e.unknownList;
    if (m === e.unknownList) {
      const v = g.listItem || "bullet";
      t(Os(v), {
        nodeType: "listStyle",
        type: v
      });
    }
    return /* @__PURE__ */ r.jsx(m, {
      value: g,
      index: i,
      isInline: !1,
      renderNode: n,
      children: u
    }, d);
  }
  function a(g, i, d) {
    const {
      markDef: u,
      markType: x,
      markKey: m
    } = g, v = e.marks[x] || e.unknownMark, b = g.children.map((E, O) => n({
      node: E,
      index: O,
      isInline: !0
    }));
    return v === e.unknownMark && t(Ts(x), {
      nodeType: "mark",
      type: x
    }), /* @__PURE__ */ r.jsx(v, {
      text: kr(g),
      value: u,
      markType: x,
      markKey: m,
      renderNode: n,
      children: b
    }, d);
  }
  function c(g, i, d, u) {
    const x = Dn({
      node: g,
      index: i,
      isInline: u,
      renderNode: n
    }), {
      _key: m
    } = x, v = en(x, ks), b = v.node.style || "normal", E = (typeof e.block == "function" ? e.block : e.block[b]) || e.unknownBlockStyle;
    return E === e.unknownBlockStyle && t(Ms(b), {
      nodeType: "blockStyle",
      type: b
    }), /* @__PURE__ */ r.jsx(E, ge(ge({}, v), {}, {
      value: v.node,
      renderNode: n
    }), d);
  }
  function h(g, i) {
    if (g.text === `
`) {
      const d = e.hardBreak;
      return d ? /* @__PURE__ */ r.jsx(d, {}, i) : `
`;
    }
    return g.text;
  }
  function p(g, i, d, u) {
    const x = {
      value: g,
      isInline: u,
      index: i,
      renderNode: n
    };
    t(_r(g._type), {
      nodeType: "block",
      type: g._type
    });
    const m = e.unknownType;
    return /* @__PURE__ */ r.jsx(m, ge({}, x), d);
  }
  function _(g, i, d, u) {
    const x = {
      value: g,
      isInline: u,
      index: i,
      renderNode: n
    }, m = e.types[g._type];
    return m ? /* @__PURE__ */ r.jsx(m, ge({}, x), d) : null;
  }
  return n;
};
function Dn(e) {
  const {
    node: t,
    index: n,
    isInline: o,
    renderNode: s
  } = e, l = ps(t).map((a, c) => s({
    node: a,
    isInline: !0,
    index: c,
    renderNode: s
  }));
  return {
    _key: t._key || `block-${n}`,
    children: l,
    index: n,
    isInline: o,
    node: t
  };
}
function Ws() {
}
const Us = "_video_14nma_1", zs = "_caption_14nma_10", Pn = {
  video: Us,
  caption: zs
}, Gs = Object.freeze({
  youtube_url_match: /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/
}), Ys = (e) => {
  const t = Gs.youtube_url_match, n = e.match(t);
  if (n === null)
    throw new Error(`Could not find Youtube id in ${e}`);
  return n[1];
}, Ks = ({ url: e, width: t, height: n, className: o, tittel: s }) => {
  const l = Ys(e);
  return /* @__PURE__ */ r.jsx("div", { className: o, style: { width: t, height: n }, children: /* @__PURE__ */ r.jsx(
    "iframe",
    {
      title: s,
      width: "100%",
      height: "100%",
      style: { border: "none" },
      src: `https://www.youtube.com/embed/${l}?autoplay=0&amp;mute=0&amp;controls=1`,
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      referrerPolicy: "strict-origin-when-cross-origin",
      allowFullScreen: !0
    }
  ) });
}, Xs = {
  maxWidth: 736
}, Zs = ({ url: e, caption: t, tittel: n }) => {
  const o = K(null), [s, l] = A({ height: 0, width: 0 });
  return G(() => {
    const a = o.current;
    if (a != null && typeof window < "u") {
      const c = a.getBoundingClientRect(), { maxWidth: h } = Xs, p = window.innerWidth - 32, _ = c.width === 0 ? p : c.width, g = Math.min(_, h), i = Math.round(g * (9 / 16));
      l({ height: i, width: g });
    }
  }, [o, t]), /* @__PURE__ */ r.jsxs("section", { ref: o, children: [
    /* @__PURE__ */ r.jsx(
      Ks,
      {
        url: e,
        tittel: n,
        className: Pn.video,
        width: `${s.width}px`,
        height: `${s.height}px`
      }
    ),
    /* @__PURE__ */ r.jsx("div", { className: Pn.caption, children: t != null && /* @__PURE__ */ r.jsx(Te, { blocks: t }) })
  ] });
}, Js = "_slikGrDuFrem_5sg7k_1", Qs = "_background_5sg7k_6", wr = {
  slikGrDuFrem: Js,
  background: Qs
}, ei = "_detailsDisclosure_2qs9k_1", ti = "_primary_2qs9k_71", ni = "_plain_2qs9k_72", ri = "_styled_2qs9k_110", Hn = {
  detailsDisclosure: ei,
  "move-down": "_move-down_2qs9k_1",
  primary: ti,
  plain: ni,
  styled: ri
}, ce = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
  INVERTED_TOP: "INVERTED_TOP",
  INVERTED_BOTTOM: "INVERTED_BOTTOM",
  VERTICAL: "VERTICAL",
  INVERTED_VERTICAL: "INVERTED_VERTICAL"
}, oi = ({
  edge: e = ce.TOP,
  curveHeight: t = 45,
  element: n
}) => {
  const o = n.clientWidth, s = n.clientHeight, l = e === void 0 ? 0 : t, a = e === void 0 ? 0 : o / 2, c = s - l;
  let h = `inset('${o}px,${s}px')`;
  return e === ce.TOP ? h = `path('M0,${t} C${a},0 ${a},0 ${o},${t} L${o},${s} L0,${s} L0,${t} Z')` : e === ce.BOTTOM ? h = `path('M0,0 L${o},0 L${o},${c} C${a},${s} ${a},${s} 0,${c} L0,0 Z')` : e === ce.VERTICAL && (h = `path('M0,${t}C${a},0 ${a},0 ${o},${t} L${o},${c} C${a},${s} ${a},${s}  0,${c}L0,${t} Z')`), e === ce.TOP ? h = `path('M0,${t} C${a},0 ${a},0 ${o},${t} L${o},${s} L0,${s} L0,${t} Z')` : e === ce.BOTTOM ? h = `path('M0,0 L${o},0 L${o},${c} C${a},${s} ${a},${s} 0,${c} L0,0 Z')` : e === ce.INVERTED_TOP ? h = `path('M0,0C${a},${t} ${a},${t} ${o},0L${o},${s}L0,${s}L0,0Z')` : e === ce.VERTICAL ? h = `path('M0,${t}C${a},0 ${a},0 ${o},${t} L${o},${c} C${a},${s} ${a},${s}  0,${c}L0,${t} Z')` : e === ce.INVERTED_VERTICAL && (h = `path('M${o},0C${a},${t} ${a},${t} 0,0L0,${c}C${a},${s} ${a},${s} ${o},${c}L${o},0Z')`), h;
}, br = ({
  children: e,
  edge: t = ce.TOP,
  curveHeight: n = 45,
  redraw: o = !1,
  refElement: s
}) => {
  const [l, a] = A("");
  return G(() => {
    const c = () => {
      const { current: h } = s;
      h != null && a(oi({ edge: t, curveHeight: n, element: h }));
    };
    return c(), window.addEventListener("resize", c), () => window.removeEventListener("resize", c);
  }, [e, o, n]), l;
}, Sr = ({
  children: e,
  edge: t = ce.TOP,
  curveHeight: n = 45,
  redraw: o = !1,
  backgroundColor: s = "white",
  style: l = {},
  className: a = "",
  ...c
}) => {
  const h = K(null), p = br({ children: e, curveHeight: n, edge: t, redraw: o, refElement: h });
  return /* @__PURE__ */ r.jsx("div", { ...c, className: a, style: { backgroundColor: s, ...l, clipPath: p }, ref: h, children: e });
}, si = ({ onClick: e, children: t, curveHeight: n, ref: o }) => {
  const s = br({
    children: t,
    edge: ce.BOTTOM,
    curveHeight: n,
    refElement: o,
    redraw: !0
  });
  return /* @__PURE__ */ r.jsx("summary", { onClick: e, ref: o, style: { clipPath: s }, children: t });
}, ii = (e, t, n) => Math.max(e, Math.min(t, n)), li = ({ children: e, attributes: t }) => (t == null ? void 0 : t["data-hash"]) !== void 0 ? /* @__PURE__ */ r.jsx(ur, { closest: "details", children: e }) : /* @__PURE__ */ r.jsx(r.Fragment, { children: e }), $r = (e) => {
  const { marginTop: t, marginBottom: n } = window.getComputedStyle(e), o = parseFloat(t) + parseFloat(n);
  return Math.ceil(e.offsetHeight + o);
}, rt = ({ children: e }) => {
  let t = 0;
  for (const n of [...e])
    t += $r(n);
  return t;
}, ai = ({
  isOpened: e,
  variant: t,
  setToggling: n,
  setIsOpened: o,
  setHeight: s,
  summary: l,
  details: a
}) => {
  if (l !== null && a !== null) {
    e || o(!0);
    const c = () => {
      if (t == tn.styled) {
        const [m, v] = e ? ["var(--fiken-color-green-500)", "none"] : ["none", "var(--fiken-color-green-500)"], b = { background: [m, v] }, E = { duration: e ? 250 : 300, fill: "forwards" }, O = new KeyframeEffect(l, b, E);
        new Animation(O, document.timeline).play();
      }
      const { offsetHeight: h } = l, p = rt(a);
      s(e ? h : p);
      const [_, g] = e ? [p, h] : [h, p], i = { height: [`${_}px`, `${g}px`] }, d = {
        duration: 300,
        easing: "ease-out"
      }, u = new KeyframeEffect(a, i, d), x = new Animation(u, document.timeline);
      x.play(), x.onfinish = () => {
        n(!1), e && o(!1), l.blur();
      }, x.oncancel = () => {
        n(!1);
      };
    };
    window.requestAnimationFrame(c);
  }
}, ci = ({ details: e, summary: t, isOpened: n }, o) => {
  const [s, l] = A();
  return Pe(() => {
    const c = setTimeout(() => {
      if (e != null && t !== null) {
        const h = rt(e), { offsetHeight: p } = t;
        l(n ? h : p);
      }
    }, n ? 100 : 0);
    return () => clearTimeout(c);
  }, o), [s, l];
}, tn = Object.freeze({
  primary: "primary",
  plain: "plain",
  styled: "styled"
}), fn = ({
  summary: e,
  children: t,
  isExpanded: n,
  viewportWidth: o,
  variant: s = tn.primary,
  className: l = "",
  style: a = {},
  attributes: c = {},
  ...h
}) => {
  const p = K(null), _ = K(null), [g, i] = A(n), [d, u] = A(!1);
  G(() => {
    n && i(!0);
  }, [n]);
  const [x, m] = ci(
    {
      summary: _.current,
      details: p.current,
      isOpened: g
    },
    [o, t, g]
  ), v = (b) => {
    const { current: E } = _;
    E != null && typeof E.animate < "u" && (b.preventDefault(), d || (u(!0), ai({
      summary: _.current,
      details: p.current,
      setToggling: u,
      variant: s,
      setHeight: m,
      setIsOpened: i,
      isOpened: g
    })));
  };
  return /* @__PURE__ */ r.jsxs(
    "details",
    {
      ...h,
      ...c,
      open: g,
      className: `${Hn.detailsDisclosure} ${Hn[s]} ${l}`,
      style: { ...a, height: x },
      ref: p,
      children: [
        s === tn.styled ? /* @__PURE__ */ r.jsx(si, { curveHeight: ii(12, 2.5 * o / 100, 15), onClick: v, ref: _, children: e }) : /* @__PURE__ */ r.jsx("summary", { onClick: v, ref: _, children: /* @__PURE__ */ r.jsx(li, { attributes: c, children: e }) }),
        /* @__PURE__ */ r.jsx("div", { children: t })
      ]
    }
  );
}, ui = ({ left: e }) => e === 0 ? /* @__PURE__ */ r.jsx(r.Fragment, {}) : /* @__PURE__ */ r.jsx("div", { className: wr.background, style: { left: `-${e}px` } }), di = ({ punkter: e }) => {
  const t = K(null), [n, o] = A(0), { width: s } = xe(ve);
  return G(() => {
    const { current: l } = t;
    l != null && setTimeout(() => {
      const { left: a } = l.getBoundingClientRect();
      o(a);
    }, 50);
  }, []), /* @__PURE__ */ r.jsxs("section", { className: wr.slikGrDuFrem, ref: t, children: [
    /* @__PURE__ */ r.jsx(ui, { left: n }),
    /* @__PURE__ */ r.jsx("h2", { children: "Slik går du frem" }),
    /* @__PURE__ */ r.jsx("ul", { children: e.map((l, a) => {
      const c = /* @__PURE__ */ r.jsx("p", { children: l.overskrift });
      return /* @__PURE__ */ r.jsxs("li", { children: [
        /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx("span", { children: a + 1 }) }),
        /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(fn, { summary: c, isExpanded: !1, viewportWidth: s, children: /* @__PURE__ */ r.jsx(Te, { blocks: l.punkt }) }) })
      ] }, a);
    }) })
  ] });
}, Er = ({ location: e, content: t }) => Ae(() => {
  const n = new URLSearchParams(e == null ? void 0 : e.search).get("q");
  return CSS.highlights && n !== null ? (typeof t == "string" ? t : JSON.stringify(t)).toLowerCase().toLowerCase().indexOf(n.toLowerCase()) !== -1 : !1;
}, [t, e]), Vn = ({
  overskrift: e,
  innhold: t,
  variant: n = "primary",
  _key: o,
  ekspandert: s = !1
}) => {
  const { width: l, location: a } = xe(ve), c = (a == null ? void 0 : a.hash) ?? "", h = Er({ location: a, content: t });
  return /* @__PURE__ */ r.jsx(
    fn,
    {
      variant: n,
      summary: e,
      isExpanded: s || c.replace(/#/, "") === o || h,
      viewportWidth: l,
      attributes: { "data-hash": o },
      children: /* @__PURE__ */ r.jsx(Te, { blocks: t })
    }
  );
}, fi = "_vanligeSporsmal_xv0s8_1", hi = {
  vanligeSporsmal: fi
}, pi = ({ svar: e, sporsmal: t, _key: n }) => {
  const { width: o, location: s } = xe(ve), l = Er({ location: s, content: e }), a = (s == null ? void 0 : s.hash) ?? "";
  return /* @__PURE__ */ r.jsx(
    fn,
    {
      summary: t,
      isExpanded: a.replace(/#/, "") === n || l,
      viewportWidth: o,
      attributes: { "data-hash": n },
      children: /* @__PURE__ */ r.jsx(Te, { blocks: e })
    }
  );
}, mi = ({ sporsmalOgSvar: e }) => /* @__PURE__ */ r.jsx("ul", { className: hi.vanligeSporsmal, children: e.map(({ svar: t, sporsmal: n, _key: o }, s) => /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(pi, { svar: t, sporsmal: n, _key: o }) }, s)) }), gi = "_dyplenkeReference_1iz8k_1", xi = {
  dyplenkeReference: gi
}, ne = ({
  href: e,
  children: t,
  className: n = "",
  style: o = {},
  ...s
}) => /* @__PURE__ */ r.jsx("a", { ...s, href: `${e}`, "data-col": e, target: "_blank", rel: "noreferrer", className: n, style: o, children: t }), vi = ({ value: e }) => {
  if (e === void 0) return /* @__PURE__ */ r.jsx(r.Fragment, {});
  const { lenke: t, fra: n, til: o, mellomMeny: s } = e;
  return /* @__PURE__ */ r.jsxs(ne, { href: `https://fiken.no/til/${t}`, className: xi.dyplenkeReference, children: [
    /* @__PURE__ */ r.jsx("span", { children: n }),
    s.map((l) => /* @__PURE__ */ r.jsxs("span", { style: { textWrap: "wrap" }, children: [
      " → ",
      l
    ] }, l)),
    /* @__PURE__ */ r.jsxs("span", { children: [
      " → ",
      o
    ] })
  ] });
}, yi = ({ epost: e }) => /* @__PURE__ */ r.jsx("a", { href: `mailto:${e}`, children: e }), ki = "_root_qss0l_1", _i = {
  root: ki
}, ji = ({ textContent: e }) => /* @__PURE__ */ r.jsx("span", { className: _i.root, children: e }), wi = "_root_9mydz_1", bi = {
  root: wi
}, Si = ({ textContent: e }) => /* @__PURE__ */ r.jsx("span", { className: bi.root, children: e }), $i = "_fil_oszin_1", Ei = {
  fil: $i
}, Ci = (e) => {
  const { navn: t, url: n } = e;
  return /* @__PURE__ */ r.jsx("div", { className: Ei.fil, children: /* @__PURE__ */ r.jsxs("a", { href: n, download: !0, children: [
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15",
              stroke: "#0539F7",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ r.jsx("path", { d: "M7 10L12 15L17 10", stroke: "#0539F7", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
          /* @__PURE__ */ r.jsx("path", { d: "M12 15V3", stroke: "#0539F7", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
        ]
      }
    ),
    /* @__PURE__ */ r.jsxs("span", { children: [
      "Last ned filen ",
      t !== void 0 ? ":" : "",
      " ",
      t
    ] })
  ] }) });
}, Li = "_uthev_1otcs_1", Ti = {
  uthev: Li
}, Mi = "_button_7xuxa_1", Oi = "_ctaLight_7xuxa_18", Ii = "_secondary_7xuxa_18", Ni = "_primaryLight_7xuxa_18", Ai = "_primary_7xuxa_18", Ri = "_cta_7xuxa_18", Fi = "_danger_7xuxa_38", Bi = "_lg_7xuxa_75", Di = "_sm_7xuxa_80", Pi = "_capsule_7xuxa_85", Hi = "_rectangle_7xuxa_89", re = {
  button: Mi,
  ctaLight: Oi,
  secondary: Ii,
  primaryLight: Ni,
  primary: Ai,
  cta: Ri,
  danger: Fi,
  lg: Bi,
  sm: Di,
  capsule: Pi,
  rectangle: Hi
}, be = {
  PRIMARY: "primary",
  CTA: "cta",
  CTA_LIGHT: "ctaLight",
  PRIMARY_LIGHT: "primaryLight",
  DANGER: "danger",
  WARNING: "warning",
  SECONDARY: "secondary"
}, ye = {
  LG: "lg",
  SM: "sm",
  xs: "xs"
}, Cr = ({
  type: e = "button",
  variant: t = be.PRIMARY,
  size: n = ye.SM,
  disabled: o = !1,
  children: s,
  onClick: l,
  rounded: a = !0,
  onEffect: c = void 0,
  style: h = {}
}) => {
  const p = a ? "capsule" : "rectangle", _ = K(null);
  return G(() => {
    const { current: g } = _;
    g !== null && c !== void 0 && c(g.getBoundingClientRect());
  }), /* @__PURE__ */ r.jsx(
    "button",
    {
      style: h,
      ref: _,
      type: e,
      onClick: l,
      disabled: o,
      className: `${re.button} ${re[t]} ${re[n]} ${re[p]}`,
      children: s
    }
  );
}, Vi = ({
  children: e,
  url: t,
  rounded: n = !1,
  size: o = ye.SM,
  variant: s = be.PRIMARY
}) => {
  const l = n ? "capsule" : "rectangle";
  return /* @__PURE__ */ r.jsx(
    "a",
    {
      href: t,
      className: `${re.button} ${re[o]} ${re[s]} ${re[l]}`,
      target: "_blank",
      rel: "noreferrer",
      children: e
    }
  );
};
var xt = { exports: {} }, qi = xt.exports, qn;
function Wi() {
  return qn || (qn = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(qi, function() {
      function n() {
        return n = Object.assign || function(y) {
          for (var j = 1; j < arguments.length; j++) {
            var w = arguments[j];
            for (var k in w)
              Object.prototype.hasOwnProperty.call(w, k) && (y[k] = w[k]);
          }
          return y;
        }, n.apply(this, arguments);
      }
      function o(y, j) {
        if (y) {
          if (typeof y == "string") return s(y, j);
          var w = Object.prototype.toString.call(y).slice(8, -1);
          if (w === "Object" && y.constructor && (w = y.constructor.name), w === "Map" || w === "Set") return Array.from(y);
          if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w)) return s(y, j);
        }
      }
      function s(y, j) {
        (j == null || j > y.length) && (j = y.length);
        for (var w = 0, k = new Array(j); w < j; w++) k[w] = y[w];
        return k;
      }
      function l(y, j) {
        var w = typeof Symbol < "u" && y[Symbol.iterator] || y["@@iterator"];
        if (w) return (w = w.call(y)).next.bind(w);
        if (Array.isArray(y) || (w = o(y)) || j) {
          w && (y = w);
          var k = 0;
          return function() {
            return k >= y.length ? {
              done: !0
            } : {
              done: !1,
              value: y[k++]
            };
          };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var a = "image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg";
      function c(y) {
        var j = y.split("-"), w = j[1], k = j[2], U = j[3];
        if (!w || !k || !U)
          throw new Error("Malformed asset _ref '" + y + `'. Expected an id like "` + a + '".');
        var L = k.split("x"), P = L[0], R = L[1], W = +P, z = +R, q = isFinite(W) && isFinite(z);
        if (!q)
          throw new Error("Malformed asset _ref '" + y + `'. Expected an id like "` + a + '".');
        return {
          id: w,
          width: W,
          height: z,
          format: U
        };
      }
      var h = function(j) {
        var w = j;
        return w ? typeof w._ref == "string" : !1;
      }, p = function(j) {
        var w = j;
        return w ? typeof w._id == "string" : !1;
      }, _ = function(j) {
        var w = j;
        return w && w.asset ? typeof w.asset.url == "string" : !1;
      };
      function g(y) {
        if (!y)
          return null;
        var j;
        if (typeof y == "string" && i(y))
          j = {
            asset: {
              _ref: d(y)
            }
          };
        else if (typeof y == "string")
          j = {
            asset: {
              _ref: y
            }
          };
        else if (h(y))
          j = {
            asset: y
          };
        else if (p(y))
          j = {
            asset: {
              _ref: y._id || ""
            }
          };
        else if (_(y))
          j = {
            asset: {
              _ref: d(y.asset.url)
            }
          };
        else if (typeof y.asset == "object")
          j = n({}, y);
        else
          return null;
        var w = y;
        return w.crop && (j.crop = w.crop), w.hotspot && (j.hotspot = w.hotspot), u(j);
      }
      function i(y) {
        return /^https?:\/\//.test("" + y);
      }
      function d(y) {
        var j = y.split("/").slice(-1);
        return ("image-" + j[0]).replace(/\.([a-z]+)$/, "-$1");
      }
      function u(y) {
        if (y.crop && y.hotspot)
          return y;
        var j = n({}, y);
        return j.crop || (j.crop = {
          left: 0,
          top: 0,
          bottom: 0,
          right: 0
        }), j.hotspot || (j.hotspot = {
          x: 0.5,
          y: 0.5,
          height: 1,
          width: 1
        }), j;
      }
      var x = [["width", "w"], ["height", "h"], ["format", "fm"], ["download", "dl"], ["blur", "blur"], ["sharpen", "sharp"], ["invert", "invert"], ["orientation", "or"], ["minHeight", "min-h"], ["maxHeight", "max-h"], ["minWidth", "min-w"], ["maxWidth", "max-w"], ["quality", "q"], ["fit", "fit"], ["crop", "crop"], ["saturation", "sat"], ["auto", "auto"], ["dpr", "dpr"], ["pad", "pad"], ["frame", "frame"]];
      function m(y) {
        var j = n({}, y || {}), w = j.source;
        delete j.source;
        var k = g(w);
        if (!k)
          throw new Error("Unable to resolve image URL from source (" + JSON.stringify(w) + ")");
        var U = k.asset._ref || k.asset._id || "", L = c(U), P = Math.round(k.crop.left * L.width), R = Math.round(k.crop.top * L.height), W = {
          left: P,
          top: R,
          width: Math.round(L.width - k.crop.right * L.width - P),
          height: Math.round(L.height - k.crop.bottom * L.height - R)
        }, z = k.hotspot.height * L.height / 2, q = k.hotspot.width * L.width / 2, te = k.hotspot.x * L.width, Q = k.hotspot.y * L.height, Z = {
          left: te - q,
          top: Q - z,
          right: te + q,
          bottom: Q + z
        };
        return j.rect || j.focalPoint || j.ignoreImageParams || j.crop || (j = n({}, j, b({
          crop: W,
          hotspot: Z
        }, j))), v(n({}, j, {
          asset: L
        }));
      }
      function v(y) {
        var j = (y.baseUrl || "https://cdn.sanity.io").replace(/\/+$/, ""), w = y.vanityName ? "/" + y.vanityName : "", k = y.asset.id + "-" + y.asset.width + "x" + y.asset.height + "." + y.asset.format + w, U = j + "/images/" + y.projectId + "/" + y.dataset + "/" + k, L = [];
        if (y.rect) {
          var P = y.rect, R = P.left, W = P.top, z = P.width, q = P.height, te = R !== 0 || W !== 0 || q !== y.asset.height || z !== y.asset.width;
          te && L.push("rect=" + R + "," + W + "," + z + "," + q);
        }
        y.bg && L.push("bg=" + y.bg), y.focalPoint && (L.push("fp-x=" + y.focalPoint.x), L.push("fp-y=" + y.focalPoint.y));
        var Q = [y.flipHorizontal && "h", y.flipVertical && "v"].filter(Boolean).join("");
        return Q && L.push("flip=" + Q), x.forEach(function(Z) {
          var le = Z[0], ee = Z[1];
          typeof y[le] < "u" ? L.push(ee + "=" + encodeURIComponent(y[le])) : typeof y[ee] < "u" && L.push(ee + "=" + encodeURIComponent(y[ee]));
        }), L.length === 0 ? U : U + "?" + L.join("&");
      }
      function b(y, j) {
        var w, k = j.width, U = j.height;
        if (!(k && U))
          return {
            width: k,
            height: U,
            rect: y.crop
          };
        var L = y.crop, P = y.hotspot, R = k / U, W = L.width / L.height;
        if (W > R) {
          var z = Math.round(L.height), q = Math.round(z * R), te = Math.max(0, Math.round(L.top)), Q = Math.round((P.right - P.left) / 2 + P.left), Z = Math.max(0, Math.round(Q - q / 2));
          Z < L.left ? Z = L.left : Z + q > L.left + L.width && (Z = L.left + L.width - q), w = {
            left: Z,
            top: te,
            width: q,
            height: z
          };
        } else {
          var le = L.width, ee = Math.round(le / R), oe = Math.max(0, Math.round(L.left)), he = Math.round((P.bottom - P.top) / 2 + P.top), me = Math.max(0, Math.round(he - ee / 2));
          me < L.top ? me = L.top : me + ee > L.top + L.height && (me = L.top + L.height - ee), w = {
            left: oe,
            top: me,
            width: le,
            height: ee
          };
        }
        return {
          width: k,
          height: U,
          rect: w
        };
      }
      var E = ["clip", "crop", "fill", "fillmax", "max", "scale", "min"], O = ["top", "bottom", "left", "right", "center", "focalpoint", "entropy"], H = ["format"];
      function C(y) {
        return y && "config" in y ? typeof y.config == "function" : !1;
      }
      function V(y) {
        return y && "clientConfig" in y ? typeof y.clientConfig == "object" : !1;
      }
      function N(y) {
        for (var j = x, w = l(j), k; !(k = w()).done; ) {
          var U = k.value, L = U[0], P = U[1];
          if (y === L || y === P)
            return L;
        }
        return y;
      }
      function ie(y) {
        if (C(y)) {
          var j = y.config(), w = j.apiHost, k = j.projectId, U = j.dataset, L = w || "https://api.sanity.io";
          return new de(null, {
            baseUrl: L.replace(/^https:\/\/api\./, "https://cdn."),
            projectId: k,
            dataset: U
          });
        }
        if (V(y)) {
          var P = y.clientConfig, R = P.apiHost, W = P.projectId, z = P.dataset, q = R || "https://api.sanity.io";
          return new de(null, {
            baseUrl: q.replace(/^https:\/\/api\./, "https://cdn."),
            projectId: W,
            dataset: z
          });
        }
        return new de(null, y || {});
      }
      var de = /* @__PURE__ */ function() {
        function y(w, k) {
          this.options = void 0, this.options = w ? n({}, w.options || {}, k || {}) : n({}, k || {});
        }
        var j = y.prototype;
        return j.withOptions = function(k) {
          var U = k.baseUrl || this.options.baseUrl, L = {
            baseUrl: U
          };
          for (var P in k)
            if (k.hasOwnProperty(P)) {
              var R = N(P);
              L[R] = k[P];
            }
          return new y(this, n({
            baseUrl: U
          }, L));
        }, j.image = function(k) {
          return this.withOptions({
            source: k
          });
        }, j.dataset = function(k) {
          return this.withOptions({
            dataset: k
          });
        }, j.projectId = function(k) {
          return this.withOptions({
            projectId: k
          });
        }, j.bg = function(k) {
          return this.withOptions({
            bg: k
          });
        }, j.dpr = function(k) {
          return this.withOptions(k && k !== 1 ? {
            dpr: k
          } : {});
        }, j.width = function(k) {
          return this.withOptions({
            width: k
          });
        }, j.height = function(k) {
          return this.withOptions({
            height: k
          });
        }, j.focalPoint = function(k, U) {
          return this.withOptions({
            focalPoint: {
              x: k,
              y: U
            }
          });
        }, j.maxWidth = function(k) {
          return this.withOptions({
            maxWidth: k
          });
        }, j.minWidth = function(k) {
          return this.withOptions({
            minWidth: k
          });
        }, j.maxHeight = function(k) {
          return this.withOptions({
            maxHeight: k
          });
        }, j.minHeight = function(k) {
          return this.withOptions({
            minHeight: k
          });
        }, j.size = function(k, U) {
          return this.withOptions({
            width: k,
            height: U
          });
        }, j.blur = function(k) {
          return this.withOptions({
            blur: k
          });
        }, j.sharpen = function(k) {
          return this.withOptions({
            sharpen: k
          });
        }, j.rect = function(k, U, L, P) {
          return this.withOptions({
            rect: {
              left: k,
              top: U,
              width: L,
              height: P
            }
          });
        }, j.format = function(k) {
          return this.withOptions({
            format: k
          });
        }, j.invert = function(k) {
          return this.withOptions({
            invert: k
          });
        }, j.orientation = function(k) {
          return this.withOptions({
            orientation: k
          });
        }, j.quality = function(k) {
          return this.withOptions({
            quality: k
          });
        }, j.forceDownload = function(k) {
          return this.withOptions({
            download: k
          });
        }, j.flipHorizontal = function() {
          return this.withOptions({
            flipHorizontal: !0
          });
        }, j.flipVertical = function() {
          return this.withOptions({
            flipVertical: !0
          });
        }, j.ignoreImageParams = function() {
          return this.withOptions({
            ignoreImageParams: !0
          });
        }, j.fit = function(k) {
          if (E.indexOf(k) === -1)
            throw new Error('Invalid fit mode "' + k + '"');
          return this.withOptions({
            fit: k
          });
        }, j.crop = function(k) {
          if (O.indexOf(k) === -1)
            throw new Error('Invalid crop mode "' + k + '"');
          return this.withOptions({
            crop: k
          });
        }, j.saturation = function(k) {
          return this.withOptions({
            saturation: k
          });
        }, j.auto = function(k) {
          if (H.indexOf(k) === -1)
            throw new Error('Invalid auto mode "' + k + '"');
          return this.withOptions({
            auto: k
          });
        }, j.pad = function(k) {
          return this.withOptions({
            pad: k
          });
        }, j.vanityName = function(k) {
          return this.withOptions({
            vanityName: k
          });
        }, j.frame = function(k) {
          if (k !== 1)
            throw new Error('Invalid frame value "' + k + '"');
          return this.withOptions({
            frame: k
          });
        }, j.url = function() {
          return m(this.options);
        }, j.toString = function() {
          return this.url();
        }, y;
      }();
      return ie;
    });
  }(xt)), xt.exports;
}
var Ui = /* @__PURE__ */ Wi();
const Lr = /* @__PURE__ */ xo(Ui), hn = {
  sanity: {
    projectId: "6s1hmfif",
    dataset: "production"
  }
}, pn = (e) => e !== void 0 ? Lr({ ...hn.sanity }).image(e).url() : "", zi = (e) => {
  const { overskrift: t, innhold: n, figur: o, knapp: s } = e;
  return /* @__PURE__ */ r.jsxs("section", { className: Ti.uthev, children: [
    o !== void 0 ? /* @__PURE__ */ r.jsx("figure", { children: /* @__PURE__ */ r.jsx(
      "img",
      {
        width: 236.77,
        height: 177.58,
        src: pn(o.asset),
        alt: (o == null ? void 0 : o.altText) ?? "Figur",
        "aria-hidden": "true"
      }
    ) }) : null,
    /* @__PURE__ */ r.jsxs("div", { children: [
      /* @__PURE__ */ r.jsx("h3", { children: t }),
      /* @__PURE__ */ r.jsx(Te, { blocks: n }),
      s !== void 0 ? /* @__PURE__ */ r.jsx(
        Vi,
        {
          rounded: !0,
          size: ye.LG,
          variant: be.PRIMARY,
          url: s.lenke,
          children: s.tittel
        }
      ) : null
    ] })
  ] });
}, Gi = ({ href: e, children: t }) => /* @__PURE__ */ r.jsx(ne, { href: e, children: t }), Nd = Object.freeze({
  ord: "ord",
  starteEnk: "starteEnk",
  starteAs: "starteAs",
  hjelpeartikkel: "hjelpeartikkel"
}), dt = Object.freeze({
  forklarer: "ordLink",
  starteEnk: "starteEnk.link",
  starteAs: "starteAs.link",
  webinar: "webinarLenke",
  hjelpeartikkel: "hjelpeartikkel.link"
}), Tr = ({ slug: e, _type: t, children: n }) => {
  const { current: o } = e;
  return t === dt.forklarer ? /* @__PURE__ */ r.jsx("a", { href: `https://fiken.no/forklarer/${o}`, children: n }) : t === dt.starteEnk ? /* @__PURE__ */ r.jsx("a", { href: `https://fiken.no/starte-enkeltpersonforetak/${o}`, children: n }) : t === dt.starteAs ? /* @__PURE__ */ r.jsx("a", { href: `https://fiken.no/starte-as/${o}`, children: n }) : t === dt.webinar ? /* @__PURE__ */ r.jsx("a", { href: `https://webomar.fiken.no/${o}`, children: n }) : /* @__PURE__ */ r.jsx("a", { href: `https://hjelp.fiken.no/${o}`, children: n });
}, Ye = ({ value: e }) => {
  const { slug: t, _type: n, tittel: o } = e;
  return /* @__PURE__ */ r.jsx(Tr, { slug: t, _type: n, children: o });
}, Ke = ({
  value: e,
  children: t
}) => {
  if (e === void 0) return /* @__PURE__ */ r.jsx(r.Fragment, {});
  const { slug: n, _type: o } = e;
  return /* @__PURE__ */ r.jsx(Tr, { slug: n, _type: o, children: t });
}, Yi = "_highlight_1v2ot_1", Ki = {
  highlight: Yi
}, Xi = ({ children: e }) => /* @__PURE__ */ r.jsx("p", { className: Ki.highlight, children: e }), Zi = "_bilde_1b6h4_1", Ji = "_svg_1b6h4_42", Qi = "_caption_1b6h4_56", nn = {
  bilde: Zi,
  svg: Ji,
  caption: Qi
}, el = (e) => {
  if (e === void 0 || e.length !== 2)
    return;
  const t = e[1];
  return t > 2500 ? 30 : t > 2e3 ? 50 : t > 1e3 ? 70 : void 0;
}, ft = (e, { width: t, quality: n, dpr: o = 3, format: s }) => {
  let l = Lr({ ...hn.sanity }).image(e).fit("clip").dpr(o);
  return s !== void 0 ? l = l.format(s) : l = l.auto("format"), t !== void 0 && (l = l.width(t)), n !== void 0 && (l = l.quality(n)), l.url();
}, tl = (e) => {
  const t = e.split("-");
  if (t.length === 4)
    return t[2].split("x").map((o) => parseInt(o));
}, rn = (e, t) => {
  const n = tl(e._ref), [o, s] = n, l = Math.min(t, o), a = s * l / o;
  return [l, a];
}, nl = "_bildeDialog_1ek44_1", rl = {
  bildeDialog: nl
}, ol = "_dialog_q4lxj_1", sl = "_center_q4lxj_24", il = "_bottomRight_q4lxj_28", ll = "_form_q4lxj_36", al = "_visualMedia_q4lxj_51", cl = "_search_q4lxj_71", Rt = {
  dialog: ol,
  center: sl,
  bottomRight: il,
  form: ll,
  visualMedia: al,
  search: cl
}, ul = "_x_3ygtj_1", dl = {
  x: ul
}, fl = ({ onClick: e, className: t = "", ...n }) => /* @__PURE__ */ r.jsx("button", { type: "button", "aria-label": "Lukk", ...n, className: `${dl.x} ${t}`, onClick: e, children: /* @__PURE__ */ r.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ r.jsxs("g", { stroke: "#5239BA", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [
  /* @__PURE__ */ r.jsx("path", { d: "M18 6L6 18" }),
  /* @__PURE__ */ r.jsx("path", { d: "M6 6L18 18" })
] }) }) }), hl = "_avbrytButton_kr076_1", pl = {
  avbrytButton: hl
}, ml = ({
  onClick: e,
  className: t = "",
  style: n = {},
  ...o
}) => /* @__PURE__ */ r.jsx("button", { type: "button", ...o, className: `${pl.avbrytButton} ${t}`, style: n, onClick: e, children: "Avbryt" }), vt = {
  form: "form",
  visualMedia: "visualMedia",
  search: "search"
}, Ft = {
  center: "center",
  bottomRight: "bottomRight"
}, gl = {
  Escape: "Escape"
}, xl = ({
  render: e,
  onclose: t,
  freezeBody: n = !0,
  type: o = vt.form,
  position: s = Ft.center,
  className: l = "",
  style: a = {},
  ...c
}) => {
  const h = K(null), [p, _] = A(!0), [g, i] = A(
    s === Ft.center ? { top: 20, opacity: 0 } : { bottom: -20, opacity: 0 }
  ), [d, u] = A(0);
  G(() => {
    s === Ft.center ? i({ top: p ? 0 : 20, opacity: p ? 1 : 0 }) : i({ bottom: p ? 0 : -20, opacity: p ? 1 : 0 }), u(p ? 1 : 0);
    const { style: v } = document.body;
    return n && (v.overflow = p ? "hidden" : "auto", v.touchAction = p ? "none" : "auto"), () => {
      v.overflow = "auto", v.touchAction = "auto";
    };
  }, [p]), G(() => {
    const v = (b) => {
      const { code: E } = b;
      E === gl.Escape && m();
    };
    return document.addEventListener("keydown", v, { passive: !0 }), () => document.removeEventListener("keydown", v);
  }, []);
  const x = ({ target: v }) => {
    const { current: b } = h;
    o === vt.visualMedia && b !== null && b == v && m();
  }, m = () => {
    _(!1), setTimeout(t, 300);
  };
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      onClick: x,
      className: `${Rt.dialog} ${Rt[o]} ${Rt[s]} ${l}`,
      style: { opacity: d, ...a },
      role: "dialog",
      "aria-modal": "true",
      ref: h,
      ...c,
      children: /* @__PURE__ */ r.jsxs("div", { style: g, role: "document", children: [
        o !== vt.search ? /* @__PURE__ */ r.jsx(fl, { onClick: m }) : /* @__PURE__ */ r.jsx(ml, { onClick: m }),
        e(m)
      ] })
    }
  );
}, vl = "_spinnerRoot_pu8qu_1", yl = "_spinner_pu8qu_1", kl = "_spin_pu8qu_1", _l = "_dark_pu8qu_22", jl = "_light_pu8qu_27", wl = "_ctaLight_pu8qu_32", bl = "_ctaDark_pu8qu_37", Bt = {
  spinnerRoot: vl,
  spinner: yl,
  spin: kl,
  dark: _l,
  light: jl,
  ctaLight: wl,
  ctaDark: bl
}, Be = {
  DARK: "dark",
  LIGHT: "light",
  CTA_DARK: "ctaDark",
  CTA_LIGHT: "ctaLight"
}, Lt = ({
  isVisible: e,
  diameter: t = 100,
  style: n = {},
  color: o = Be.LIGHT,
  children: s
}) => {
  const l = { height: `${t}px`, width: `${t}px`, ...n };
  return /* @__PURE__ */ r.jsxs("span", { className: Bt.spinnerRoot, children: [
    s !== void 0 ? /* @__PURE__ */ r.jsx("span", { style: { visibility: e ? "hidden" : "visible" }, children: s }) : null,
    e ? /* @__PURE__ */ r.jsx("i", { className: `${Bt.spinner} ${Bt[o]}`, style: l }) : null
  ] });
};
function Sl({ params: e, onclose: t }) {
  const { asset: n, altText: o } = e, [s, l] = rn(n, window.document.documentElement.clientWidth - 40), a = n._ref.endsWith("svg"), [c, h] = A(!1);
  return /* @__PURE__ */ r.jsx(
    xl,
    {
      type: vt.visualMedia,
      onclose: t,
      render: () => /* @__PURE__ */ r.jsxs("div", { className: rl.bildeDialog, style: { width: s, height: l }, children: [
        c ? null : /* @__PURE__ */ r.jsx(
          Lt,
          {
            isVisible: !0,
            diameter: 50,
            style: { borderColor: Be.LIGHT },
            color: Be.DARK
          }
        ),
        /* @__PURE__ */ r.jsx("figure", { style: { margin: 0, background: a ? "var(--fiken-color-white-500)" : "transparent" }, children: /* @__PURE__ */ r.jsx(
          Mr,
          {
            altText: o,
            dpr2x: 3,
            asset: n,
            width: s,
            height: l,
            onLoad: () => {
              h(!0);
            }
          }
        ) })
      ] })
    }
  );
}
function $l({ onClick: e }) {
  return /* @__PURE__ */ r.jsx("button", { type: "button", onClick: e, "aria-hidden": "true", tabIndex: -1, children: /* @__PURE__ */ r.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      version: "1.1",
      xmlSpace: "preserve",
      style: {
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        fill: "white"
      },
      children: /* @__PURE__ */ r.jsx("g", { transform: "matrix(1.8581e-17,-0.303451,0.3047,1.86575e-17,22.7419,26.0835)", children: /* @__PURE__ */ r.jsx("path", { d: "M55.713,1.465L75.977,1.465C80.469,1.465 83.057,-1.123 83.057,-5.615L83.057,-25.879C83.057,-28.174 81.348,-29.932 79.004,-29.932C76.709,-29.932 75,-28.223 75,-25.879L75,-24.609L75.928,-11.035L66.748,-20.801L55.371,-32.275C54.639,-33.057 53.613,-33.447 52.539,-33.447C50.049,-33.447 48.193,-31.787 48.193,-29.297C48.193,-28.125 48.633,-27.051 49.414,-26.27L60.791,-14.893L70.606,-5.713L56.982,-6.592L55.713,-6.592C53.369,-6.592 51.611,-4.932 51.563,-2.588C51.563,-0.244 53.369,1.465 55.713,1.465ZM13.818,-40.576C16.162,-40.576 17.822,-42.285 17.822,-44.629L17.822,-45.898L16.943,-59.473L26.123,-49.707L37.451,-38.232C38.232,-37.451 39.209,-37.061 40.283,-37.061C42.773,-37.061 44.629,-38.721 44.629,-41.211C44.629,-42.383 44.238,-43.457 43.408,-44.238L32.031,-55.615L22.217,-64.795L35.889,-63.916L37.109,-63.916C39.453,-63.916 41.26,-65.576 41.26,-67.92C41.26,-70.264 39.453,-71.973 37.109,-71.973L16.846,-71.973C12.354,-71.973 9.766,-69.385 9.766,-64.893L9.766,-44.629C9.766,-42.334 11.475,-40.576 13.818,-40.576Z" }) })
    }
  ) });
}
const El = ({ asset: e, altText: t, width: n, height: o, dpr2x: s, style: l, onLoad: a }) => {
  const c = K(null);
  if (G(() => {
    const { current: h } = c;
    a !== void 0 && h !== null && (h.onload = a);
  }, [c, a]), e != null) {
    const h = t !== "" && t !== void 0 ? { alt: t } : { role: "presentation" }, p = el([n, o]);
    return /* @__PURE__ */ r.jsx(
      "img",
      {
        ref: c,
        width: n,
        height: o,
        loading: "lazy",
        srcSet: `
             ${ft(e, { width: n, quality: p, dpr: 1, format: "webp" })} 1x,
             ${ft(e, { width: n, quality: p, dpr: s, format: "webp" })} 2x,
             ${ft(e, { width: n, quality: p, dpr: 3, format: "webp" })} 3x`,
        src: ft(e, { width: n, quality: p, dpr: 2, format: "jpg" }),
        ...h,
        style: l
      }
    );
  }
  return /* @__PURE__ */ r.jsx(r.Fragment, {});
}, Cl = ({ caption: e }) => /* @__PURE__ */ r.jsx("figcaption", { className: nn.caption, children: e }), Mr = ({
  asset: e,
  height: t,
  width: n,
  altText: o,
  dpr2x: s,
  style: l = { borderColor: "transparent" },
  onLoad: a = void 0
}) => /* @__PURE__ */ r.jsx(r.Fragment, { children: e._ref.endsWith("svg") ? /* @__PURE__ */ r.jsx("img", { src: pn(e), alt: o, style: { width: n, height: t, background: "transparent" } }) : /* @__PURE__ */ r.jsx(
  El,
  {
    style: l,
    asset: e,
    altText: o,
    height: t,
    width: n,
    dpr2x: s,
    onLoad: a
  }
) }), ht = (e) => {
  const n = K(null), [o, s] = A(!1), { caption: l, asset: a } = e, { isMobile: c, width: h } = xe(ve), p = a._ref.endsWith("svg"), [_, g] = rn(a, Math.min(h, 736)), [i, d] = A({ width: _, height: g });
  G(() => {
    const { current: x } = n;
    if (x !== null && typeof window < "u") {
      const { clientWidth: m } = x, v = m === 0 ? window.document.documentElement.clientWidth - 40 : m, b = v > 736 ? 736 : v, [E, O] = rn(a, b);
      d({ width: E, height: Math.ceil(O) });
    }
  }, [a, h]);
  const u = () => {
    s(!0);
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("figure", { className: nn.bilde, ref: n, onDoubleClick: u, children: [
      c ? null : /* @__PURE__ */ r.jsx($l, { onClick: () => s(!0) }),
      /* @__PURE__ */ r.jsx(
        "div",
        {
          className: p ? nn.svg : "",
          style: {
            display: "flex",
            justifyContent: "center",
            background: p ? "var(--fiken-color-white-500)" : "var(--fiken-color-grey-200)"
          },
          children: /* @__PURE__ */ r.jsx(
            Mr,
            {
              style: {
                width: _ > i.width ? "100%" : "auto",
                height: i.height
              },
              ...e,
              width: i.width,
              height: i.height,
              dpr2x: 2
            }
          )
        }
      ),
      l !== void 0 && l !== "" && l !== "Bilde" ? /* @__PURE__ */ r.jsx(Cl, { caption: l }) : null
    ] }),
    o ? /* @__PURE__ */ r.jsx(Sl, { onclose: () => s(!1), params: e }) : null
  ] });
}, Ll = "_table_rmlng_1", Tl = {
  table: Ll
}, Ml = ({ value: e }) => {
  const { isMobile: t } = xe(ve), { rows: n } = e;
  return n == null ? /* @__PURE__ */ r.jsx(r.Fragment, {}) : /* @__PURE__ */ r.jsx("div", { className: Tl.table, children: /* @__PURE__ */ r.jsx("table", { children: /* @__PURE__ */ r.jsx("tbody", { children: n.map((o) => /* @__PURE__ */ r.jsx("tr", { style: t ? { whiteSpace: "nowrap" } : {}, children: o.cells !== void 0 ? o.cells.map((s, l) => /* @__PURE__ */ r.jsx("td", { children: s }, l)) : null }, o._key)) }) }) });
}, Ol = ({ children: e }) => /* @__PURE__ */ r.jsx("span", { style: { whiteSpace: "nowrap" }, children: e }), Il = "_copyAnchorH2Link_1qx10_1", Nl = {
  copyAnchorH2Link: Il
}, Or = (e) => e.replace(/æ/g, "ae").replace(/ø/g, "oe").replace(/å/g, "aa").replace(/\s+/g, "-").replace(/[&/\\#,+()$~%.'":*?<>{}]/g, ""), Al = ({ children: e }) => {
  const t = K(null), [n, o] = A();
  return G(() => {
    const { current: s } = t;
    if (s !== null && s.textContent !== null) {
      const l = Or(s.textContent.trim().toLowerCase());
      o(l);
    }
  }, [t]), /* @__PURE__ */ r.jsx("h2", { ref: t, "data-hash": n, className: Nl.copyAnchorH2Link, children: /* @__PURE__ */ r.jsx(ur, { closest: "h2", children: e }) });
}, Rl = fo(document.body), Fl = ({ children: e, parent: t }) => {
  const n = xe(Rl);
  return t !== void 0 ? jn(e, t) : jn(e, n);
}, Bl = ({ offsetWidth: e, offsetHeight: t }, n) => {
  const { clientHeight: l, clientWidth: a } = window.document.documentElement, { top: c, left: h, height: p, width: _ } = n, g = e / 2;
  let i = {};
  if (g + h + _ / 2 < a) {
    const d = h - g + _ / 2;
    d > 0 ? i = { left: d, right: "unset" } : h - 20 > 0 ? i = { left: d + 20, right: "unset" } : h > 0 && (i = { left: 20, right: "unset" });
  } else
    i = { right: 20, left: "unset" };
  return c + t + p + 10 < l ? i = { ...i, top: `${c + p + 10}px`, bottom: "unset" } : i = { ...i, bottom: `${l - c + 10}px`, top: "unset" }, i;
}, Dl = "_verticalTooltip_1rtdj_1", Pl = {
  verticalTooltip: Dl
}, Hl = ({ children: e, content: t }) => {
  const n = K(null), o = K(null), [s, l] = A(!1), [a, c] = A({}), { width: h } = xe(ve);
  G(() => {
    const { current: i } = o;
    if (i !== null && i instanceof HTMLElement && n.current !== null) {
      const d = Bl(i, n.current.getBoundingClientRect());
      c({ position: "fixed", zIndex: 1e4, ...d });
    }
  }, [s, h]);
  const p = Jt(
    (i) => {
      var d, u;
      (u = (d = e == null ? void 0 : e.props) == null ? void 0 : d.onMouseEnter) == null || u.call(d, i), l(!0);
    },
    [e == null ? void 0 : e.props]
  ), _ = Jt(
    (i) => {
      var d, u;
      (u = (d = e == null ? void 0 : e.props) == null ? void 0 : d.onMouseEnter) == null || u.call(d, i), l(!1);
    },
    [e == null ? void 0 : e.props]
  ), g = Ae(() => e ? ho(e, {
    onMouseEnter: p,
    onMouseLeave: _,
    ref: n
  }) : null, [_, _]);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    g,
    s ? /* @__PURE__ */ r.jsx(Fl, { children: /* @__PURE__ */ r.jsx("div", { ref: o, style: { ...a, width: 270 }, className: Pl.verticalTooltip, children: t }) }) : null
  ] });
}, Vl = "_dottedUnderline_14nso_1", ql = {
  dottedUnderline: Vl
}, Wl = ({ children: e, ...t }) => /* @__PURE__ */ r.jsx("span", { className: ql.dottedUnderline, ...t, children: e }), Ul = "_forklaringContent_12mc0_1", zl = {
  forklaringContent: Ul
}, Gl = ({ value: e }) => /* @__PURE__ */ r.jsx("div", { className: zl.forklaringContent, children: /* @__PURE__ */ r.jsx(jr, { value: e, components: Ir }) }), Yl = ({ forklaring: e, children: t }) => {
  const { isMobile: n } = xe(ve);
  return n ? /* @__PURE__ */ r.jsx("span", { children: t }) : /* @__PURE__ */ r.jsx(Hl, { content: /* @__PURE__ */ r.jsx(Gl, { value: e }), children: /* @__PURE__ */ r.jsx(Wl, { children: t }) });
}, Kl = {
  mark: ({ children: e }) => /* @__PURE__ */ r.jsx(Xi, { children: e }),
  h2: (e) => /* @__PURE__ */ r.jsx(Al, { children: e.children })
}, Xl = {
  youtube: ({ value: e }) => {
    const { url: t, caption: n, tittel: o } = e;
    return /* @__PURE__ */ r.jsx(Zs, { tittel: o, url: t, caption: n });
  },
  slikGarDuFrem: ({ value: e }) => /* @__PURE__ */ r.jsx(di, { punkter: e.punkter }),
  image: ({ value: e }) => {
    const { asset: t, caption: n, altText: o } = e;
    return /* @__PURE__ */ r.jsx(ht, { asset: t, caption: n, altText: o });
  },
  bilde: ({ value: e }) => {
    if (e.image) {
      const { image: t, caption: n, altText: o } = e, { asset: s } = t;
      return /* @__PURE__ */ r.jsx(ht, { asset: s, caption: n, altText: o });
    } else if (e.asset) {
      const { asset: t, caption: n, altText: o } = e;
      return /* @__PURE__ */ r.jsx(ht, { asset: t, caption: n, altText: o });
    } else
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  },
  figur: ({ value: e }) => /* @__PURE__ */ r.jsx(ht, { ...e }),
  "hjelpeartikkel.expandCollapse": ({ value: e }) => {
    const { overskrift: t, innhold: n, _key: o, ekspandert: s } = e;
    return t && n ? /* @__PURE__ */ r.jsx(Vn, { innhold: n, overskrift: t, _key: o, ekspandert: s }) : /* @__PURE__ */ r.jsx(r.Fragment, {});
  },
  vanligeSporsmal: ({ value: e }) => {
    const { sporsmalOgSvar: t } = e;
    return /* @__PURE__ */ r.jsx(mi, { sporsmalOgSvar: t });
  },
  "dyplenke.link": (e) => {
    const { value: t } = e;
    return /* @__PURE__ */ r.jsx(vi, { value: t });
  },
  "hjelpeartikkel.link": (e) => /* @__PURE__ */ r.jsx(Ye, { ...e }),
  "starteEnk.link": (e) => /* @__PURE__ */ r.jsx(Ye, { ...e }),
  "starteAs.link": (e) => /* @__PURE__ */ r.jsx(Ye, { ...e }),
  webinarLenke: (e) => /* @__PURE__ */ r.jsx(Ye, { ...e }),
  ordLink: (e) => /* @__PURE__ */ r.jsx(Ye, { ...e }),
  epost: ({ value: e }) => {
    const { epost: t } = e;
    return /* @__PURE__ */ r.jsx(yi, { epost: t });
  },
  knappIBilde: ({ value: e }) => {
    const { knapp: t } = e;
    return /* @__PURE__ */ r.jsx(ji, { textContent: t });
  },
  tekstIBilde: ({ value: e }) => {
    const { tekst: t } = e;
    return /* @__PURE__ */ r.jsx(Si, { textContent: t });
  },
  fil: ({ value: e }) => {
    const { url: t, navn: n } = e.fil;
    return /* @__PURE__ */ r.jsx(Ci, { url: t, navn: n });
  },
  uthev: ({ value: e }) => /* @__PURE__ */ r.jsx(zi, { ...e }),
  expandCollapse: ({ value: e }) => /* @__PURE__ */ r.jsx(Vn, { variant: "styled", ...e }),
  table: ({ value: e }) => /* @__PURE__ */ r.jsx(Ml, { value: e })
}, Zl = {
  "blogg.link": ({ value: e, children: t }) => /* @__PURE__ */ r.jsx(Gi, { href: e.href, children: t }),
  link: ({ value: e, children: t }) => /* @__PURE__ */ r.jsx(ne, { href: e.href, children: t }),
  "hjelpeartikkel.link": (e) => /* @__PURE__ */ r.jsx(Ke, { ...e }),
  "starteAs.link": (e) => /* @__PURE__ */ r.jsx(Ke, { ...e }),
  "starteEnk.link": (e) => /* @__PURE__ */ r.jsx(Ke, { ...e }),
  webinarLenke: (e) => /* @__PURE__ */ r.jsx(Ke, { ...e }),
  ordLink: (e) => /* @__PURE__ */ r.jsx(Ke, { ...e }),
  kontoLenke: ({ value: e, children: t }) => /* @__PURE__ */ r.jsx(ne, { href: e.href, children: t }),
  nowrap: ({ children: e }) => /* @__PURE__ */ r.jsx(Ol, { children: e }),
  forklaring: ({ value: e, children: t }) => /* @__PURE__ */ r.jsx(Yl, { forklaring: e.forklaring, children: t })
}, Ir = {
  types: Xl,
  marks: Zl,
  block: Kl
}, Te = Et(({ blocks: e }) => /* @__PURE__ */ r.jsx(jr, { value: e, components: Ir }));
Te.displayName = "BlockContent";
const Jl = ({ blocks: e }) => typeof e == "string" ? /* @__PURE__ */ r.jsx("header", { className: On.innledning, children: /* @__PURE__ */ r.jsx("p", { children: e }) }) : /* @__PURE__ */ r.jsx("header", { className: On.innledning, children: /* @__PURE__ */ r.jsx(Te, { blocks: e }) }), Ql = "_articleBody_xodhx_1", ea = {
  articleBody: Ql
}, ta = (e, t, n) => {
  if (!CSS.highlights || t == null)
    return;
  if (n.trim() === "") {
    CSS.highlights.clear();
    return;
  }
  const o = document.createTreeWalker(t, NodeFilter.SHOW_TEXT), s = [];
  let l = o.nextNode();
  for (; l; )
    s.push(l), l = o.nextNode();
  CSS.highlights.clear();
  const a = n.trim().toLowerCase(), c = s.filter((p) => p.textContent !== null).map((p) => {
    const _ = p.textContent.toLowerCase(), g = [];
    let i = 0;
    for (; i < _.length; ) {
      const d = _.indexOf(a, i);
      if (d === -1)
        break;
      g.push(d), i = d + a.length;
    }
    return g.map((d) => {
      const u = new Range();
      return u.setStart(p, d), u.setEnd(p, d + a.length), u;
    });
  }), h = new Highlight(...c.flat());
  CSS.highlights.set(e, h);
}, na = ({ element: e, keyword: t, dependencies: n, highlightName: o = "highlight" }) => {
  G(() => {
    const s = setTimeout(() => {
      const { current: l } = e;
      l !== null && t !== void 0 && t !== null && ta(o, l, t);
    }, 1e3);
    CSS.highlights || clearTimeout(s);
  }, [n, t]);
}, ra = ({ children: e }) => {
  const [t] = mo(), n = K(null);
  return na({ element: n, keyword: t.get("q"), dependencies: [e] }), /* @__PURE__ */ r.jsx("div", { className: ea.articleBody, ref: n, children: e });
}, oa = "_articleTema_y6lqz_1", sa = {
  articleTema: oa
}, ia = "_temaer_qbbrd_1", la = {
  temaer: ia
}, aa = (e) => e.trim().replaceAll(" ", "_"), ca = (e) => e.charAt(0).toUpperCase() + e.slice(1), Qe = {
  digitSpaceDigit: /(\d+\s+\d+)/,
  noneAlphanumeric: /[^0-9a-zæåø]/gim,
  endsWithNoneAlphanumeric: /[^0-9a-zæåø]$/gim,
  validEmail: /^[A-ZÆÅØ0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  samiskeBokstaver: /[čšŋđŧžáåäö]/i
}, ua = [
  "outlook.no",
  "host.com",
  "hormail.com",
  "hotmail.co",
  "hotmil.com",
  "homail.com",
  "homtail.com",
  "outook.com",
  "outlok.com",
  "gmsil.com",
  "gmail.no",
  "gamil.com",
  "gmil.com",
  "gmeil.com",
  "gmai.com"
], da = (e) => typeof e == "string" ? e.trim() === "" : Array.isArray(e) ? e.length === 0 : !1, Ad = (e) => e !== "", fa = (e) => e.replace(/\s+/, " ") === " ", Rd = (e) => !fa(e), ha = (e) => Qe.validEmail.test(e), Fd = (e) => !ha(e), Bd = (e) => ua.includes(e), mn = (e) => e === null, Dd = (e) => !mn(e), gn = (e) => e === void 0, Pd = (e) => !gn(e), Nr = (e) => mn(e) || gn(e), Hd = (e) => !Nr(e), Vd = (e) => mn(e) || gn(e), qd = (e) => !Nr(e), pa = (e) => !isNaN(Number(e)) && !isNaN(parseFloat(e)), Wd = (e) => typeof e == "string", ma = (e) => {
  try {
    if (e instanceof Object)
      JSON.parse(JSON.stringify(e));
    else if (typeof e == "string")
      JSON.parse(e);
    else
      return !1;
    return !0;
  } catch (t) {
    return console.log(t), !1;
  }
}, Ud = (e) => !ma(e), zd = (e, t) => e.includes(t), Gd = (e, t) => e === t, Yd = (e) => e.replace(/\s|\+\(47\)/g, "").length < 8 || !/^4|9\d{7}$/.test(e), Ar = ({ text: e }) => da(e) ? /* @__PURE__ */ r.jsx(r.Fragment, {}) : /* @__PURE__ */ r.jsx(r.Fragment, { children: ca(e) }), ga = ({ temaer: e }) => /* @__PURE__ */ r.jsx("ul", { className: la.temaer, children: e.map(({ value: t }, n) => /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(Ct, { to: `/tema/${aa(t)}`, children: /* @__PURE__ */ r.jsx(Ar, { text: t }) }) }, n)) }), xa = ({ temaTags: e }) => e === void 0 || e.length === 0 ? /* @__PURE__ */ r.jsx(r.Fragment, {}) : /* @__PURE__ */ r.jsxs("div", { className: sa.articleTema, children: [
  /* @__PURE__ */ r.jsx("h2", { children: "Se flere artikler om" }),
  /* @__PURE__ */ r.jsx(ga, { temaer: e })
] }), va = "_row_46m8g_1", ya = "_column_46m8g_5", ka = "_card_46m8g_10", pt = {
  row: va,
  column: ya,
  card: ka
}, _a = "_root_v8s6q_1", ja = {
  root: _a
}, wa = (e, t = 180) => {
  const n = () => {
    if (e.length < t)
      return e.match(Qe.endsWithNoneAlphanumeric) != null ? `${e.slice(0, e.lastIndexOf("."))}` : `${e}`;
    let l = e.slice(0, t);
    l = l.slice(0, l.lastIndexOf(" ")).trim();
    const a = (l.match(Qe.noneAlphanumeric) ?? []).pop();
    if (a !== void 0) {
      const h = l.lastIndexOf(a);
      if (t - h <= 10)
        return `${l.slice(0, h).trim()}`;
    }
    return `${l}`;
  }, s = n().trim().lastIndexOf(" ");
  return {
    start: n().slice(0, s),
    end: `${n().slice(s, n().length)} ...`
  };
}, ba = ({ description: e }) => {
  if (e === void 0 || e.trim().length === 0) return /* @__PURE__ */ r.jsx(r.Fragment, {});
  const { start: t, end: n } = wa(e);
  return /* @__PURE__ */ r.jsxs("p", { className: ja.root, children: [
    /* @__PURE__ */ r.jsx("span", { children: t }),
    /* @__PURE__ */ r.jsx("span", { style: { whiteSpace: "nowrap" }, children: n })
  ] });
}, Sa = "_relative_res3a_1", $a = "_container_res3a_6", Ea = "_row_res3a_76", Ca = "_col_res3a_93", Tt = {
  relative: Sa,
  "container-text": "_container-text_res3a_6",
  container: $a,
  "container-fluid": "_container-fluid_res3a_18",
  "container-xxl": "_container-xxl_res3a_19",
  "container-xl": "_container-xl_res3a_20",
  "container-lg": "_container-lg_res3a_21",
  "container-md": "_container-md_res3a_22",
  "container-sm": "_container-sm_res3a_23",
  row: Ea,
  col: Ca,
  "col-auto": "_col-auto_res3a_97",
  "col-1": "_col-1_res3a_102",
  "col-2": "_col-2_res3a_107",
  "col-3": "_col-3_res3a_112",
  "col-4": "_col-4_res3a_117",
  "col-5": "_col-5_res3a_122",
  "col-6": "_col-6_res3a_127",
  "col-7": "_col-7_res3a_132",
  "col-8": "_col-8_res3a_137",
  "col-9": "_col-9_res3a_142",
  "col-10": "_col-10_res3a_147",
  "col-11": "_col-11_res3a_152",
  "col-12": "_col-12_res3a_157",
  "col-sm-auto": "_col-sm-auto_res3a_163",
  "col-sm-1": "_col-sm-1_res3a_168",
  "col-sm-2": "_col-sm-2_res3a_173",
  "col-sm-3": "_col-sm-3_res3a_178",
  "col-sm-4": "_col-sm-4_res3a_183",
  "col-sm-5": "_col-sm-5_res3a_188",
  "col-sm-6": "_col-sm-6_res3a_193",
  "col-sm-7": "_col-sm-7_res3a_198",
  "col-sm-8": "_col-sm-8_res3a_203",
  "col-sm-9": "_col-sm-9_res3a_208",
  "col-sm-10": "_col-sm-10_res3a_213",
  "col-sm-11": "_col-sm-11_res3a_218",
  "col-sm-12": "_col-sm-12_res3a_223",
  "col-md-auto": "_col-md-auto_res3a_230",
  "col-md-1": "_col-md-1_res3a_235",
  "col-md-2": "_col-md-2_res3a_240",
  "col-md-3": "_col-md-3_res3a_245",
  "col-md-4": "_col-md-4_res3a_250",
  "col-md-5": "_col-md-5_res3a_255",
  "col-md-6": "_col-md-6_res3a_260",
  "col-md-7": "_col-md-7_res3a_265",
  "col-md-8": "_col-md-8_res3a_270",
  "col-md-9": "_col-md-9_res3a_275",
  "col-md-10": "_col-md-10_res3a_280",
  "col-md-11": "_col-md-11_res3a_285",
  "col-md-12": "_col-md-12_res3a_290",
  "col-lg-auto": "_col-lg-auto_res3a_297",
  "col-lg-1": "_col-lg-1_res3a_302",
  "col-lg-2": "_col-lg-2_res3a_307",
  "col-lg-3": "_col-lg-3_res3a_312",
  "col-lg-4": "_col-lg-4_res3a_317",
  "col-lg-5": "_col-lg-5_res3a_322",
  "col-lg-6": "_col-lg-6_res3a_327",
  "col-lg-7": "_col-lg-7_res3a_332",
  "col-lg-8": "_col-lg-8_res3a_337",
  "col-lg-9": "_col-lg-9_res3a_342",
  "col-lg-10": "_col-lg-10_res3a_347",
  "col-lg-11": "_col-lg-11_res3a_352",
  "col-lg-12": "_col-lg-12_res3a_357",
  "col-xl-auto": "_col-xl-auto_res3a_364",
  "col-xl-1": "_col-xl-1_res3a_369",
  "col-xl-2": "_col-xl-2_res3a_374",
  "col-xl-3": "_col-xl-3_res3a_379",
  "col-xl-4": "_col-xl-4_res3a_384",
  "col-xl-5": "_col-xl-5_res3a_389",
  "col-xl-6": "_col-xl-6_res3a_394",
  "col-xl-7": "_col-xl-7_res3a_399",
  "col-xl-8": "_col-xl-8_res3a_404",
  "col-xl-9": "_col-xl-9_res3a_409",
  "col-xl-10": "_col-xl-10_res3a_414",
  "col-xl-11": "_col-xl-11_res3a_419",
  "col-xl-12": "_col-xl-12_res3a_424",
  "col-xxl-auto": "_col-xxl-auto_res3a_431",
  "col-xxl-1": "_col-xxl-1_res3a_436",
  "col-xxl-2": "_col-xxl-2_res3a_441",
  "col-xxl-3": "_col-xxl-3_res3a_446",
  "col-xxl-4": "_col-xxl-4_res3a_451",
  "col-xxl-5": "_col-xxl-5_res3a_456",
  "col-xxl-6": "_col-xxl-6_res3a_461",
  "col-xxl-7": "_col-xxl-7_res3a_466",
  "col-xxl-8": "_col-xxl-8_res3a_471",
  "col-xxl-9": "_col-xxl-9_res3a_476",
  "col-xxl-10": "_col-xxl-10_res3a_481",
  "col-xxl-11": "_col-xxl-11_res3a_486",
  "col-xxl-12": "_col-xxl-12_res3a_491"
}, Kd = {
  TWELVE: "col-xl-12",
  NINE: "col-xl-9",
  SIX: "col-xl-6",
  FOUR: "col-xl-4",
  THREE: "col-xl-3"
}, pe = {
  TWELVE: "col-lg-12",
  NINE: "col-lg-9",
  EIGHT: "col-lg-8",
  SEVEN: "col-lg-7",
  SIX: "col-lg-6",
  FIVE: "col-lg-5",
  FOUR: "col-lg-4",
  THREE: "col-lg-3",
  TWO: "col-lg-2",
  AUTO: "col-lg-auto"
}, on = {
  TWELVE: "col-md-12",
  NINE: "col-md-9",
  EIGHT: "col-md-8",
  SEVEN: "col-md-7",
  SIX: "col-md-6",
  FOUR: "col-md-4",
  THREE: "col-md-3",
  TWO: "col-md-2",
  AUTO: "col-md-auto"
}, Xd = {
  TWELVE: "col-sm-12",
  NINE: "col-sm-9",
  SEVEN: "col-md-7",
  SIX: "col-sm-6",
  FOUR: "col-sm-4",
  THREE: "col-sm-3",
  AUTO: "col-sm-auto",
  COLUMN: "col"
}, ue = {
  TWELVE: "col-12",
  NINE: "col-9",
  SIX: "col-6",
  FOUR: "col-4",
  THREE: "col-3",
  TWO: "col-2",
  AUTO: "col-auto",
  COLUMN: "col"
}, Se = {
  TEXT: "container-text",
  FLUID: "container-fluid",
  XL: "container-xl",
  LG: "container-lg",
  MD: "container-md",
  SM: "container-sm",
  XS: "container-xs"
}, Zd = ({
  children: e,
  className: t = "",
  style: n = {},
  ...o
}) => /* @__PURE__ */ r.jsx("div", { ...o, className: `${Tt.relative} ${t}`, style: n, children: e });
function Le({
  children: e,
  className: t = "",
  style: n = {},
  type: o = Se.XL,
  ...s
}) {
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      ...s,
      style: {
        paddingLeft: "0.5rem",
        paddingRight: "0.5rem",
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
        ...n
      },
      children: /* @__PURE__ */ r.jsx("div", { className: `${Tt[o]} ${t}`, children: e })
    }
  );
}
function we({ children: e, className: t = "", style: n = {}, ...o }) {
  return /* @__PURE__ */ r.jsx("section", { ...o, className: `${Tt.row} ${t}`, style: n, children: e });
}
function se({
  children: e,
  className: t = "",
  style: n = {},
  types: o = [ue.TWELVE],
  ...s
}) {
  const l = o.map((a) => Tt[a]).join(" ");
  return /* @__PURE__ */ r.jsx("div", { ...s, className: `${l} ${t}`, style: n, children: e });
}
const La = ({ slug: e, lenke: t }) => {
  const n = "Les mer";
  return e != null ? /* @__PURE__ */ r.jsx("a", { href: `/${e.current}`, children: n }) : t != null ? /* @__PURE__ */ r.jsx(ne, { href: t.href, children: n }) : /* @__PURE__ */ r.jsx(r.Fragment, {});
}, Wn = ({ relatedArticles: e }) => {
  const t = [...e].sort((o, s) => {
    const l = o.beskrivelse ?? o.innledning ?? "";
    return (s.beskrivelse ?? s.innledning ?? "").length - l.length;
  }), n = t.length > 2 ? pe.FOUR : pe.SIX;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(we, { className: pt.row, children: /* @__PURE__ */ r.jsx(se, { children: /* @__PURE__ */ r.jsx("h2", { children: "Relaterte artikler" }) }) }),
    /* @__PURE__ */ r.jsx(we, { className: pt.row, children: t.map(({ tittel: o, beskrivelse: s, innledning: l, slug: a, lenke: c }, h) => {
      const p = s ?? l;
      return /* @__PURE__ */ r.jsx(se, { types: [n, ue.TWELVE], className: pt.column, children: /* @__PURE__ */ r.jsxs("div", { className: pt.card, children: [
        o !== void 0 ? /* @__PURE__ */ r.jsx("h3", { children: o }) : null,
        /* @__PURE__ */ r.jsx(ba, { description: p }),
        /* @__PURE__ */ r.jsx(La, { slug: a, lenke: c })
      ] }) }, h);
    }) })
  ] });
};
let sn = ["Mer informasjon", "Flere artikler", "Se også:", "Relaterte artikler", "Slik går du frem"];
sn = sn.map((e) => e.trim().toLowerCase().replace(/\s/g, ""));
const Ta = new Set(sn), Ma = "_aside_jt61k_1", Oa = "_active_jt61k_39", Ia = "_content_jt61k_69", Na = "_inline_jt61k_89", wt = {
  aside: Ma,
  active: Oa,
  content: Ia,
  inline: Na
}, Un = ({ headings: e, isAside: t }) => {
  const n = "innhold", o = [...e], [s, l] = A();
  pr({ callback: l });
  const a = (c) => {
    dr(c), l(c);
  };
  return /* @__PURE__ */ r.jsxs("nav", { className: wt.content, "aria-labelledby": n, children: [
    /* @__PURE__ */ r.jsx("h2", { id: n, children: "Innhold" }),
    /* @__PURE__ */ r.jsx("ul", { children: o.map((c, h) => {
      const { textContent: p } = c;
      if (p === null)
        return /* @__PURE__ */ r.jsx(r.Fragment, {});
      {
        const _ = Or(p.toLowerCase().trim()), i = _ === s && t ? wt.active : "";
        return /* @__PURE__ */ po("li", { tabIndex: 0, key: h, className: `${i}` }, /* @__PURE__ */ r.jsx(
          "a",
          {
            onClick: (d) => {
              d.preventDefault(), a(`h2[data-hash="${_}"]`);
            },
            href: `#${_}`,
            children: p
          }
        ));
      }
    }) })
  ] });
}, zn = ({ headings: e, isAside: t }) => e === void 0 || e.length < 2 ? /* @__PURE__ */ r.jsx(r.Fragment, {}) : t ? /* @__PURE__ */ r.jsx("div", { className: wt.aside, children: /* @__PURE__ */ r.jsx(Un, { headings: e, isAside: t }) }) : /* @__PURE__ */ r.jsx("div", { className: wt.inline, children: /* @__PURE__ */ r.jsx(Un, { headings: e, isAside: t }) }), Aa = (e, t, n) => (e - t) * (e - n) <= 0, Ra = Et(({ article: e, children: t }) => {
  const { width: n, breakpoint: o } = xe(ve), s = K(null), [l, a] = A([]), c = n > o.large;
  G(() => {
    const g = s.current;
    if (g != null) {
      const i = [...g.querySelectorAll("h2")].filter((d) => {
        const u = d.textContent;
        if (u !== null) {
          const x = u.trim().toLowerCase().replace(/\s/g, "");
          return u.length > 0 && !Ta.has(x);
        }
        return !1;
      });
      a(i);
    }
  }, [e]), pr();
  const { relaterteArtikler: h, featuredImage: p } = e, _ = h != null;
  return /* @__PURE__ */ r.jsxs(Le, { className: ct.articleContent, type: Se.XL, children: [
    /* @__PURE__ */ r.jsxs(we, { className: ct.row, children: [
      /* @__PURE__ */ r.jsx(se, { children: /* @__PURE__ */ r.jsxs("header", { className: ct.topHeader, children: [
        /* @__PURE__ */ r.jsx("figure", { children: p !== void 0 ? /* @__PURE__ */ r.jsx("img", { width: 250, height: 187, src: pn(p.asset), role: "presentation" }) : null }),
        t
      ] }) }),
      /* @__PURE__ */ r.jsxs(se, { className: ct.column, children: [
        c && l.length >= 2 ? /* @__PURE__ */ r.jsx(zn, { isAside: c, headings: l }) : null,
        /* @__PURE__ */ r.jsxs("article", { ref: s, style: l.length < 2 && c ? { marginLeft: "250px" } : {}, children: [
          /* @__PURE__ */ r.jsx(Jl, { blocks: e.innledning }),
          !c && l.length >= 2 ? /* @__PURE__ */ r.jsx(zn, { isAside: c, headings: l }) : null,
          /* @__PURE__ */ r.jsx(ra, { children: /* @__PURE__ */ r.jsx(Te, { blocks: e.innhold }) }),
          /* @__PURE__ */ r.jsx(xa, { temaTags: e.temaTags }),
          _ && Aa(h.length, 0, 2) ? /* @__PURE__ */ r.jsx(Wn, { relatedArticles: h }) : null
        ] })
      ] })
    ] }),
    _ && h.length > 2 ? /* @__PURE__ */ r.jsx(Wn, { relatedArticles: h }) : null
  ] });
});
Ra.displayName = "ArticleContent";
const Fa = "_headingOne_1lzrl_1", Ba = {
  headingOne: Fa
}, Jd = ({ text: e }) => /* @__PURE__ */ r.jsx("h1", { className: Ba.headingOne, children: /* @__PURE__ */ r.jsx(Ar, { text: e }) }), Da = "_banner_10sc7_1", Pa = {
  banner: Da
}, Mt = ({ children: e, style: t }) => /* @__PURE__ */ r.jsx("div", { className: Pa.banner, style: t, children: e }), Ha = ({ children: e, style: t }) => /* @__PURE__ */ r.jsx(
  Mt,
  {
    style: {
      borderColor: "var(--fiken-color-red-500)",
      backgroundColor: "var(--fiken-color-red-300)",
      color: "var(--fiken-color-black-500)",
      ...t
    },
    children: /* @__PURE__ */ r.jsx(r.Fragment, { children: e })
  }
), Qd = ({ children: e, style: t }) => /* @__PURE__ */ r.jsx(
  Mt,
  {
    style: {
      borderColor: "var(--fiken-color-blue-500)",
      backgroundColor: "var(--fiken-color-blue-300)",
      color: "var(--fiken-color-black-500)",
      ...t
    },
    children: /* @__PURE__ */ r.jsx(r.Fragment, { children: e })
  }
), ef = ({ children: e }) => /* @__PURE__ */ r.jsx(
  Mt,
  {
    style: {
      borderColor: "var(--fiken-color-green-500)",
      backgroundColor: "var(--fiken-color-green-300)",
      color: "var(--fiken-color-green-900)",
      fontWeight: 700
    },
    children: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsx(jo, {}),
      e
    ] })
  }
), tf = ({
  variant: e = be.PRIMARY,
  size: t = ye.SM,
  children: n,
  href: o,
  ...s
}) => /* @__PURE__ */ r.jsx("a", { ...s, href: o, className: `${re.button} ${re[e]} ${re[t]} `, children: n }), nf = ({ children: e, style: t = {} }) => /* @__PURE__ */ r.jsx(
  Mt,
  {
    style: {
      borderColor: "var(--fiken-color-yellow-500)",
      backgroundColor: "var(--fiken-color-yellow-300)",
      ...t
    },
    children: e
  }
), Va = "_buttonLink_qals1_1", qa = {
  buttonLink: Va
}, rf = ({
  children: e,
  onClick: t,
  className: n = "",
  style: o = {},
  ...s
}) => /* @__PURE__ */ r.jsx("button", { type: "button", ...s, className: `${qa.buttonLink} ${n}`, style: o, onClick: t, children: e }), Wa = "_infoButton_uzq79_1", Ua = {
  infoButton: Wa
}, za = ({ onClick: e, className: t = "" }) => /* @__PURE__ */ r.jsx("button", { type: "button", onClick: e, className: `${Ua.infoButton} ${t}`, children: /* @__PURE__ */ r.jsx("svg", { width: "19", height: "19", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ r.jsxs("g", { stroke: "#272727", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", children: [
  /* @__PURE__ */ r.jsx("path", { d: "M9.5 17C13.6421 17 17 13.6421 17 9.5C17 5.35786 13.6421 2 9.5 2C5.35786 2 2 5.35786 2 9.5C2 13.6421 5.35786 17 9.5 17Z" }),
  /* @__PURE__ */ r.jsx("path", { d: "M9.5 12.5V9.5" }),
  /* @__PURE__ */ r.jsx("path", { d: "M9.5 6.5H9.5075" })
] }) }) }), Ga = ({
  href: e,
  children: t,
  className: n = "",
  target: o = "_self",
  rel: s = "",
  style: l = {},
  ...a
}) => /* @__PURE__ */ r.jsx("a", { href: `${e}`, target: o, rel: s, ...a, className: n, style: l, children: t }), xn = ({
  variant: e = be.PRIMARY,
  size: t = ye.SM,
  rounded: n = !0,
  children: o,
  href: s,
  target: l = "_self",
  rel: a = "",
  ...c
}) => {
  const h = n ? "capsule" : "rectangle";
  return /* @__PURE__ */ r.jsx(
    Ga,
    {
      href: `${s}`,
      className: `${re.button} ${re[e]} ${re[t]} ${re[h]}`,
      target: l,
      rel: a,
      ...c,
      children: o
    }
  );
}, Ya = "_root_1a2mi_1", Ka = {
  root: Ya
}, of = () => {
  const [e, t] = A(!1);
  G(() => (document.addEventListener("scroll", n), () => document.removeEventListener("scroll", n)), []);
  const n = () => {
    const { clientHeight: s } = document.documentElement, { scrollY: l } = window;
    t(l > s * 0.5);
  }, o = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return e ? /* @__PURE__ */ r.jsx("button", { className: Ka.root, type: "button", "aria-label": "Gå til topp", onClick: o, children: /* @__PURE__ */ r.jsx("svg", { "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "m16 10-4-4-4 4M12 18V6",
      stroke: "#4B33DD",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) }) }) : /* @__PURE__ */ r.jsx(r.Fragment, {});
}, Xa = "_button_frzni_1", Za = "_active_frzni_12", Ja = "_disabled_frzni_31", Gn = {
  button: Xa,
  active: Za,
  default: "_default_frzni_30",
  disabled: Ja
}, Qa = {
  disabled: "disabled",
  active: "active",
  default: "default"
}, sf = ({
  onClick: e,
  isDisabled: t = !1,
  state: n = Qa.default,
  className: o = "",
  style: s = {},
  ...l
}) => /* @__PURE__ */ r.jsx(
  "button",
  {
    type: "button",
    "aria-label": "Søk",
    ...l,
    className: `${Gn.button} ${Gn[n]} ${o}`,
    style: s,
    onClick: e,
    disabled: t,
    onMouseDown: (a) => a.preventDefault(),
    children: /* @__PURE__ */ r.jsx(ec, {})
  }
), ec = () => /* @__PURE__ */ r.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
      stroke: "#272727",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M18.9999 19.0004L14.6499 14.6504",
      stroke: "#272727",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Rr = ({ param: e, ...t }) => /* @__PURE__ */ r.jsx(xn, { href: `https://fiken.no/registrer${e}`, size: ye.LG, ...t, children: "Prøv Fiken gratis" }), lf = ({
  variant: e = be.PRIMARY,
  size: t = ye.SM,
  onClick: n,
  children: o,
  spin: s,
  color: l = Be.LIGHT,
  type: a = "button",
  rounded: c = !1
}) => {
  const h = c ? "capsule" : "rectangle", p = K(null), [_, g] = A(0);
  return Pe(() => {
    const { current: i } = p;
    if (i != null) {
      const { clientHeight: d } = i, x = d - 14;
      g(x);
    }
  }, []), /* @__PURE__ */ r.jsx(
    "button",
    {
      type: a,
      ref: p,
      onClick: n,
      disabled: s,
      className: `${re.button} ${re[e]} ${re[t]} ${re[h]}`,
      children: /* @__PURE__ */ r.jsx(Lt, { isVisible: s, diameter: _, style: { borderColor: l }, color: l, children: /* @__PURE__ */ r.jsx(r.Fragment, { children: o }) })
    }
  );
}, Ot = (e = "footer-navigation") => {
  const [t, n] = A("");
  return G(() => {
    if (typeof window > "u")
      return;
    const o = [
      "starte-as",
      "starte-enkeltpersonforetak",
      "forklarer",
      "logo",
      "webinar",
      "kontohjelp",
      "kontohjelp-test",
      "hjelp",
      "hjelp-test",
      "webinar-test"
    ], { href: s } = window.location, l = o.find((a) => s.split(/([./])/).includes(a));
    l !== void 0 && n(`?utm_source=${l}&utm_medium=${e}`);
  }, [e]), t;
}, tc = (e) => /* @__PURE__ */ r.jsx(xn, { href: "https://fiken.no/", size: ye.LG, ...e, children: "Tilbake til Fiken" }), nc = ({ isAuthenticated: e, ...t }) => {
  const n = Ot();
  return e ? /* @__PURE__ */ r.jsx(tc, { ...t }) : /* @__PURE__ */ r.jsx(Rr, { param: n, ...t });
}, rc = fe.createContext(null), af = ({ children: e, dyplenker: t, articleLinks: n }) => /* @__PURE__ */ r.jsx(rc.Provider, { value: { dyplenker: t, articleLinks: n }, children: e }), cf = {
  ADMIN: "admin",
  SUPPORT: "support",
  BRUKER: "bruker",
  UKJENT: "ukjent"
}, oc = fe.createContext(null), uf = ({ children: e, whoami: t }) => {
  const n = t !== null ? { rolle: t.rolle, brukerInfo: t.brukerInfo } : null;
  return /* @__PURE__ */ r.jsx(oc.Provider, { value: n, children: e });
}, Fr = (e, t) => {
  G(() => (typeof window < "u" && document.addEventListener("mousedown", e), () => {
    typeof window < "u" && document.removeEventListener("mousedown", e);
  }), typeof t == "boolean" ? [t] : t);
}, df = (e, t, n) => {
  Fr((o) => {
    const { current: s } = e, l = o.target;
    s !== null && l !== null && !s.contains(l) && t(o);
  }, n);
}, ff = (e) => {
  const [t, n] = A(!1), o = Ae(() => new IntersectionObserver(([s]) => n(s.isIntersecting)), [e]);
  return G(() => (e.current !== null && o.observe(e.current), () => o.disconnect()), []), t;
}, hf = (e, t, n) => {
  const o = Jt(
    (s) => {
      if (!Array.isArray(s))
        return;
      const l = s[0];
      t !== void 0 && t(l.contentRect);
    },
    [t]
  );
  Pe(() => {
    if (e == null)
      return;
    const s = new ResizeObserver((l) => o(l));
    return s.observe(e), () => s.unobserve(e);
  }, [e, ...n ?? []]);
}, sc = () => {
  const { scrollY: e } = window;
  Math.round(e) > 0 && window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
}, pf = (e) => {
  G(sc, [e]);
}, mf = (e, t = { top: 0, behavior: "smooth" }) => {
  G(() => {
    window.scrollTo(t);
  }, [e]);
}, ic = (e, t, n) => {
  G(() => {
    function o(s) {
      const { current: l } = e, a = s.target;
      l !== null && a !== null && !l.contains(a) && t && n(!1);
    }
    return document.addEventListener("mousedown", o), () => document.removeEventListener("mousedown", o);
  }, [t]);
}, gf = { timeStyle: "short" };
function xf(e, t = {
  dateStyle: "full",
  timeStyle: "short"
}) {
  const n = new Date(e);
  return new Intl.DateTimeFormat("nb", t).format(n);
}
const lc = ({ visible: e, children: t, style: n = {} }) => {
  const [o, s] = A(), l = K(null);
  return G(() => {
    const { current: a } = l;
    if (a !== null)
      if (e) {
        const c = rt(a);
        s(c);
      } else
        s(0);
  }, [e, t]), /* @__PURE__ */ r.jsx(
    "div",
    {
      ref: l,
      style: {
        height: o,
        transition: "height var(--transition-duration)",
        overflow: "hidden",
        background: "var(--fiken-color-white-500)",
        ...n
      },
      children: t
    }
  );
}, vf = {
  weekday: "long",
  year: "numeric",
  month: "short",
  day: "numeric"
}, ac = "_dropYMenu_8p9c2_1", cc = {
  dropYMenu: ac
}, uc = ({ offsetHeight: e, offsetWidth: t }, n) => {
  const { clientHeight: l, clientWidth: a } = window.document.documentElement, { top: c, left: h, bottom: p, right: _, height: g } = n;
  let i = {};
  return _ + t + 10 > a ? i = { right: 0, left: "unset" } : h < 0 && (i = { left: 0, right: "unset" }), p + e + 10 > l ? i = { ...i, bottom: `${g + 5}px`, top: "unset" } : c - e - 100 - 10 < 0 && (i = { ...i, top: `${g + 5}px`, bottom: "unset" }), i;
}, Yn = {
  top: "top",
  bottom: "bottom"
}, yf = ({
  label: e,
  children: t,
  className: n = "",
  style: o = {},
  preferredDirection: s = Yn.top,
  ...l
}) => {
  const a = K(null), c = K(null), [h, p] = A({}), [_, g] = A(!1);
  return ic(a, _, g), Pe(() => {
    const { current: i } = c;
    if (i !== null) {
      const { parentElement: d } = i;
      if (d !== null) {
        const { clientHeight: u } = i, x = uc(i, d.getBoundingClientRect()), m = { height: u, ...x };
        s === Yn.top ? p({ top: "110%", ...m }) : p({ bottom: "110%", ...m });
      }
    }
  }, [_]), /* @__PURE__ */ r.jsxs(
    "div",
    {
      ...l,
      className: `${cc.dropYMenu} ${n}`,
      style: { ...o, position: _ ? "relative" : "initial" },
      ref: a,
      children: [
        /* @__PURE__ */ r.jsx(Cr, { size: ye.SM, variant: be.SECONDARY, onClick: () => g((i) => !i), children: e }),
        _ ? /* @__PURE__ */ r.jsx("ul", { style: h, ref: c, children: fe.Children.map(t, (i) => fe.isValidElement(i) ? /* @__PURE__ */ r.jsx("li", { children: i }) : /* @__PURE__ */ r.jsx("li", { onClick: () => g(!1), children: i })) }) : null
      ]
    }
  );
}, kf = ({ children: e }) => /* @__PURE__ */ r.jsx("div", { children: e }), dc = "_dropdown_txr6g_1", fc = "_open_txr6g_51", hc = "_chevron_txr6g_54", pc = "_disabled_txr6g_64", mc = "_selected_txr6g_76", gc = "_hasResult_txr6g_82", xc = "_loading_txr6g_1", Oe = {
  dropdown: dc,
  open: fc,
  chevron: hc,
  disabled: pc,
  selected: mc,
  hasResult: gc,
  loading: xc
}, Br = {
  code: {
    Enter: "Enter",
    ArrowDown: "ArrowDown",
    Backspace: "Backspace",
    ArrowUp: "ArrowUp",
    Escape: "Escape",
    ControlLeft: "ControlLeft",
    ControlRight: "ControlRight",
    AltLeft: "AltLeft",
    AltRight: "AltRight",
    Tab: "Tab"
  }
}, vc = "_header_xqk3e_1", yc = "_chevron_xqk3e_28", kc = "_search_xqk3e_35", _c = "_loading_xqk3e_35", Je = {
  header: vc,
  chevron: yc,
  search: kc,
  loading: _c
}, jc = ({ header: e, onClick: t, style: n = {}, ref: o }) => /* @__PURE__ */ r.jsx(
  "header",
  {
    ref: o,
    className: `${Je.header} ${Je[vn.chevron]}`,
    onClick: t,
    style: { ...n, minHeight: 41 },
    children: e
  }
), wc = ({
  onKeyDown: e,
  onClick: t,
  onChange: n,
  searchable: o,
  style: s = {},
  ref: l
}) => /* @__PURE__ */ r.jsxs(
  "header",
  {
    className: `${Je.header} ${Je.search}  ${(o == null ? void 0 : o.isLoading) === !0 ? Je.loading : ""}`,
    ref: l,
    onKeyDown: e,
    onClick: t,
    style: s,
    children: [
      /* @__PURE__ */ r.jsx(
        "input",
        {
          ...o == null ? void 0 : o.inputProps,
          onChange: n,
          onKeyDown: (a) => {
            a.key === Br.code.Enter && a.preventDefault();
          }
        }
      ),
      o != null && o.isLoading ? /* @__PURE__ */ r.jsx(Lt, { isVisible: !0, diameter: 24, color: Be.DARK }) : null
    ]
  }
), bc = (e, t, n, o, s) => {
  const l = { height: [`${n}px`, `${o}px`] }, a = {
    duration: e ? 120 : 200,
    easing: e ? "ease-in" : "ease-out"
  }, c = new KeyframeEffect(t, l, a), h = new Animation(c, document.timeline);
  h.play(), h.onfinish = s;
}, vn = {
  chevron: "chevron",
  search: "search"
}, Sc = {
  down: 1,
  up: -1
}, _f = ({ style: e, children: t }) => /* @__PURE__ */ r.jsx("li", { style: e, className: Oe.disabled, children: t }), $c = ({
  children: e,
  onSelect: t,
  isSelected: n,
  className: o = "",
  scrollDirection: s
}) => {
  const l = K(null), a = (c) => {
    const h = c.nextElementSibling, p = c.previousElementSibling, _ = {
      behavior: "smooth",
      block: "nearest"
    };
    p === null ? c.scrollIntoView(_) : h !== null ? s === 1 ? p.scrollIntoView(_) : s === -1 && h.scrollIntoView(_) : c.scrollIntoView(_);
  };
  if (n && l.current != null) {
    const c = l.current;
    a(c);
  }
  return /* @__PURE__ */ r.jsx("li", { tabIndex: 0, onClick: t, className: `${o} ${n ? Oe.selected : ""}`, ref: l, children: e });
}, Ec = ({
  render: e,
  header: t,
  maxWidth: n,
  minHeight: o = 100,
  maxHeight: s = "100%",
  marginBottom: l = 0,
  searchable: a = void 0,
  footer: c,
  items: h,
  disabled: p = !1,
  icon: _ = vn.chevron
}) => {
  const [g, i] = A(-1), [d, u] = A(1), x = K(null), m = K(null), v = K(null), [b, E] = A(), [O, H] = A(), [C, V] = A(!1), [N, ie] = A(!1), [de, y] = A(s), { up: j, down: w } = Sc;
  Fr((R) => {
    const { current: W } = x, z = R.target;
    W !== null && z !== null && !W.contains(z) && C && (a !== void 0 ? a.closable !== !1 && L(!1) : L(!1));
  }, C), G(() => {
    const R = m.current;
    if (R !== null) {
      const { offsetHeight: W } = R;
      H(W), E(W);
    }
  }, [p]), G(() => {
    (a == null ? void 0 : a.openByDefault) === !0 && L(!0);
  }, [a == null ? void 0 : a.openByDefault]);
  const k = (R) => {
    var W;
    if (s === "100%") {
      const { clientHeight: z } = window.document.documentElement, q = rt(R), { top: te } = R.getBoundingClientRect(), Q = z - te - l - (((W = R.nextElementSibling) == null ? void 0 : W.clientHeight) ?? 0);
      return Math.min(q, Q);
    } else {
      const { clientHeight: z } = R;
      return z > o ? z > s ? s : z : s;
    }
  }, U = (R) => {
    R.preventDefault(), a !== void 0 ? (a == null ? void 0 : a.openOnClick) === !0 && L(!C) : N || L(!C);
  }, L = (R) => {
    ie(!0);
    const W = m.current, z = x.current, q = v.current;
    if (R && V(!0), z !== null && W !== null && q !== null) {
      const te = setTimeout(() => {
        var he;
        const Q = k(q);
        y(Q);
        const { offsetHeight: Z } = W, le = Q + Z + (((he = q.nextElementSibling) == null ? void 0 : he.clientHeight) ?? 0), [ee, oe] = C ? [le, Z] : [Z, le];
        H(C ? Z : le), bc(C, z, ee, oe, () => {
          ie(!1), R || V(!1), clearTimeout(te);
        });
      });
    }
  }, P = (R) => {
    var W, z;
    if (a !== void 0) {
      const { Enter: q, Escape: te, ArrowDown: Q, ArrowUp: Z } = Br.code, le = h.length - 1, { key: ee } = R;
      if (ee === q ? (R.preventDefault(), g !== -1 && a.onSelect(g)) : ee === Q ? (C || L(!0), i((oe) => oe < le ? oe + w : 0), u(j)) : ee === Z && (C || L(!0), i((oe) => oe > 0 ? oe + j : 0), u(w)), ee === te && typeof window < "u") {
        const { activeElement: oe } = document;
        oe !== null && oe instanceof HTMLInputElement && (oe.blur(), L(!1));
      }
      ((W = a.inputProps) == null ? void 0 : W.onKeyDown) !== void 0 && ((z = a.inputProps) == null || z.onKeyDown(R));
    }
  };
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      className: `${Oe.dropdown} ${p ? Oe.disabled : ""} ${h.length > 0 ? Oe.hasResult : ""} `,
      style: { maxWidth: n, zIndex: C ? 1e3 : 1, minHeight: b },
      children: /* @__PURE__ */ r.jsxs(
        "div",
        {
          ref: x,
          style: {
            height: O
          },
          className: `${C ? Oe.open : ""} ${Oe[_]}`,
          children: [
            t === void 0 ? a !== void 0 ? /* @__PURE__ */ r.jsx(
              wc,
              {
                ref: m,
                searchable: a,
                onClick: U,
                onKeyDown: P,
                onChange: ({ target: R }) => {
                  C || L(!0), a == null || a.onChange(R.value);
                }
              }
            ) : null : /* @__PURE__ */ r.jsx(jc, { onClick: U, header: t, ref: m }),
            /* @__PURE__ */ r.jsx("ul", { style: { height: de }, ref: v, children: O == null ? null : e(L, h, g, d) }),
            c
          ]
        }
      )
    }
  );
};
let Dt = !1;
const Cc = (e, t) => {
  Dt || (Dt = !0, setTimeout(() => {
    e(), Dt = !1;
  }, t));
}, jf = ({
  isLoading: e,
  field: t,
  initialValue: n,
  onChange: o,
  data: s,
  onDataSelect: l,
  onKeyDown: a,
  onPaste: c,
  renderResult: h,
  renderNoResult: p
}) => {
  const [_, g] = A(n);
  return /* @__PURE__ */ r.jsx(
    Ec,
    {
      items: s,
      maxWidth: "100%",
      maxHeight: 300,
      icon: vn.search,
      searchable: {
        inputProps: {
          "aria-label": t.name,
          autoFocus: t.autoFocus ?? !1,
          placeholder: t.placeholder ?? "Søk",
          value: _,
          onKeyDown: a,
          onPaste: c
        },
        isLoading: e,
        onSelect: (i) => {
          l(s[i]);
        },
        onChange: (i) => {
          g(i), Cc(() => {
            o(i);
          }, 300);
        }
      },
      render: (i, d, u, x) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        d.map((m, v) => /* @__PURE__ */ r.jsx(
          $c,
          {
            scrollDirection: x,
            isSelected: v === u,
            onSelect: () => {
              i(!1), l(m), g(m.label);
            },
            children: h(m, v)
          },
          m.id
        )),
        s.length === 0 ? p(_) : null
      ] })
    }
  );
}, mt = {
  standard: "standard",
  errorBanner: "errorBanner",
  dialogModal: "dialogModal",
  interactionErrorBanner: "interactionErrorBanner"
}, Lc = {
  isValid: !1,
  isTouched: !1,
  isChanged: !1,
  isSubmitted: !1,
  lastModifiedDate: void 0,
  fields: {},
  errors: {}
}, Pt = (e, t) => Object.entries(e).reduce((n, [o, s]) => {
  const l = t[o];
  return { ...n, [o]: { ...s, error: l, isValid: l === void 0 } };
}, {}), Tc = (e, t) => Object.entries(t).reduce((n, [o]) => o in e ? { ...n, [o]: e[o] } : n, {}), Ht = (e) => Object.values(e).length > 0, wf = ({
  initialValues: e,
  fields: t,
  validate: n
}) => {
  const [o, s] = A(void 0), l = (i, d) => ({ ...i, ...d }), [a, c] = cr(l, e), [h, p] = A({ ...Lc, fields: t }), _ = ({ onValid: i, onInvalid: d, identifier: u }) => {
    s(u);
    const x = n !== void 0 ? n(a, u) : {}, m = !Ht(x);
    p((v) => ({
      ...v,
      fields: Pt(t, x),
      isSubmitted: !0,
      isValid: m,
      errors: x
    })), m ? i(a) : d !== void 0 && d({ values: a, invalidValues: Tc(a, x), errors: x });
  };
  return G(() => {
    const i = JSON.stringify(e), d = JSON.stringify(a), u = /* @__PURE__ */ new Date(), x = i !== d, { isSubmitted: m } = h;
    if (m) {
      const v = n !== void 0 ? n(a, o) : {};
      p((b) => ({
        ...b,
        fields: Pt(t, v),
        isTouched: !0,
        isChanged: x,
        isValid: !Ht(v),
        lastModifiedDate: u,
        errors: v
      }));
    } else
      p((v) => ({ ...v, isChanged: x, isTouched: !0, lastModifiedDate: u }));
  }, [a]), [a, c, _, h, (i) => {
    p((d) => ({ ...d, isValid: !Ht(i), fields: Pt(t, i) }));
  }];
}, Mc = ({ param: e }) => /* @__PURE__ */ r.jsxs(se, { types: [ue.TWELVE, pe.FOUR], children: [
  /* @__PURE__ */ r.jsx("h3", { children: "Bli med på webinar" }),
  /* @__PURE__ */ r.jsx("p", { children: "Lyst til å lære? Bli med på gratis webinar, lær om Fiken, still spørsmål og få svar." }),
  /* @__PURE__ */ r.jsx(ne, { href: `https://webinar.fiken.no/${e}`, children: "Meld deg på webinar" })
] }), Oc = "_fikenPromo_1wtlm_1", Ic = "_column_1wtlm_6", Kn = {
  fikenPromo: Oc,
  column: Ic
}, Nc = "_textDecoration_3br3c_1", Ac = "_textDecorationHover_3br3c_9", Xn = {
  textDecoration: Nc,
  textDecorationHover: Ac
}, Dr = ({
  param: e,
  className: t = "",
  hasTextDecoration: n = !1,
  style: o = {},
  ...s
}) => {
  const l = n ? Xn.textDecoration : Xn.textDecorationHover;
  return /* @__PURE__ */ r.jsx(
    "a",
    {
      ...s,
      style: { marginRight: "clamp(1.25rem, 6.25vw, 3rem)", ...o },
      className: `${l} ${t}`,
      href: `https://fiken.no/logg-inn/${e}`,
      children: "Logg inn"
    }
  );
}, bf = (e) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ r.jsx("g", { stroke: "#5239BA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, children: /* @__PURE__ */ r.jsx("path", { d: "M18 6 6 18M6 6l12 12" }) }) }), Rc = (e) => /* @__PURE__ */ r.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", height: 250, fill: "none", viewBox: "0 0 300 250", ...e, children: [
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#272727",
      d: "M124.7 186.12a28.6 28.6 0 0 1-3.12 12.33c-.49 1-1.06 2-1.6 3-.35.65-.33.71.18 1.33a19 19 0 0 0 7.34 5.47c1.05.44 2.11.81 3.14 1.28.75.34 1.5.68 2.17 1.15 1.7 1.2 1.83 2.85.41 4.35a9.2 9.2 0 0 1-5.28 2.67c-2.86.51-5.49-.06-7.94-1.62-3.67-2.34-5.9-5.58-6.47-9.93a9 9 0 0 1 .2-3q.43-1.87 2.31-2.17.65-.13 1.3-.14c1 0 .99.02 1.34-.87a55 55 0 0 0 3.26-11.03c.31-1.78.47-3.6.2-5.45a8.4 8.4 0 0 0-3.22-5.58 14 14 0 0 0-5.6-2.56 21 21 0 0 0-4.5-.46c-.57-.02-1.3.3-1.6-.55.28-.62.93-.63 1.44-.77a12 12 0 0 1 5.05-.16 14.6 14.6 0 0 1 7.18 3.1c2.31 1.9 3.55 4.37 3.81 7.33.06.77 0 1.53 0 2.28"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#6BD1B7",
      d: "M147.47 99.5a45.5 45.5 0 0 1-7.24 25 57 57 0 0 1-15.55 16.26 86 86 0 0 1-8.58 5.47q-.4.24-.8.52-.76.55-.62 1.48c.43 2.69.31 5.42.21 8.1-.23 5.8-.98 11.52-2.78 17.08a33 33 0 0 1-6.39 11.46 26 26 0 0 1-5.13 4.68 24 24 0 0 1-13.25 4.3c-2.77.05-5.53-.03-8.23-.76a26 26 0 0 1-9.47-4.9c-4.34-3.46-6.94-8.04-8.44-13.32a93 93 0 0 1-2-9.58c-.6-3.56.06-2.83-3.31-2.38-2.94.4-5.86.75-8.82.56a50 50 0 0 1-16.95-4.05 50 50 0 0 1-10.98-6.53 40.5 40.5 0 0 1-11.27-13.51 38 38 0 0 1-3.43-9.55c-.87-4.07-.85-8.14.3-12.13 1.3-4.59 4.02-8.07 8.38-10.14a15 15 0 0 1 5.64-1.37c2.8-.11 5.5.34 8.17 1.13 3.43 1.03 6.7 2.5 10.04 3.8q2.2.84 4.42 1.66.35.1.73.15c.24.04.5-.3.4-.51q-.29-.7-.64-1.36-1.56-3.11-3.15-6.23a46 46 0 0 1-4.15-11.7c-.31-1.54-.45-3.1-.65-4.66q-.11-.94-.16-1.88c-.02-.32-.1-.63-.07-.93.23-2.31.27-4.64.86-6.92A20.2 20.2 0 0 1 46.2 64.97c4.38-2.02 9.02-2.51 13.81-1.96 2.7.32 5.33.83 7.91 1.66a39 39 0 0 1 12.43 6.58 48 48 0 0 1 12.27 14.67c.93 1.7 1.76 3.48 2.65 5.22q.29.6.65 1.14c.06.1.41.12.47.04q.69-.77 1.28-1.62c1.58-2.27 3.12-4.56 4.72-6.84a46 46 0 0 1 5.95-7.05 24 24 0 0 1 11.45-6.25 18.5 18.5 0 0 1 13.63 2.1 25.7 25.7 0 0 1 9.7 10.06 35 35 0 0 1 4.2 13.02c.15 1.4.1 2.87.15 3.76"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#272727",
      d: "m61.6 211.67 2.32 9.54c.51 2.16.83 4.33.69 6.54a8 8 0 0 1-.38 2.22c-.8 2.39-3.03 3.46-5.44 2.63a7.5 7.5 0 0 1-3.2-2.28q-1.29-1.51-1.99-3.4a20 20 0 0 1-1.22-5.5c-.3-3.8-.16-7.56.8-11.25.32-1.2.78-2.4 1.27-3.54a7 7 0 0 1 1.26-1.86c1.26-1.3 2.9-1.24 4.13.1a4.2 4.2 0 0 1 1.16 2.92c-.02.95.43 1.35 1.24 1.6 1.13.38 2.23.84 3.38 1.2q3.73 1.15 6.21-1.93a18 18 0 0 0 3.18-5.75c.77-2.27 1.24-4.6 1.53-7l.77-6.36q.07-.35.2-.7c.02-.05.1-.1.14-.1.12.01.28.01.32.1.17.39.37.8.45 1.22q.18.92.2 1.88c.11 4.42-.26 8.8-1.74 13.02a18 18 0 0 1-3.73 6.28 7.6 7.6 0 0 1-4.16 2.41 7.2 7.2 0 0 1-4.24-.49c-1-.41-2-.95-3.16-1.5M76.72 80.1q.37 3.94.02 7.83-.11 1.25-.33 2.47c-.1.58-.42 1.43-.63 2.02q-.23.62-.62 1.17l-1.46 2.15c-.49.71-1.44 1.74-2.15 2.25-2.17 1.6-4.28 1.72-6.96.66a13 13 0 0 1-2.88-1.74c-2.82-2.14-5.2-4.73-7.56-7.38-1.5-1.7-2.86-3.51-4.26-5.27-.1-.12-.08-.32-.06-.5 0-.04.22-.08.34-.08 3.75.38 7.5.8 11.24 1.11 2.33.2 4.64.14 6.9-.5A9 9 0 0 0 74.54 79q.62-1.5 1.26-2.94.07-.11.22-.16c.16-.08.36.04.38.22q.15 2 .33 3.99M54.15 73.19q1.7.02 3.24.77c1.77.87 3.23 2.14 4.5 3.64.15.18.25.43.35.65.04.1-.02.28-.1.32-.14.08-.35.15-.47.1-.28-.14-.51-.36-.77-.54-.99-.67-1.93-1.38-2.94-2.01a6.4 6.4 0 0 0-2.8-1.01c-1.82-.2-2.86.37-3.61 2.01-.34.75-.55 1.54-.85 2.3-.36.9-.9 1.32-1.46 1.16q-.78-.22-.8-1.54c-.13-2.53 1.79-6.05 5.71-5.85M66.15 71.89q-.05.7.14 1.38.18.7.41 1.48.28.9.51 1.8c.02.08-.08.26-.15.32-.08.04-.24.02-.34-.02a1 1 0 0 1-.28-.24 13 13 0 0 1-1.91-4.45c-.37-2.11 1.07-3.57 3.18-3.2q1.99.37 3.5 1.68c.32.28.58.65.82 1.01.17.28.2.6-.02.87-.26.34-.63.45-1 .3-.52-.22-1.02-.5-1.5-.75-.5-.28-.98-.6-1.47-.83-.27-.14-.59-.18-.9-.22-.58-.08-.93.26-1 .85z"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#DDD8FE",
      d: "M179.8 115.46s-.08-.17.18-.65a35 35 0 0 0 2.92-9.27c.43-2.47.67-4.98.4-7.5-.09-.8-.07-1.6-.13-2.4q-.64-9.87-3.73-19.27l-.43-1.26c-1.2.22-2.8.31-4.02.28a10 10 0 0 1-3.77-.85 12.5 12.5 0 0 1-7.4-8.82 6 6 0 0 1 .45-3.93 4.34 4.34 0 0 1 5.2-2.33 9.2 9.2 0 0 1 4.35 2.96 29 29 0 0 1 4.76 7.83l1.24 3.1a20 20 0 0 0 5.92-4c3.39-3.51 5.6-7.72 7.26-12.26 1.14-3.13 1.9-7.87 2.36-11.15 0 0-.23-.16-.59-.36q-.56-.3-1.12-.63a46 46 0 0 1-14.05-12 42.6 42.6 0 0 1-8.3-18.45 43 43 0 0 1-.6-4.2q-.26-3.05.64-6 .33-1.06.92-2a4.9 4.9 0 0 1 3.99-2.29c2.05-.1 3.87.53 5.52 1.66 2 1.36 3.67 3.06 5.15 4.96 3.16 4 5.45 8.44 7.04 13.26a60 60 0 0 1 2.65 12.2c.41 3.61.45 7.23.35 10.84l-.06 2.08.8.36.33.13a37.5 37.5 0 0 0 15.17 3.25c3.21 0 6.33-.64 9.37-1.63a63 63 0 0 0 10.04-4.03 1 1 0 0 1 .24-.08c.16-.04.25.16.14.26-.81.8-1.58 1.32-2.41 1.8a39 39 0 0 1-14.13 4.96 31 31 0 0 1-10.06-.42 42 42 0 0 1-7.8-2.29q-.64-.27-1.3-.5l-.5-.17c-.28 1.56-.66 4.1-1 5.65-1 4.79-2.66 9.31-5.32 13.44a24 24 0 0 1-4.62 5.46 22 22 0 0 1-5.64 3.41s.12.22.4 1.11q.5 1.68.98 3.36a85 85 0 0 1 2.37 11.52q.81 5.77.44 11.58a29 29 0 0 1-3.4 11.56c-.22.44-.53.84-.8 1.23-.26.5-.4.5-.4.5m15.8-76.36c.14-4.68-.37-9.3-1.42-13.85a50 50 0 0 0-6.43-15.95 25 25 0 0 0-5.7-6.42 11 11 0 0 0-3.53-1.92c-3-.85-5.07.33-6.1 2.88q-.26.7-.43 1.4c-.56 2.06-.5 4.16-.24 6.21.65 5.16 2.33 10 4.87 14.55a47 47 0 0 0 11.48 13.52 40 40 0 0 0 7.46 4.72c.02-1.4.04-3.72.04-5.14m-19.94 34.86c1.6-.04 2.78-.25 2.78-.25-1.05-2.83-2.5-6.39-4.24-8.88-.77-1.1-1.7-2.1-2.8-2.88a5.5 5.5 0 0 0-2.85-1.19c-1.42-.1-2.3.48-2.86 1.8a5.3 5.3 0 0 0-.17 3.26c.96 4 4.99 8.24 10.14 8.14M257.4 51.5a5.7 5.7 0 0 1-3.03-1.13c-4.05-3.22-8.01-6.5-11.56-10.3a67 67 0 0 1-6.69-8.22q-.5-.77-.97-1.56c-.33-.62-.11-1.03.64-1.1 1.28-.15 2.56-.33 3.84-.36 6.41-.26 12.65-1.59 18.84-3.09 4.9-1.18 9.67-2.7 14.27-4.76l.55-.24c.77-.37 1.4-.18 2.03.4q3.52 3.27 7.08 6.46a94 94 0 0 0 9.33 7.23q3.3 2.24 6.6 4.45.67.44-.03.95-.49.36-1.04.63a72 72 0 0 1-8.37 3.7 141 141 0 0 1-21.05 5.49c-3.4.67-6.92.99-10.43 1.44"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#9371F2",
      d: "M246.58 31.16a76 76 0 0 1-2.37-2.69q-2.25.27-4.54.36c-1.28.05-2.56.21-3.85.35-.75.08-.98.48-.63 1.1q.46.8.97 1.57a65 65 0 0 0 6.69 8.22c3.53 3.8 7.51 7.08 11.56 10.3a6 6 0 0 0 3.04 1.12c3.49-.45 7.02-.77 10.47-1.42l1.09-.2a37 37 0 0 1-2.53-1.6c-7.14-5.14-13.9-10.69-19.9-17.11M272.22 25.98c.36.12 1.36.34 2.21.77 2.31 1.2 2.63 3.66.73 5.22q-.68.57-1.56.9a10 10 0 0 1-6.88.2c-2.92-.96-3.55-3.63-1.36-5.49 1.66-1.4 3.65-1.92 6.86-1.6"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#DDD8FE",
      d: "M248.43 40.23c.14.08.35.18.5.28q.81.66 1.57 1.36a295 295 0 0 1 4.38 4.25q.4.4.67.79c.08.12.02.3-.08.35a1 1 0 0 1-.57 0 3 3 0 0 1-.73-.37c-2.39-1.84-4.5-3.78-5.94-5.93q-.18-.28-.23-.55c-.02-.06.1-.14.17-.18q.1-.02.26 0"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#9371F2",
      d: "M289.07 40.2c-.22.07-.41.2-.61.17-.4-.06-.85-.14-1.14-.32-2.7-1.66-5.47-3.28-7.64-5.26-.26-.23-.43-.5-.63-.75-.06-.08-.06-.27 0-.3.2-.03.5-.07.67 0q.98.43 1.85.97 3.1 2.02 6.18 4.06c.43.27.77.63 1.12.94.12.12.12.3.2.5M284.81 41.63c-.22.08-.36.2-.45.18a3 3 0 0 1-.93-.28c-2.74-1.56-5.39-3.2-7.48-5.18-.25-.23-.53-.47-.67-.73-.1-.18-.14-.45 0-.59.2-.22.57-.06.85.08q.63.31 1.18.7 3.47 2.52 6.87 5.09c.27.2.41.47.63.73"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#DDD8FE",
      d: "M252.4 40.23c.21.12.53.24.75.4a68 68 0 0 1 6.5 5.57q.16.13.17.3c0 .07-.05.17-.14.21a1 1 0 0 1-.42 0 2 2 0 0 1-.65-.26c-2.52-1.64-4.81-3.38-6.43-5.37a3 3 0 0 1-.36-.6c-.03-.07 0-.2.08-.23.08-.04.28-.02.5-.02"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#9371F2",
      d: "M271.2 35.86c.2.08.43.14.6.26q.97.61 1.84 1.26 2.9 2.29 5.72 4.6c.34.28.58.58.87.87q.04.06.08.16c-.16.02-.33.08-.45.04q-.47-.14-.87-.37a37 37 0 0 1-7.83-5.7 3 3 0 0 1-.56-.77c-.04-.07.04-.21.14-.27.08-.06.26-.06.46-.08"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#FFE86F",
      d: "M88.7 47.36a.3.3 0 0 0-.28-.37q-1.22-.01-2.4-.08c-1.2-.08-2.35-.22-3.54-.36q-.29-.04-.55-.2c-.1-.06-.22-.17-.24-.3-.02-.07.12-.23.2-.25.71-.12 1.42-.28 2.13-.3q1.95-.04 3.95-.02h.02c.53 0 .82-.6.49-1.02-.77-1-1.58-1.96-2.3-2.99-.25-.31-.7-.57-.74-.99a.29.29 0 0 1 .44-.27c.31.2.65.37.9.63q1.38 1.41 2.72 2.85.25.24.58.49c.17.14.41.04.47-.16.47-2.17.18-4.35.73-6.52.08-.28.45-.3.55-.04.38.97.2 1.96.28 2.9.08 1.03.08 2.06.1 3.23 0 .21.23.35.43.23q.36-.18.65-.41 1.62-1.29 3.24-2.57c.35-.28.77-.5 1.16-.73.06-.04.2.08.3.14.04.02.06.14.04.18-.1.23-.14.5-.3.7q-.75.91-1.58 1.75c-.69.69-1.42 1.36-2.1 2.05-.1.1-.13.34-.13.51 0 .06.2.16.32.16l1.78.04q1.27.04 2.54.14c.24.02.61.04.53.4-.04.17-.35.35-.57.4q-1.65.23-3.31.4-.7.07-1.54.07a.29.29 0 0 0-.22.47l.38.45c.88 1.05 1.8 2.1 2.66 3.17.31.4.53.89.77 1.36.04.06-.08.22-.16.32-.02.04-.14.04-.18 0-.49-.32-1.02-.6-1.46-.97-.92-.83-1.8-1.74-2.68-2.61-.08-.08-.28-.18-.34-.14-.11.1-.27.26-.27.4q-.2 2.25-.36 4.52c-.02.32-.13.63-.23.95-.02.04-.1.12-.14.12-.12-.02-.3-.04-.32-.1q-.26-.94-.43-1.9c-.08-.51-.06-1.04-.1-1.58l-.18-2.74c0-.02-.14-.06-.17-.04-.72.55-1.43 1.14-2.16 1.68-.9.65-1.67 1.48-2.8 1.77-.13.04-.35-.06-.49-.15-.04-.02-.02-.28.06-.36q1.51-1.68 3.04-3.36c.23-.3.65-.5.8-.95M104.7 23.15c1 0 1.87.91 1.81 1.9a2.04 2.04 0 0 1-2.03 1.94 1.77 1.77 0 0 1-1.72-1.76c.02-1.11.95-2.08 1.94-2.08M87.22 32.32c.04.6-.48 1.15-1.09 1.17s-1.1-.46-1.12-1.1c-.02-.66.45-1.17 1.04-1.2.6 0 1.15.52 1.17 1.13"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#F1D01F",
      d: "M157.98 104.22c.53.02.9.43.93 1 .02.56-.42 1.03-.93 1.02s-.93-.48-.93-1.03c0-.6.4-1.01.93-1M163.96 109.95c-.18 2.03-.08 7.15 4.97 8.56.12.04.14.2.02.23-4.52 1.76-5.1 6.19-5.15 7.61 0 .12-.18.18-.24.06-.85-1.3-4-5.33-9.07-2.92-.12.06-.24-.08-.16-.2a8.5 8.5 0 0 0-.02-9.53c-.08-.1.04-.23.16-.2 1.46.56 6.45 1.92 9.27-3.7.04-.1.24-.05.22.09M1.1 6.99A1.1 1.1 0 0 1 0 5.88c0-.57.51-1.09 1.13-1.1.6-.03 1.06.45 1.06 1.12 0 .65-.43 1.1-1.08 1.09M3.45 34.56c1.66-2.81 5.1-10.26-1.2-15.8-.16-.13-.04-.37.16-.35 7.73.63 11.62-5.36 12.7-7.37.1-.18.38-.14.4.08.31 2.47 2.05 10.47 11.03 10.57.21 0 .3.28.1.4-7.2 4.28-6.91 11.46-6.6 13.73.02.2-.21.32-.35.18-1.74-1.82-7.95-7.27-15.92-1.13-.18.1-.43-.12-.32-.31"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#272727",
      d: "M216.57 229.83c.26-6.03 1.05-12 2.08-17.94a8 8 0 0 1 .49-1.66c.08-.18.41-.36.61-.34.22.02.47.24.57.44q.21.54.22 1.12-.02 1.65-.12 3.3c-.4 6.6-1 13.18-1.03 19.78l-.01.58c-.03.5.07.89.57 1.12q.35.16.65.42c1.1.93 1.16 2.21.04 3.16-.63.53-1.38 1-2.15 1.27-1.23.37-2.5.69-3.8.77-2.99.18-5.9-.36-8.71-1.48a9 9 0 0 1-1.9-.97 5 5 0 0 1-1.36-1.35c-1.08-1.64-.37-3.44 1.54-3.95a9 9 0 0 1 3.48-.22l7.5.95q.19.03.39.04c.77.08.94-.08.96-.81v-.2q-.03-1.98-.02-4.03M187.04 148.29q.17.05.22.1.3.8.53 1.64c.02.08-.1.26-.2.31-2.7 1.9-4.93 4.3-7.14 6.72-.08.08-.27.2-.33.16-.16-.1-.32-.23-.36-.4-.08-.3-.08-.64-.12-.96-.23-2.4-.23-2.4 1.64-3.97a26 26 0 0 1 5.25-3.44q.28-.11.51-.16"
    }
  ),
  /* @__PURE__ */ r.jsx("path", { fill: "#B5A0F1", d: "m184 179.51 14.82-11.72a.52.52 0 0 0-.1-.86l-18.59-8.64 3.18 20.57z" }),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#5239BA",
      d: "M191.78 166.2c-.8-.48-1.64-.83-2.49-1.21-1.91-.85-5.39-2.45-7.4-3.26 0 0 0-.38-.14-1.5-.3-2.61-.65-5.22-.96-7.83q-.46-3.82-.87-7.65c-.08-.67-.38-1.08-1.05-1.24-.88-.22-41.94-13.14-45.67-14.17-.75-.2-1.14.1-1.18 1.1.04.34.12.91.22 1.5 1.08 6.69 2.19 14.69 3.3 21.39.29 1.82.66 3.62.88 5.45.14 1.13.69 1.8 1.72 2.18l.73.31 5.97 2.51c3.8 2.65 18.7 9.1 22.63 9.2l16.57 6.58-.3-4.35s.13-.18 1.1-.77q3.69-2.29 7.2-4.83c3.03-2.27 2.64-1.72-.26-3.42m-6.32-.66.48-.35c.49-.48 1.02-.5 1.61-.16q.62.31 1.23.61c.08.04.1.22.16.34-.06.12-.1.26-.18.33q-.55.44-1.07.87-.76.66-1.62.1c-.1-.08-.23-.1-.35-.16-1.2-.6-1.24-.8-.26-1.58m-2.96-.25c-.13-.62-.15-1.27-.17-1.9 0-.12.23-.24.41-.4.73.34 1.44.64 2.13 1 .26.13.28.45.08.66q-.54.56-1.16 1.01c-.48.34-1.15.16-1.29-.37m.48 4.23a9 9 0 0 1-.14-1l.04-.76c.04-.28.43-.56.73-.52q.21.01.37.08c.58.28 1.46.3 1.6.97.18.75-.77.9-1.2 1.34-.14.14-.34.22-.5.3-.39.2-.82.02-.9-.41m2.52 3.34q-.7.51-1.46.96c-.27.16-.51.02-.57-.3q-.13-.77-.24-1.48c0-.45.46-.75.85-.55q.7.34 1.38.73c.26.12.28.48.04.64m3.65-2.51c-.51.4-1 .8-1.56 1.14-.25.16-.67.24-.9.14-.62-.28-1.4-.32-1.72-1.09q.63-.56 1.26-1.14.89-.87 1.94-.24c.33.2.69.34 1.02.53.08.04.08.22.12.34-.04.1-.06.26-.16.32m1.78-1.19c-.1.06-.26.04-.58.1l-1.85-1.1c.06-.8.83-.96 1.26-1.41a1 1 0 0 1 1.27-.18c.65.38 1.55.3 1.93 1.13-.5.73-1.3 1.05-2.03 1.46"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#75ABF7",
      d: "M229.22 169c-7.73-.12-15.31-.97-22.67-3.18a42 42 0 0 1-14.03-7.07 21 21 0 0 1-6.49-8.98c-1.02-2.55-1.75-5.16-1.65-7.92.12-3.56 1.65-6.48 4.36-8.86 2.28-2 5.05-3.18 7.9-4.17a59 59 0 0 1 9.95-2.4c4.04-.68 8.1-1.03 12.21-1.25 3.5-.18 6.97-.48 10.44-.77 5.54-.5 11.03-1.39 16.49-2.5 3.8-.76 7.64-1.46 11.5-1.83 1.68-.16 3.34-.36 5.01-.28 7.06.3 13 2.93 17.72 8.03 1.56 1.68 2.43 3.71 3.12 5.83 1.89 5.73.92 11.1-2.37 16.16-2.74 4.2-6.47 7.4-10.75 10.06-3.6 2.25-7.56 3.64-11.62 4.8a115 115 0 0 1-15.31 3.26q-6.91.96-13.81 1.07M231.66 214.48c-4.93.07-8.46-.28-12.01-.64a75 75 0 0 1-11.07-1.95 36 36 0 0 1-14.26-7.2 27 27 0 0 1-5.78-6.78 14 14 0 0 1-1.64-5.1c-.28-1.95-.37-3.97.1-5.92.75-3.17 2.76-5.48 5.49-7.26 2.78-1.8 5.9-2.86 9.09-3.7a73 73 0 0 1 12.05-2.05c4.54-.4 9.08-.57 13.63-.75 6.2-.26 12.41-.24 18.6-.4 3.56-.1 7.15-.1 10.68-.45 3.4-.34 6.73.02 10.08.24 3.97.26 7.83 1.13 11.37 3a18.5 18.5 0 0 1 6.56 5.44c3.2 4.42 3.71 9.13 1.38 13.99a23 23 0 0 1-10.13 10.45 61 61 0 0 1-11.9 4.67 115 115 0 0 1-12.9 2.86c-2.67.44-5.37.62-8.05.95-4.2.48-8.43.42-11.29.6"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#272727",
      d: "M261.65 241.06c-1.6-.14-3.3-.12-4.91-.71-.6-.22-1.2-.54-1.66-.95-1.04-.97-.93-2.31.22-3.19.35-.27.77-.47 1.16-.69 1.03-.57 1.05-.59.71-1.62-1.3-3.95-1.97-8.04-2.78-12.11-.55-2.79-.98-5.61-1.4-8.44-.14-.89-.06-1.8-.04-2.7 0-.28.61-.46.8-.22.25.35.54.73.66 1.14q.64 1.93 1.13 3.91 1.93 8.04 3.86 16.07.29 1.13.65 2.23c.12.42.4.64.87.56l5.37-.75c.96-.14 1.91-.36 2.88-.46 1.1-.12 2.19.12 3.21.56q.55.23.97.63c1.03.95 1.1 2.21.24 3.3a5 5 0 0 1-2.2 1.56q-1.53.6-3.13 1.03c-2.15.55-4.34.7-6.6.85M217.34 146.24c-2.54.07-4.81-.74-6.8-2.26a22 22 0 0 1-2.5-2.21c-.46-.46-.74-1.07-1.05-1.64-.08-.14-.02-.42.05-.53.22-.32.48-.08.66.07 1 .83 1.97 1.74 3.01 2.53 3.65 2.81 7.58 3.05 11.66 1.15a28 28 0 0 0 6.02-4.07q.6-.52 1.2-1.03c.2-.16.5-.34.65-.04.1.18.06.52-.03.71q-.28.53-.7.95a25 25 0 0 1-6.52 5 11 11 0 0 1-5.65 1.37M207.76 131.6a6 6 0 0 1 3.43 1.24c1.66 1.26 2.7 3 3.53 4.86.02.04 0 .15-.04.17-.1.04-.26.1-.31.06q-.74-.66-1.44-1.32c-.77-.7-1.52-1.46-2.35-2.08-1.82-1.34-3.48-1.22-5.15.3-.57.53-1.07 1.17-1.6 1.72q-.42.41-.87.77c-.25.2-.7-.04-.75-.35-.02-.26-.06-.54 0-.78a6.4 6.4 0 0 1 4.95-4.52q.27-.04.6-.06M234.66 133.17c-.02.56-.53.9-.86.71-.46-.23-.9-.55-1.35-.79-.75-.4-1.48-.85-2.26-1.12-1.68-.58-3.22-.16-4.6.93a10 10 0 0 0-2.5 3.24c-.24.45-.46.94-.74 1.38-.07.14-.41.28-.47.24a1.4 1.4 0 0 1-.35-.6 1 1 0 0 1 .1-.57 11 11 0 0 1 4.24-5.51c2.3-1.47 4.69-1.43 7.08-.16.65.33 1.2.83 1.52 1.48.13.3.15.63.2.77M283.8 84.52c.54-2.97 2.9-4.55 5.9-3.26.62.27 1.05.92 1.05.92 1.66-1.91 4.32-1.18 5.86.08a9.3 9.3 0 0 1 3.25 5.8c.36 2.13 0 4.16-.88 6.12-2.53 6.17-7.87 6.96-7.87 6.96.5 3.61-.62 9.62-1.3 13.22-2.12 11.18-6.63 19.39-15.6 26.32-.66.52-1.41.91-2.16 1.33a1.6 1.6 0 0 1-.81.15c-.14 0-.32-.11-.4-.25-.07-.12-.1-.36-.01-.46q.35-.47.78-.87 1.11-1.03 2.25-2.07c4.9-4.55 8.35-10.08 10.8-16.27a56 56 0 0 0 3.56-16.02c.32-2.75.1-4.77.1-4.77s-3.11.38-6.39-1.22a6 6 0 0 1-2.23-2.04 4.2 4.2 0 0 1 .93-5.41s-3.45-.73-3.06-5.75q.06-.76.36-1.49a3.14 3.14 0 0 1 4-1.9c.61.22 1.2.58 1.88.88"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#fff",
      d: "M153.68 142.18c.7.12 1.42.42 1.97 1.07.95 1.15.5 2.55-.92 2.99-.95.3-2.47-.32-3.02-1.17-.4-.61-.52-1.27-.2-1.94s.95-.93 1.66-.97c.14 0 .27 0 .51.02"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#272727",
      d: "M237.64 249.6c29.08 0 52.66-3.47 52.66-7.75s-23.58-7.75-52.66-7.75-52.65 3.47-52.65 7.75 23.57 7.75 52.65 7.75M83.17 249.61c26.53 0 48.04-3.16 48.04-7.07 0-3.9-21.5-7.08-48.04-7.08s-48.03 3.17-48.03 7.08c0 3.9 21.5 7.07 48.03 7.07",
      opacity: 0.07
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#272727",
      d: "M158.7 175.84c4.77 4.96 8.75-2.9 8.75-2.9l-7.36-2.97c-1.75-11.44-6.03-13.97-6.59-11q-.04.2.02.43a64 64 0 0 1 1.3 7.31c.02.1-.11.14-.15.04-2.78-6-6.28-11.52-7.76-8.14a1 1 0 0 0 .02.83c1.07 2.11 2.75 5.71 3.2 6.68a.09.09 0 0 1-.12.12 46 46 0 0 0-4.8-2.42c-3.94-1.56-8.46 1.39-4.3 3.15 10.66 4.48 10.07 9.17 13.32 7.11 2.45 3.44 4.46 1.76 4.46 1.76"
    }
  )
] }), Fc = (e) => /* @__PURE__ */ r.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 205, height: 81, fill: "none", viewBox: "0 0 205 81", ...e, children: [
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M112.1 62.16v-22.2h-10.36v22.2h-5.45v-22.2h-4v-4.4h4V30.9c0-5.63 3.42-8.96 8.8-8.96q1.54 0 3 .49l-.96 4.72a6 6 0 0 0-1.82-.27c-2.19 0-3.58 1.45-3.58 4.13v4.55h15.8v26.6zm-.38-30.83v-6.17h6.19v6.17zm18.68-6.7v19.89l9.02-8.96h6.68l-9.35 9.23 10.95 17.37h-6.36l-8.48-13.51-2.46 2.47v11.04h-5.44V24.63zm43.99 25.41H153.4c.21 4.72 3.36 8.1 8.06 8.1 4.32 0 6.35-2.36 7.9-5.52l4.22 2.52c-2.46 5.1-6.3 7.77-12.28 7.77-7.26 0-13.35-5.73-13.35-14.05 0-8.3 6.09-14.05 13.61-14.05 7.7 0 12.82 5.53 12.82 13.3zm-12.92-10.83c-3.95 0-7.05 2.79-8.06 6.65h15.8c-.43-4.34-4.06-6.65-7.74-6.65M204 44.1v18.07h-5.44V45.7c0-3.65-2.14-5.85-5.87-5.85-3.8 0-6.94 3.22-6.94 8.26v14.05h-5.45v-26.6h5.45v4.46a10.5 10.5 0 0 1 9.02-5.2c5.18 0 9.23 3.26 9.23 9.27",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#75ABF7",
      fillRule: "evenodd",
      d: "M30.2 37.28a7 7 0 0 1-4.93-2.03 6.8 6.8 0 0 1-2.04-4.87V27.7C23.22 12.7 35.51.54 50.71.49c5.48 0 10.84 1.62 15.37 4.65a6.84 6.84 0 0 1 1.8 9.51 7.05 7.05 0 0 1-9.6 1.94 13.5 13.5 0 0 0-7.57-2.29A13.5 13.5 0 0 0 37.2 27.7v2.69c0 1.83-.73 3.58-2.04 4.87a7 7 0 0 1-4.94 2.03",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M53.41 43.76H37.18V27.7a6.9 6.9 0 0 0-3.42-6.16 7 7 0 0 0-7.11 0 6.9 6.9 0 0 0-3.42 6.16v16.06H7c-3.87 0-7 3.1-7 6.9 0 3.82 3.13 6.9 7 6.9h16.23v16.07a6.9 6.9 0 0 0 3.44 6.1 7 7 0 0 0 7.07 0 6.9 6.9 0 0 0 3.44-6.1V57.56h16.23c3.87 0 7-3.09 7-6.9s-3.13-6.9-7-6.9",
      clipRule: "evenodd"
    }
  )
] }), Sf = (e) => /* @__PURE__ */ r.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 69, height: 80, fill: "none", viewBox: "0 0 69 80", ...e, children: [
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#75ABF7",
      fillRule: "evenodd",
      d: "M30.05 36.6a7 7 0 0 1-4.91-2.02 6.8 6.8 0 0 1-2.03-4.86v-2.65C23.1 12.16 35.32.05 50.44 0a27.4 27.4 0 0 1 15.3 4.63 6.8 6.8 0 0 1 1.79 9.45 7 7 0 0 1-9.56 1.93 13.5 13.5 0 0 0-7.53-2.28A13.4 13.4 0 0 0 37 27.07v2.67a6.8 6.8 0 0 1-2.03 4.85 7 7 0 0 1-4.91 2.01",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M53.13 43.04H36.98V27.07a6.8 6.8 0 0 0-3.4-6.12 7 7 0 0 0-7.07 0 6.8 6.8 0 0 0-3.4 6.12v15.98H6.96A6.9 6.9 0 0 0 0 49.92c0 3.79 3.12 6.86 6.96 6.86h16.15v15.98a6.8 6.8 0 0 0 3.42 6.06 7 7 0 0 0 7.04 0 6.8 6.8 0 0 0 3.42-6.06V56.77h16.14a6.9 6.9 0 0 0 6.97-6.87c0-3.79-3.12-6.86-6.97-6.86",
      clipRule: "evenodd"
    }
  )
] }), Bc = (e) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 50,
    fill: "none",
    "aria-label": "Fiken Logo",
    viewBox: "0 0 128 50",
    ...e,
    children: [
      /* @__PURE__ */ r.jsx(
        "path",
        {
          fill: "#75ABF7",
          fillRule: "evenodd",
          d: "M18.93 22.94a4.4 4.4 0 0 1-3.1-1.27 4.3 4.3 0 0 1-1.27-3.04v-1.66C14.55 7.62 22.26.03 31.78 0c3.43 0 6.79 1 9.63 2.9a4.25 4.25 0 0 1 1.13 5.93 4.43 4.43 0 0 1-6.02 1.2 8.5 8.5 0 0 0-4.74-1.42 8.43 8.43 0 0 0-8.48 8.36v1.67c0 1.14-.46 2.23-1.28 3.04a4.4 4.4 0 0 1-3.09 1.26",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          fill: "#5239BA",
          fillRule: "evenodd",
          d: "M33.47 26.98H23.3V16.97a4.3 4.3 0 0 0-2.14-3.84 4.4 4.4 0 0 0-4.46 0 4.3 4.3 0 0 0-2.14 3.84v10.01H4.39A4.35 4.35 0 0 0 0 31.28c0 2.38 1.96 4.31 4.39 4.31h10.17v10.02a4.3 4.3 0 0 0 2.15 3.8c1.37.79 3.07.79 4.44 0a4.3 4.3 0 0 0 2.15-3.8V35.58h10.17a4.35 4.35 0 0 0 4.39-4.3c0-2.38-1.97-4.3-4.39-4.3M70.4 37.3V23.46h-6.5V37.3h-3.4V23.46h-2.51v-2.74h2.5v-2.9c0-3.52 2.15-5.6 5.53-5.6q.96 0 1.87.3l-.6 2.95q-.6-.18-1.14-.17c-1.37 0-2.24.9-2.24 2.58v2.84h9.9V37.3zm-.24-19.22v-3.85h3.88v3.85zm11.71-4.18v12.4l5.66-5.58h4.18l-5.86 5.75 6.86 10.83h-3.98l-5.32-8.42-1.54 1.54v6.88h-3.4V13.9zm27.57 15.85H96.29c.13 2.94 2.1 5.05 5.05 5.05 2.71 0 3.98-1.47 4.95-3.45l2.64 1.57c-1.53 3.18-3.94 4.85-7.69 4.85-4.55 0-8.36-3.58-8.36-8.76s3.81-8.76 8.53-8.76c4.82 0 8.03 3.45 8.03 8.3zm-8.1-6.76c-2.48 0-4.42 1.74-5.05 4.15h9.9c-.27-2.7-2.54-4.15-4.85-4.15M128 26.04V37.3h-3.41V27.04c0-2.27-1.34-3.65-3.68-3.65-2.38 0-4.35 2.01-4.35 5.15v8.76h-3.41V20.72h3.41v2.78a6.6 6.6 0 0 1 5.65-3.25c3.25 0 5.8 2.04 5.8 5.79",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Dc = (e) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    fill: "none",
    "aria-label": "Fiken Logo",
    viewBox: "0 0 28 32",
    ...e,
    children: [
      /* @__PURE__ */ r.jsx(
        "path",
        {
          fill: "#75ABF7",
          fillRule: "evenodd",
          d: "M12.46 15.17c-.72 0-1.4-.28-1.91-.78-.5-.5-.8-1.18-.8-1.89v-1.03C9.76 5.67 14.52.97 20.4.94c2.13 0 4.2.63 5.96 1.8a2.64 2.64 0 0 1 .7 3.68 2.74 2.74 0 0 1-3.72.75 5.3 5.3 0 0 0-2.94-.88 5.2 5.2 0 0 0-5.24 5.18v1.04c0 .7-.28 1.38-.79 1.88-.5.5-1.19.79-1.9.79",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          fill: "#5239BA",
          fillRule: "evenodd",
          d: "M21.45 17.68h-6.29v-6.2a2.7 2.7 0 0 0-1.32-2.39c-.85-.5-1.9-.5-2.76 0s-1.35 1.41-1.32 2.38v6.22H3.47a2.7 2.7 0 0 0-2.71 2.67 2.7 2.7 0 0 0 2.71 2.67h6.29v6.21c-.02.97.49 1.87 1.33 2.36s1.9.49 2.74 0a2.7 2.7 0 0 0 1.33-2.36v-6.22h6.3a2.7 2.7 0 0 0 2.7-2.67 2.7 2.7 0 0 0-2.7-2.67",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Pc = ({
  containerType: e = Se.XL,
  className: t = "",
  style: n = {},
  ...o
}) => {
  const s = Ot("fiken-promo");
  return /* @__PURE__ */ r.jsx(Le, { ...o, type: e, className: `${Kn.fikenPromo} ${t}`, style: n, children: /* @__PURE__ */ r.jsx(we, { children: /* @__PURE__ */ r.jsxs(se, { className: Kn.column, children: [
    /* @__PURE__ */ r.jsxs("div", { children: [
      /* @__PURE__ */ r.jsx("h2", { children: "Superenkelt regnskap for små bedrifter" }),
      /* @__PURE__ */ r.jsx("p", { children: "Med Fiken er det superenkelt for små bedrifter å gjøre regnskapet selv! Innleveringer til Skatteetaten og Altinn er gjort på et blunk, og vi passer på at regnskapet blir riktig." }),
      /* @__PURE__ */ r.jsx(Rr, { param: s }),
      /* @__PURE__ */ r.jsxs("p", { children: [
        "Allerede registrert? ",
        /* @__PURE__ */ r.jsx(Dr, { hasTextDecoration: !0, param: s })
      ] })
    ] }),
    /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(Rc, {}) })
  ] }) }) });
}, $f = ({
  containerType: e = Se.XL,
  background: t = "var(--fiken-color-grey-200)",
  className: n = "",
  style: o = {},
  ...s
}) => {
  const [l, a] = A(45);
  return G(() => {
    const { clientWidth: c } = document.documentElement;
    a(c * 45 / 1440);
  }, []), /* @__PURE__ */ r.jsx(
    Sr,
    {
      curveHeight: Math.min(l, 45),
      edge: ce.INVERTED_TOP,
      backgroundColor: t,
      className: n,
      style: o,
      ...s,
      children: /* @__PURE__ */ r.jsx(Pc, { containerType: e })
    }
  );
}, Hc = ({ param: e }) => /* @__PURE__ */ r.jsxs(se, { types: [ue.TWELVE, pe.FOUR], children: [
  /* @__PURE__ */ r.jsx("h3", { children: "Regnskap enkelt forklart" }),
  /* @__PURE__ */ r.jsx("p", { children: "På bloggen vår svarer vi på alt fra hva som er årets MVA-terminer, til hvordan skatt fungerer for enkeltpersonforetak." }),
  /* @__PURE__ */ r.jsx(ne, { href: `https://blogg.fiken.no/${e}`, children: "Lær mer om regnskap" })
] }), Vc = "_fikenMottoParagraph_1ihuq_1", qc = {
  fikenMottoParagraph: Vc
}, Pr = () => /* @__PURE__ */ r.jsx("p", { className: qc.fikenMottoParagraph, children: "Superenkelt regnskap for små bedrifter" }), Wc = "_footerBanner_2wtcq_1", Uc = {
  footerBanner: Wc
}, zc = ({
  children: e = null,
  containerType: t = Se.XL
}) => /* @__PURE__ */ r.jsx(Le, { className: Uc.footerBanner, type: t, children: /* @__PURE__ */ r.jsxs(we, { children: [
  /* @__PURE__ */ r.jsx(se, { types: [ue.TWELVE, on.SIX, pe.FOUR], children: /* @__PURE__ */ r.jsx(Pr, {}) }),
  /* @__PURE__ */ r.jsx(se, { types: [ue.TWELVE, on.SIX, pe.FOUR], children: e !== null ? e : /* @__PURE__ */ r.jsx(ne, { href: "https://fiken.no/personvern", children: "Personvern og informasjonskapsler" }) }),
  /* @__PURE__ */ r.jsx(se, { types: [ue.TWELVE, pe.FOUR], children: /* @__PURE__ */ r.jsx(ne, { href: "https://fiken.no/barekraft", children: "Bærekraftsrapport" }) })
] }) }), Gc = ({ param: e }) => /* @__PURE__ */ r.jsxs(se, { types: [ue.TWELVE, pe.FOUR], children: [
  /* @__PURE__ */ r.jsx("h3", { children: "Hjelp og kundeservice" }),
  /* @__PURE__ */ r.jsx("p", { children: "Det du lurer på om Fiken finner du på hjelpesidene våre. Du kan også få hjelp på e-post eller telefon – helt gratis!" }),
  /* @__PURE__ */ r.jsx(ne, { href: `https://hjelp.fiken.no/${e}`, style: { color: "var(--fiken-color-white-500)" }, children: "Få svar på hjelpesidene" })
] }), Yc = "_sprOmHjelp_1ylrn_1", Kc = {
  sprOmHjelp: Yc
}, Xc = () => /* @__PURE__ */ r.jsx("p", { children: "Fant du ikke svar på det du lurte på? Vi hjelper deg raskt – og helt gratis!" }), Zc = ({ variant: e }) => /* @__PURE__ */ r.jsx(xn, { variant: e, size: ye.LG, href: "mailto:hjelp@fiken.no", children: "Send oss en e-post" }), Jc = () => /* @__PURE__ */ r.jsxs(se, { className: Kc.sprOmHjelp, types: [ue.TWELVE, pe.FOUR], children: [
  /* @__PURE__ */ r.jsx("h3", { children: "Spør om hjelp" }),
  /* @__PURE__ */ r.jsx(Xc, {}),
  /* @__PURE__ */ r.jsx(Zc, { variant: be.CTA_LIGHT })
] }), Qc = ({ param: e }) => e.includes("hjelp") && !e.includes("kontohjelp") ? /* @__PURE__ */ r.jsx(Jc, {}) : /* @__PURE__ */ r.jsx(Gc, { param: e }), eu = "_footer_1wmfg_1", tu = "_content_1wmfg_11", nu = "_logo_1wmfg_41", Vt = {
  footer: eu,
  content: tu,
  logo: nu
}, ru = "_micrositesLink_ok8i7_1", ou = {
  micrositesLink: ru
}, su = ({ param: e }) => {
  const t = e.includes("kontohjelp"), n = e.includes("forklarer"), o = e.includes("starte-as"), s = e.includes("starte-enkeltpersonforetak"), l = e.includes("logo"), a = "nyttig-verktøy";
  return /* @__PURE__ */ r.jsxs(se, { types: [ue.TWELVE, pe.FOUR], children: [
    /* @__PURE__ */ r.jsx("h3", { id: a, children: "Nyttig verktøy" }),
    /* @__PURE__ */ r.jsxs("nav", { className: ou.micrositesLink, "aria-labelledby": a, children: [
      s ? null : /* @__PURE__ */ r.jsx(ne, { href: `https://fiken.no/starte-enkeltpersonforetak${e}`, children: "Start ditt eget enkeltpersonforetak" }),
      o ? null : /* @__PURE__ */ r.jsx(ne, { href: `https://fiken.no/starte-as${e}`, children: "Start ditt eget AS" }),
      n ? /* @__PURE__ */ r.jsx(ne, { href: `https://blogg.fiken.no/${e}`, children: "Lær mer om regnskap" }) : /* @__PURE__ */ r.jsx(ne, { href: `https://fiken.no/forklarer${e}`, children: "Fiken forklarer regnskapsord" }),
      t ? /* @__PURE__ */ r.jsx(ne, { href: `https://blogg.fiken.no/${e}`, children: "Regnskap enkelt forklart" }) : /* @__PURE__ */ r.jsx(ne, { href: `https://kontohjelp.fiken.no/${e}`, children: "Finn riktig regnskapskonto" }),
      /* @__PURE__ */ r.jsx(ne, { href: `https://fiken.no/regnskapsforere/${e}`, children: "Finn regnskapsfører" }),
      l ? null : /* @__PURE__ */ r.jsx(ne, { href: `https://fiken.no/logo${e}`, children: "Fiken logo og designhåndbok" })
    ] })
  ] });
}, Ef = ({ personvern: e, containerType: t = Se.XL }) => {
  const n = Ot(), o = n.includes("webinar");
  return /* @__PURE__ */ r.jsxs("footer", { className: Vt.footer, children: [
    /* @__PURE__ */ r.jsxs(Le, { type: t, children: [
      /* @__PURE__ */ r.jsx(we, { children: /* @__PURE__ */ r.jsx(se, { types: [ue.TWELVE], className: Vt.logo, children: /* @__PURE__ */ r.jsx(Fc, {}) }) }),
      /* @__PURE__ */ r.jsxs(we, { className: Vt.content, children: [
        /* @__PURE__ */ r.jsx(Qc, { param: n }),
        o ? /* @__PURE__ */ r.jsx(Hc, { param: n }) : /* @__PURE__ */ r.jsx(Mc, { param: n }),
        /* @__PURE__ */ r.jsx(su, { param: n })
      ] })
    ] }),
    /* @__PURE__ */ r.jsx(zc, { containerType: t, children: e })
  ] });
}, Cf = () => /* @__PURE__ */ r.jsxs(se, { types: [ue.TWELVE, pe.FOUR], children: [
  /* @__PURE__ */ r.jsx("h3", { children: "Kontohjelp" }),
  /* @__PURE__ */ r.jsx("p", { children: "Usikker på konto? Søk på relevante ord og finn regnskapskontoen du skal bruke." }),
  /* @__PURE__ */ r.jsx(ne, { href: "https://kontohjelp.fiken.no/", children: "Gå til kontohjelp" })
] }), iu = "_inputBar_1ofvu_1", lu = {
  inputBar: iu
}, au = "_button_111sx_1", cu = {
  button: au
}, uu = ({
  onClick: e,
  isDisabled: t = !1,
  children: n,
  buttonLabel: o
}) => /* @__PURE__ */ r.jsx(
  "button",
  {
    type: "button",
    className: `${cu.button} `,
    onClick: e,
    "aria-label": o,
    disabled: t,
    onMouseDown: (s) => s.preventDefault(),
    children: n
  }
), Zn = { border: "var(--border)" }, du = ({
  children: e,
  onChange: t,
  placeholder: n,
  inputLabel: o,
  buttonLabel: s,
  onClick: l,
  isLoading: a,
  defaultValue: c,
  inputType: h = "text"
}) => {
  const [p, _] = A(!1), [g, i] = A(), [d, u] = A(Zn), x = (b) => {
    const E = b.value.trim().length;
    t !== void 0 && t(b.value), i(b.value), _(E > 0);
  }, m = () => u({ border: "var(--focus-border)" }), v = () => u(Zn);
  return /* @__PURE__ */ r.jsxs("div", { role: "search", className: lu.inputBar, style: d, children: [
    /* @__PURE__ */ r.jsx(
      "input",
      {
        onBlur: v,
        onFocus: m,
        defaultValue: c,
        type: h,
        placeholder: n,
        autoComplete: "false",
        "aria-label": o,
        onChange: ({ target: b }) => x(b)
      }
    ),
    /* @__PURE__ */ r.jsx(
      uu,
      {
        onClick: () => {
          g !== void 0 && l(g);
        },
        buttonLabel: s,
        isDisabled: !p,
        children: /* @__PURE__ */ r.jsx(Lt, { isVisible: a ?? !1, diameter: 25, color: Be.LIGHT, children: /* @__PURE__ */ r.jsx(r.Fragment, { children: e }) })
      }
    )
  ] });
}, Lf = (e) => /* @__PURE__ */ r.jsx(du, { ...e, children: /* @__PURE__ */ r.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ r.jsx("path", { d: "M12 5V19", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r.jsx("path", { d: "M5 12H19", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
] }) }), fu = "_checkbox_yb6dx_1", hu = {
  checkbox: fu
}, Tf = ({ name: e, onChange: t, isChecked: n }) => /* @__PURE__ */ r.jsxs("label", { htmlFor: e, className: hu.checkbox, children: [
  /* @__PURE__ */ r.jsx(
    "input",
    {
      type: "checkbox",
      id: e,
      name: e,
      checked: n,
      onChange: ({ target: o }) => {
        t(o.checked);
      }
    }
  ),
  /* @__PURE__ */ r.jsx("span", { children: e })
] }), pu = "_formGroup_ip86v_1", mu = "_standard_ip86v_10", gu = "_formGroupDescription_ip86v_17", ln = {
  formGroup: pu,
  standard: mu,
  formGroupDescription: gu
}, xu = "_forGroupHeader_12vg1_1", vu = "_infoButton_12vg1_11", qt = {
  forGroupHeader: xu,
  infoButton: vu
}, Hr = ({
  name: e = void 0,
  infoTekst: t = void 0,
  labelFor: n = void 0
}) => {
  const [o, s] = A(!1);
  return t !== void 0 ? /* @__PURE__ */ r.jsxs("div", { className: qt.forGroupHeader, children: [
    /* @__PURE__ */ r.jsxs("div", { className: qt.infoButton, children: [
      e !== void 0 ? /* @__PURE__ */ r.jsx(r.Fragment, { children: n !== void 0 ? /* @__PURE__ */ r.jsx("label", { htmlFor: n, children: e }) : /* @__PURE__ */ r.jsx("label", { children: e }) }) : null,
      /* @__PURE__ */ r.jsx(za, { onClick: () => s((l) => !l) })
    ] }),
    /* @__PURE__ */ r.jsx(lc, { visible: o, children: t })
  ] }) : /* @__PURE__ */ r.jsx("div", { className: qt.forGroupHeader, children: n !== void 0 ? /* @__PURE__ */ r.jsx("label", { htmlFor: n, children: e }) : /* @__PURE__ */ r.jsx("label", { children: e }) });
};
function Ie() {
  return Ie = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Ie.apply(this, arguments);
}
const yu = ["children", "options"], I = { blockQuote: "0", breakLine: "1", breakThematic: "2", codeBlock: "3", codeFenced: "4", codeInline: "5", footnote: "6", footnoteReference: "7", gfmTask: "8", heading: "9", headingSetext: "10", htmlBlock: "11", htmlComment: "12", htmlSelfClosing: "13", image: "14", link: "15", linkAngleBraceStyleDetector: "16", linkBareUrlDetector: "17", linkMailtoDetector: "18", newlineCoalescer: "19", orderedList: "20", paragraph: "21", ref: "22", refImage: "23", refLink: "24", table: "25", text: "27", textBolded: "28", textEmphasized: "29", textEscaped: "30", textMarked: "31", textStrikethroughed: "32", unorderedList: "33" };
var Jn;
(function(e) {
  e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
})(Jn || (Jn = {}));
const Qn = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce((e, t) => (e[t.toLowerCase()] = t, e), { class: "className", for: "htmlFor" }), er = { amp: "&", apos: "'", gt: ">", lt: "<", nbsp: " ", quot: "“" }, ku = ["style", "script"], _u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, ju = /mailto:/i, wu = /\n{2,}$/, Vr = /^(\s*>[\s\S]*?)(?=\n\n|$)/, bu = /^ *> ?/gm, Su = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $u = /^ {2,}\n/, Eu = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, qr = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, Wr = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, Cu = /^(`+)((?:\\`|[^`])+)\1/, Lu = /^(?:\n *)*\n/, Tu = /\r\n?/g, Mu = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, Ou = /^\[\^([^\]]+)]/, Iu = /\f/g, Nu = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, Au = /^\s*?\[(x|\s)\]/, Ur = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, zr = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, Gr = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, an = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, Ru = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, Yr = /^<!--[\s\S]*?(?:-->)/, Fu = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, cn = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, Bu = /^\{.*\}$/, Du = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, Pu = /^<([^ >]+@[^ >]+)>/, Hu = /^<([^ >]+:\/[^ >]+)>/, Vu = /-([a-z])?/gi, Kr = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, qu = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, Wu = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, Uu = /^\[([^\]]*)\] ?\[([^\]]*)\]/, zu = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, Gu = /\t/g, Yu = /(^ *\||\| *$)/g, Ku = /^ *:-+: *$/, Xu = /^ *:-+ *$/, Zu = /^ *-+: *$/, It = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", Ju = new RegExp(`^([*_])\\1${It}\\1\\1(?!\\1)`), Qu = new RegExp(`^([*_])${It}\\1(?!\\1)`), e1 = new RegExp(`^(==)${It}\\1`), t1 = new RegExp(`^(~~)${It}\\1`), n1 = /^\\([^0-9A-Za-z\s])/, Wt = /\\([^0-9A-Za-z\s])/g, r1 = /^([\s\S](?:(?!  |[0-9]\.)[^*_~\-\n<`\\\[!])*)/, o1 = /^\n+/, s1 = /^([ \t]*)/, i1 = /\\([^\\])/g, l1 = /(?:^|\n)( *)$/, yn = "(?:\\d+\\.)", kn = "(?:[*+-])";
function Xr(e) {
  return "( *)(" + (e === 1 ? yn : kn) + ") +";
}
const Zr = Xr(1), Jr = Xr(2);
function Qr(e) {
  return new RegExp("^" + (e === 1 ? Zr : Jr));
}
const a1 = Qr(1), c1 = Qr(2);
function eo(e) {
  return new RegExp("^" + (e === 1 ? Zr : Jr) + "[^\\n]*(?:\\n(?!\\1" + (e === 1 ? yn : kn) + " )[^\\n]*)*(\\n|$)", "gm");
}
const u1 = eo(1), d1 = eo(2);
function to(e) {
  const t = e === 1 ? yn : kn;
  return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const no = to(1), ro = to(2);
function tr(e, t) {
  const n = t === 1, o = n ? no : ro, s = n ? u1 : d1, l = n ? a1 : c1;
  return { match: De(function(a, c) {
    const h = l1.exec(c.prevCapture);
    return h && (c.list || !c.inline && !c.simple) ? o.exec(a = h[1] + a) : null;
  }), order: 1, parse(a, c, h) {
    const p = n ? +a[2] : void 0, _ = a[0].replace(wu, `
`).match(s);
    let g = !1;
    return { items: _.map(function(i, d) {
      const u = l.exec(i)[0].length, x = new RegExp("^ {1," + u + "}", "gm"), m = i.replace(x, "").replace(l, ""), v = d === _.length - 1, b = m.indexOf(`

`) !== -1 || v && g;
      g = b;
      const E = h.inline, O = h.list;
      let H;
      h.list = !0, b ? (h.inline = !1, H = et(m) + `

`) : (h.inline = !0, H = et(m));
      const C = c(H, h);
      return h.inline = E, h.list = O, C;
    }), ordered: n, start: p };
  }, render: (a, c, h) => e(a.ordered ? "ol" : "ul", { key: h.key, start: a.type === I.orderedList ? a.start : void 0 }, a.items.map(function(p, _) {
    return e("li", { key: _ }, c(p, h));
  })) };
}
const f1 = new RegExp(`^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['"]([\\s\\S]*?)['"])?\\s*\\)`), h1 = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, oo = [Vr, qr, Wr, Ur, Gr, zr, Kr, no, ro], p1 = [...oo, /^[^\n]+(?:  \n|\n{2,})/, an, Yr, cn];
function et(e) {
  let t = e.length;
  for (; t > 0 && e[t - 1] <= " "; ) t--;
  return e.slice(0, t);
}
function Xe(e) {
  return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function m1(e) {
  return Zu.test(e) ? "right" : Ku.test(e) ? "center" : Xu.test(e) ? "left" : null;
}
function nr(e, t, n, o) {
  const s = n.inTable;
  n.inTable = !0;
  let l = [[]], a = "";
  function c() {
    if (!a) return;
    const h = l[l.length - 1];
    h.push.apply(h, t(a, n)), a = "";
  }
  return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((h, p, _) => {
    h.trim() === "|" && (c(), o) ? p !== 0 && p !== _.length - 1 && l.push([]) : a += h;
  }), c(), n.inTable = s, l;
}
function g1(e, t, n) {
  n.inline = !0;
  const o = e[2] ? e[2].replace(Yu, "").split("|").map(m1) : [], s = e[3] ? function(a, c, h) {
    return a.trim().split(`
`).map(function(p) {
      return nr(p, c, h, !0);
    });
  }(e[3], t, n) : [], l = nr(e[1], t, n, !!s.length);
  return n.inline = !1, s.length ? { align: o, cells: s, header: l, type: I.table } : { children: l, type: I.paragraph };
}
function rr(e, t) {
  return e.align[t] == null ? {} : { textAlign: e.align[t] };
}
function De(e) {
  return e.inline = 1, e;
}
function Ee(e) {
  return De(function(t, n) {
    return n.inline ? e.exec(t) : null;
  });
}
function Ce(e) {
  return De(function(t, n) {
    return n.inline || n.simple ? e.exec(t) : null;
  });
}
function je(e) {
  return function(t, n) {
    return n.inline || n.simple ? null : e.exec(t);
  };
}
function Ze(e) {
  return De(function(t) {
    return e.exec(t);
  });
}
function x1(e, t) {
  if (t.inline || t.simple) return null;
  let n = "";
  e.split(`
`).every((s) => (s += `
`, !oo.some((l) => l.test(s)) && (n += s, !!s.trim())));
  const o = et(n);
  return o == "" ? null : [n, , o];
}
function v1(e) {
  try {
    if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
  } catch {
    return null;
  }
  return e;
}
function or(e) {
  return e.replace(i1, "$1");
}
function yt(e, t, n) {
  const o = n.inline || !1, s = n.simple || !1;
  n.inline = !0, n.simple = !0;
  const l = e(t, n);
  return n.inline = o, n.simple = s, l;
}
function y1(e, t, n) {
  const o = n.inline || !1, s = n.simple || !1;
  n.inline = !1, n.simple = !0;
  const l = e(t, n);
  return n.inline = o, n.simple = s, l;
}
function k1(e, t, n) {
  const o = n.inline || !1;
  n.inline = !1;
  const s = e(t, n);
  return n.inline = o, s;
}
const Ut = (e, t, n) => ({ children: yt(t, e[2], n) });
function zt() {
  return {};
}
function Gt() {
  return null;
}
function _1(...e) {
  return e.filter(Boolean).join(" ");
}
function Yt(e, t, n) {
  let o = e;
  const s = t.split(".");
  for (; s.length && (o = o[s[0]], o !== void 0); ) s.shift();
  return o || n;
}
function j1(e = "", t = {}) {
  function n(i, d, ...u) {
    const x = Yt(t.overrides, `${i}.props`, {});
    return t.createElement(function(m, v) {
      const b = Yt(v, m);
      return b ? typeof b == "function" || typeof b == "object" && "render" in b ? b : Yt(v, `${m}.component`, m) : m;
    }(i, t.overrides), Ie({}, d, x, { className: _1(d == null ? void 0 : d.className, x.className) || void 0 }), ...u);
  }
  function o(i) {
    i = i.replace(Nu, "");
    let d = !1;
    t.forceInline ? d = !0 : t.forceBlock || (d = zu.test(i) === !1);
    const u = p(h(d ? i : `${et(i).replace(o1, "")}

`, { inline: d }));
    for (; typeof u[u.length - 1] == "string" && !u[u.length - 1].trim(); ) u.pop();
    if (t.wrapper === null) return u;
    const x = t.wrapper || (d ? "span" : "div");
    let m;
    if (u.length > 1 || t.forceWrapper) m = u;
    else {
      if (u.length === 1) return m = u[0], typeof m == "string" ? n("span", { key: "outer" }, m) : m;
      m = null;
    }
    return t.createElement(x, { key: "outer" }, m);
  }
  function s(i, d) {
    const u = d.match(_u);
    return u ? u.reduce(function(x, m) {
      const v = m.indexOf("=");
      if (v !== -1) {
        const b = function(C) {
          return C.indexOf("-") !== -1 && C.match(Fu) === null && (C = C.replace(Vu, function(V, N) {
            return N.toUpperCase();
          })), C;
        }(m.slice(0, v)).trim(), E = function(C) {
          const V = C[0];
          return (V === '"' || V === "'") && C.length >= 2 && C[C.length - 1] === V ? C.slice(1, -1) : C;
        }(m.slice(v + 1).trim()), O = Qn[b] || b;
        if (O === "ref") return x;
        const H = x[O] = function(C, V, N, ie) {
          return V === "style" ? N.split(/;\s?/).reduce(function(de, y) {
            const j = y.slice(0, y.indexOf(":"));
            return de[j.trim().replace(/(-[a-z])/g, (w) => w[1].toUpperCase())] = y.slice(j.length + 1).trim(), de;
          }, {}) : V === "href" || V === "src" ? ie(N, C, V) : (N.match(Bu) && (N = N.slice(1, N.length - 1)), N === "true" || N !== "false" && N);
        }(i, b, E, t.sanitizer);
        typeof H == "string" && (an.test(H) || cn.test(H)) && (x[O] = o(H.trim()));
      } else m !== "style" && (x[Qn[m] || m] = !0);
      return x;
    }, {}) : null;
  }
  t.overrides = t.overrides || {}, t.sanitizer = t.sanitizer || v1, t.slugify = t.slugify || Xe, t.namedCodesToUnicode = t.namedCodesToUnicode ? Ie({}, er, t.namedCodesToUnicode) : er, t.createElement = t.createElement || ar.createElement;
  const l = [], a = {}, c = { [I.blockQuote]: { match: je(Vr), order: 1, parse(i, d, u) {
    const [, x, m] = i[0].replace(bu, "").match(Su);
    return { alert: x, children: d(m, u) };
  }, render(i, d, u) {
    const x = { key: u.key };
    return i.alert && (x.className = "markdown-alert-" + t.slugify(i.alert.toLowerCase(), Xe), i.children.unshift({ attrs: {}, children: [{ type: I.text, text: i.alert }], noInnerParse: !0, type: I.htmlBlock, tag: "header" })), n("blockquote", x, d(i.children, u));
  } }, [I.breakLine]: { match: Ze($u), order: 1, parse: zt, render: (i, d, u) => n("br", { key: u.key }) }, [I.breakThematic]: { match: je(Eu), order: 1, parse: zt, render: (i, d, u) => n("hr", { key: u.key }) }, [I.codeBlock]: { match: je(Wr), order: 0, parse: (i) => ({ lang: void 0, text: et(i[0].replace(/^ {4}/gm, "")).replace(Wt, "$1") }), render: (i, d, u) => n("pre", { key: u.key }, n("code", Ie({}, i.attrs, { className: i.lang ? `lang-${i.lang}` : "" }), i.text)) }, [I.codeFenced]: { match: je(qr), order: 0, parse: (i) => ({ attrs: s("code", i[3] || ""), lang: i[2] || void 0, text: i[4].replace(Wt, "$1"), type: I.codeBlock }) }, [I.codeInline]: { match: Ce(Cu), order: 3, parse: (i) => ({ text: i[2].replace(Wt, "$1") }), render: (i, d, u) => n("code", { key: u.key }, i.text) }, [I.footnote]: { match: je(Mu), order: 0, parse: (i) => (l.push({ footnote: i[2], identifier: i[1] }), {}), render: Gt }, [I.footnoteReference]: { match: Ee(Ou), order: 1, parse: (i) => ({ target: `#${t.slugify(i[1], Xe)}`, text: i[1] }), render: (i, d, u) => n("a", { key: u.key, href: t.sanitizer(i.target, "a", "href") }, n("sup", { key: u.key }, i.text)) }, [I.gfmTask]: { match: Ee(Au), order: 1, parse: (i) => ({ completed: i[1].toLowerCase() === "x" }), render: (i, d, u) => n("input", { checked: i.completed, key: u.key, readOnly: !0, type: "checkbox" }) }, [I.heading]: { match: je(t.enforceAtxHeadings ? zr : Ur), order: 1, parse: (i, d, u) => ({ children: yt(d, i[2], u), id: t.slugify(i[2], Xe), level: i[1].length }), render: (i, d, u) => n(`h${i.level}`, { id: i.id, key: u.key }, d(i.children, u)) }, [I.headingSetext]: { match: je(Gr), order: 0, parse: (i, d, u) => ({ children: yt(d, i[1], u), level: i[2] === "=" ? 1 : 2, type: I.heading }) }, [I.htmlBlock]: { match: Ze(an), order: 1, parse(i, d, u) {
    const [, x] = i[3].match(s1), m = new RegExp(`^${x}`, "gm"), v = i[3].replace(m, ""), b = (E = v, p1.some((N) => N.test(E)) ? k1 : yt);
    var E;
    const O = i[1].toLowerCase(), H = ku.indexOf(O) !== -1, C = (H ? O : i[1]).trim(), V = { attrs: s(C, i[2]), noInnerParse: H, tag: C };
    return u.inAnchor = u.inAnchor || O === "a", H ? V.text = i[3] : V.children = b(d, v, u), u.inAnchor = !1, V;
  }, render: (i, d, u) => n(i.tag, Ie({ key: u.key }, i.attrs), i.text || (i.children ? d(i.children, u) : "")) }, [I.htmlSelfClosing]: { match: Ze(cn), order: 1, parse(i) {
    const d = i[1].trim();
    return { attrs: s(d, i[2] || ""), tag: d };
  }, render: (i, d, u) => n(i.tag, Ie({}, i.attrs, { key: u.key })) }, [I.htmlComment]: { match: Ze(Yr), order: 1, parse: () => ({}), render: Gt }, [I.image]: { match: Ce(h1), order: 1, parse: (i) => ({ alt: i[1], target: or(i[2]), title: i[3] }), render: (i, d, u) => n("img", { key: u.key, alt: i.alt || void 0, title: i.title || void 0, src: t.sanitizer(i.target, "img", "src") }) }, [I.link]: { match: Ee(f1), order: 3, parse: (i, d, u) => ({ children: y1(d, i[1], u), target: or(i[2]), title: i[3] }), render: (i, d, u) => n("a", { key: u.key, href: t.sanitizer(i.target, "a", "href"), title: i.title }, d(i.children, u)) }, [I.linkAngleBraceStyleDetector]: { match: Ee(Hu), order: 0, parse: (i) => ({ children: [{ text: i[1], type: I.text }], target: i[1], type: I.link }) }, [I.linkBareUrlDetector]: { match: De((i, d) => d.inAnchor || t.disableAutoLink ? null : Ee(Du)(i, d)), order: 0, parse: (i) => ({ children: [{ text: i[1], type: I.text }], target: i[1], title: void 0, type: I.link }) }, [I.linkMailtoDetector]: { match: Ee(Pu), order: 0, parse(i) {
    let d = i[1], u = i[1];
    return ju.test(u) || (u = "mailto:" + u), { children: [{ text: d.replace("mailto:", ""), type: I.text }], target: u, type: I.link };
  } }, [I.orderedList]: tr(n, 1), [I.unorderedList]: tr(n, 2), [I.newlineCoalescer]: { match: je(Lu), order: 3, parse: zt, render: () => `
` }, [I.paragraph]: { match: De(x1), order: 3, parse: Ut, render: (i, d, u) => n("p", { key: u.key }, d(i.children, u)) }, [I.ref]: { match: Ee(qu), order: 0, parse: (i) => (a[i[1]] = { target: i[2], title: i[4] }, {}), render: Gt }, [I.refImage]: { match: Ce(Wu), order: 0, parse: (i) => ({ alt: i[1] || void 0, ref: i[2] }), render: (i, d, u) => a[i.ref] ? n("img", { key: u.key, alt: i.alt, src: t.sanitizer(a[i.ref].target, "img", "src"), title: a[i.ref].title }) : null }, [I.refLink]: { match: Ee(Uu), order: 0, parse: (i, d, u) => ({ children: d(i[1], u), fallbackChildren: i[0], ref: i[2] }), render: (i, d, u) => a[i.ref] ? n("a", { key: u.key, href: t.sanitizer(a[i.ref].target, "a", "href"), title: a[i.ref].title }, d(i.children, u)) : n("span", { key: u.key }, i.fallbackChildren) }, [I.table]: { match: je(Kr), order: 1, parse: g1, render(i, d, u) {
    const x = i;
    return n("table", { key: u.key }, n("thead", null, n("tr", null, x.header.map(function(m, v) {
      return n("th", { key: v, style: rr(x, v) }, d(m, u));
    }))), n("tbody", null, x.cells.map(function(m, v) {
      return n("tr", { key: v }, m.map(function(b, E) {
        return n("td", { key: E, style: rr(x, E) }, d(b, u));
      }));
    })));
  } }, [I.text]: { match: Ze(r1), order: 4, parse: (i) => ({ text: i[0].replace(Ru, (d, u) => t.namedCodesToUnicode[u] ? t.namedCodesToUnicode[u] : d) }), render: (i) => i.text }, [I.textBolded]: { match: Ce(Ju), order: 2, parse: (i, d, u) => ({ children: d(i[2], u) }), render: (i, d, u) => n("strong", { key: u.key }, d(i.children, u)) }, [I.textEmphasized]: { match: Ce(Qu), order: 3, parse: (i, d, u) => ({ children: d(i[2], u) }), render: (i, d, u) => n("em", { key: u.key }, d(i.children, u)) }, [I.textEscaped]: { match: Ce(n1), order: 1, parse: (i) => ({ text: i[1], type: I.text }) }, [I.textMarked]: { match: Ce(e1), order: 3, parse: Ut, render: (i, d, u) => n("mark", { key: u.key }, d(i.children, u)) }, [I.textStrikethroughed]: { match: Ce(t1), order: 3, parse: Ut, render: (i, d, u) => n("del", { key: u.key }, d(i.children, u)) } };
  t.disableParsingRawHTML === !0 && (delete c[I.htmlBlock], delete c[I.htmlSelfClosing]);
  const h = function(i) {
    let d = Object.keys(i);
    function u(x, m) {
      let v, b, E = [], O = "", H = "";
      for (m.prevCapture = m.prevCapture || ""; x; ) {
        let C = 0;
        for (; C < d.length; ) {
          if (O = d[C], v = i[O], m.inline && !v.match.inline) {
            C++;
            continue;
          }
          const V = v.match(x, m);
          if (V) {
            H = V[0], m.prevCapture += H, x = x.substring(H.length), b = v.parse(V, u, m), b.type == null && (b.type = O), E.push(b);
            break;
          }
          C++;
        }
      }
      return m.prevCapture = "", E;
    }
    return d.sort(function(x, m) {
      let v = i[x].order, b = i[m].order;
      return v !== b ? v - b : x < m ? -1 : 1;
    }), function(x, m) {
      return u(function(v) {
        return v.replace(Tu, `
`).replace(Iu, "").replace(Gu, "    ");
      }(x), m);
    };
  }(c), p = (_ = /* @__PURE__ */ function(i, d) {
    return function(u, x, m) {
      const v = i[u.type].render;
      return d ? d(() => v(u, x, m), u, x, m) : v(u, x, m);
    };
  }(c, t.renderRule), function i(d, u = {}) {
    if (Array.isArray(d)) {
      const x = u.key, m = [];
      let v = !1;
      for (let b = 0; b < d.length; b++) {
        u.key = b;
        const E = i(d[b], u), O = typeof E == "string";
        O && v ? m[m.length - 1] += E : E !== null && m.push(E), v = O;
      }
      return u.key = x, m;
    }
    return _(d, i, u);
  });
  var _;
  const g = o(e);
  return l.length ? n("div", null, g, n("footer", { key: "footer" }, l.map(function(i) {
    return n("div", { id: t.slugify(i.identifier, Xe), key: i.identifier }, i.identifier, p(h(i.footnote, { inline: !0 })));
  }))) : g;
}
const w1 = (e) => {
  let { children: t = "", options: n } = e, o = function(s, l) {
    if (s == null) return {};
    var a, c, h = {}, p = Object.keys(s);
    for (c = 0; c < p.length; c++) l.indexOf(a = p[c]) >= 0 || (h[a] = s[a]);
    return h;
  }(e, yu);
  return ar.cloneElement(j1(t, n), o);
}, b1 = ({ error: e }) => e === void 0 ? /* @__PURE__ */ r.jsx(r.Fragment, {}) : /* @__PURE__ */ r.jsx(
  w1,
  {
    options: {
      overrides: {
        a: (t) => /* @__PURE__ */ r.jsx("a", { ...t, target: "_blank", rel: "noreferrer" }),
        strong: "b"
      }
    },
    children: e.message
  }
), Mf = ({
  children: e,
  className: t = "",
  name: n = void 0,
  labelFor: o = void 0,
  error: s,
  infoTekst: l,
  style: a = {},
  errorComponent: c = null
}) => {
  const h = s !== void 0, p = (s == null ? void 0 : s.displayType) ?? mt.standard;
  return /* @__PURE__ */ r.jsxs("section", { className: `${ln.formGroup} ${t} ${h ? ln[p] : ""}`, style: a, children: [
    /* @__PURE__ */ r.jsx(Hr, { name: n, labelFor: o, infoTekst: l }),
    e,
    h && p === mt.standard ? /* @__PURE__ */ r.jsx("span", { style: { color: "var(--fiken-color-red-900)" }, children: s == null ? void 0 : s.message }) : null,
    h && (p === mt.errorBanner || p === mt.interactionErrorBanner) ? /* @__PURE__ */ r.jsx(Ha, { style: { marginTop: "1.2rem" }, children: /* @__PURE__ */ r.jsxs("div", { children: [
      /* @__PURE__ */ r.jsx(b1, { error: s }),
      c
    ] }) }) : null
  ] });
}, Of = ({
  children: e,
  className: t = "",
  name: n,
  infoTekst: o
}) => /* @__PURE__ */ r.jsxs("section", { className: `${ln.formGroupDescription} ${t}`, children: [
  /* @__PURE__ */ r.jsx(Hr, { name: n, infoTekst: o }),
  e
] }), S1 = "_input_a7ly1_1", so = {
  input: S1
};
function io(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, o = Object.getOwnPropertySymbols(e); s < o.length; s++)
      t.indexOf(o[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[s]) && (n[o[s]] = e[o[s]]);
  return n;
}
var bt;
(function(e) {
  e.event = "event", e.props = "prop";
})(bt || (bt = {}));
function Ne() {
}
function $1(e) {
  var t, n = void 0;
  return function() {
    for (var o = [], s = arguments.length; s--; ) o[s] = arguments[s];
    return t && o.length === t.length && o.every(function(l, a) {
      return l === t[a];
    }) || (t = o, n = e.apply(void 0, o)), n;
  };
}
function tt(e) {
  return !!(e || "").match(/\d/);
}
function St(e) {
  return e == null;
}
function E1(e) {
  return typeof e == "number" && isNaN(e);
}
function C1(e) {
  return St(e) || E1(e) || typeof e == "number" && !isFinite(e);
}
function L1(e) {
  var t = K(e);
  t.current = e;
  var n = K(function() {
    for (var o = [], s = arguments.length; s--; ) o[s] = arguments[s];
    return t.current.apply(t, o);
  });
  return n.current;
}
function sr(e, t) {
  return Array(t + 1).join(e);
}
function T1(e) {
  var t = e + "", n = t[0] === "-" ? "-" : "";
  n && (t = t.substring(1));
  var o = t.split(/[eE]/g), s = o[0], l = o[1];
  if (l = Number(l), !l)
    return n + s;
  s = s.replace(".", "");
  var a = 1 + l, c = s.length;
  return a < 0 ? s = "0." + sr("0", Math.abs(a)) + s : a >= c ? s = s + sr("0", a - c) : s = (s.substring(0, a) || "0") + "." + s.substring(a), n + s;
}
function un(e, t) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var n = e.createTextRange();
      return n.move("character", t), n.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
  }
}
var M1 = $1(function(e, t) {
  for (var n = 0, o = 0, s = e.length, l = t.length; e[n] === t[n] && n < s; )
    n++;
  for (; e[s - 1 - o] === t[l - 1 - o] && l - o > n && s - o > n; )
    o++;
  return {
    from: { start: n, end: s - o },
    to: { start: n, end: l - o }
  };
}), O1 = function(e, t) {
  var n = Math.min(e.selectionStart, t);
  return {
    from: { start: n, end: e.selectionEnd },
    to: { start: n, end: t }
  };
};
function I1(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function Kt(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function N1() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function A1(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function lo(e, t) {
  return e === void 0 && (e = " "), typeof e == "string" ? e : e[t] || " ";
}
function R1(e) {
  var t = e.currentValue, n = e.formattedValue, o = e.currentValueIndex, s = e.formattedValueIndex;
  return t[o] === n[s];
}
function F1(e, t, n, o, s, l, a) {
  a === void 0 && (a = R1);
  var c = s.findIndex(function(O) {
    return O;
  }), h = e.slice(0, c);
  !t && !n.startsWith(h) && (t = h, n = h + n, o = o + h.length);
  for (var p = n.length, _ = e.length, g = {}, i = new Array(p), d = 0; d < p; d++) {
    i[d] = -1;
    for (var u = 0, x = _; u < x; u++) {
      var m = a({
        currentValue: n,
        lastValue: t,
        formattedValue: e,
        currentValueIndex: d,
        formattedValueIndex: u
      });
      if (m && g[u] !== !0) {
        i[d] = u, g[u] = !0;
        break;
      }
    }
  }
  for (var v = o; v < p && (i[v] === -1 || !l(n[v])); )
    v++;
  var b = v === p || i[v] === -1 ? _ : i[v];
  for (v = o - 1; v > 0 && i[v] === -1; )
    v--;
  var E = v === -1 || i[v] === -1 ? 0 : i[v] + 1;
  return E > b ? b : o - E < b - o ? E : b;
}
function $t(e, t, n, o) {
  var s = e.length;
  if (t = I1(t, 0, s), o === "left") {
    for (; t >= 0 && !n[t]; )
      t--;
    t === -1 && (t = n.indexOf(!0));
  } else {
    for (; t <= s && !n[t]; )
      t++;
    t > s && (t = n.lastIndexOf(!0));
  }
  return t === -1 && (t = s), t;
}
function B1(e) {
  for (var t = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), n = 0, o = t.length; n < o; n++)
    t[n] = !!(tt(e[n]) || tt(e[n - 1]));
  return t;
}
function D1(e, t, n, o, s, l) {
  l === void 0 && (l = Ne);
  var a = L1(function(u, x) {
    var m, v;
    return C1(u) ? (v = "", m = "") : typeof u == "number" || x ? (v = typeof u == "number" ? T1(u) : u, m = o(v)) : (v = s(u, void 0), m = o(v)), { formattedValue: m, numAsString: v };
  }), c = A(function() {
    return a(St(e) ? t : e, n);
  }), h = c[0], p = c[1], _ = function(u, x) {
    u.formattedValue !== h.formattedValue && p({
      formattedValue: u.formattedValue,
      numAsString: u.value
    }), l(u, x);
  }, g = e, i = n;
  St(e) && (g = h.numAsString, i = !0);
  var d = a(g, i);
  return Ae(function() {
    p(d);
  }, [d.formattedValue]), [h, _];
}
function P1(e) {
  return e.replace(/[^0-9]/g, "");
}
function H1(e) {
  return e;
}
function V1(e) {
  var t = e.type;
  t === void 0 && (t = "text");
  var n = e.displayType;
  n === void 0 && (n = "input");
  var o = e.customInput, s = e.renderText, l = e.getInputRef, a = e.format;
  a === void 0 && (a = H1);
  var c = e.removeFormatting;
  c === void 0 && (c = P1);
  var h = e.defaultValue, p = e.valueIsNumericString, _ = e.onValueChange, g = e.isAllowed, i = e.onChange;
  i === void 0 && (i = Ne);
  var d = e.onKeyDown;
  d === void 0 && (d = Ne);
  var u = e.onMouseUp;
  u === void 0 && (u = Ne);
  var x = e.onFocus;
  x === void 0 && (x = Ne);
  var m = e.onBlur;
  m === void 0 && (m = Ne);
  var v = e.value, b = e.getCaretBoundary;
  b === void 0 && (b = B1);
  var E = e.isValidInputCharacter;
  E === void 0 && (E = tt);
  var O = e.isCharacterSame, H = io(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), C = D1(v, h, !!p, a, c, _), V = C[0], N = V.formattedValue, ie = V.numAsString, de = C[1], y = K(), j = K({ formattedValue: N, numAsString: ie }), w = function(T, M) {
    j.current = { formattedValue: T.formattedValue, numAsString: T.value }, de(T, M);
  }, k = A(!1), U = k[0], L = k[1], P = K(null), R = K({
    setCaretTimeout: null,
    focusTimeout: null
  });
  G(function() {
    return L(!0), function() {
      clearTimeout(R.current.setCaretTimeout), clearTimeout(R.current.focusTimeout);
    };
  }, []);
  var W = a, z = function(T, M) {
    var B = parseFloat(M);
    return {
      formattedValue: T,
      value: M,
      floatValue: isNaN(B) ? void 0 : B
    };
  }, q = function(T, M, B) {
    T.selectionStart === 0 && T.selectionEnd === T.value.length || (un(T, M), R.current.setCaretTimeout = setTimeout(function() {
      T.value === B && T.selectionStart !== M && un(T, M);
    }, 0));
  }, te = function(T, M, B) {
    return $t(T, M, b(T), B);
  }, Q = function(T, M, B) {
    var X = b(M), f = F1(M, N, T, B, X, E, O);
    return f = $t(M, f, X), f;
  }, Z = function(T) {
    var M = T.formattedValue;
    M === void 0 && (M = "");
    var B = T.input, X = T.source, f = T.event, $ = T.numAsString, S;
    if (B) {
      var D = T.inputValue || B.value, J = Kt(B);
      B.value = M, S = Q(D, M, J), S !== void 0 && q(B, S, M);
    }
    M !== N && w(z(M, $), { event: f, source: X });
  };
  G(function() {
    var T = j.current, M = T.formattedValue, B = T.numAsString;
    (N !== M || ie !== B) && w(z(N, ie), {
      event: void 0,
      source: bt.props
    });
  }, [N, ie]);
  var le = P.current ? Kt(P.current) : void 0, ee = typeof window < "u" ? Pe : G;
  ee(function() {
    var T = P.current;
    if (N !== j.current.formattedValue && T) {
      var M = Q(j.current.formattedValue, N, le);
      T.value = N, q(T, M, N);
    }
  }, [N]);
  var oe = function(T, M, B) {
    var X = M.target, f = y.current ? O1(y.current, X.selectionEnd) : M1(N, T), $ = Object.assign(Object.assign({}, f), { lastValue: N }), S = c(T, $), D = W(S);
    if (S = c(D, void 0), g && !g(z(D, S))) {
      var J = M.target, Y = Kt(J), F = Q(T, N, Y);
      return J.value = N, q(J, F, N), !1;
    }
    return Z({
      formattedValue: D,
      numAsString: S,
      inputValue: T,
      event: M,
      source: B,
      input: M.target
    }), !0;
  }, he = function(T, M) {
    M === void 0 && (M = 0);
    var B = T.selectionStart, X = T.selectionEnd;
    y.current = { selectionStart: B, selectionEnd: X + M };
  }, me = function(T) {
    var M = T.target, B = M.value, X = oe(B, T, bt.event);
    X && i(T), y.current = void 0;
  }, ot = function(T) {
    var M = T.target, B = T.key, X = M.selectionStart, f = M.selectionEnd, $ = M.value;
    $ === void 0 && ($ = "");
    var S;
    B === "ArrowLeft" || B === "Backspace" ? S = Math.max(X - 1, 0) : B === "ArrowRight" ? S = Math.min(X + 1, $.length) : B === "Delete" && (S = X);
    var D = 0;
    B === "Delete" && X === f && (D = 1);
    var J = B === "ArrowLeft" || B === "ArrowRight";
    if (S === void 0 || X !== f && !J) {
      d(T), he(M, D);
      return;
    }
    var Y = S;
    if (J) {
      var F = B === "ArrowLeft" ? "left" : "right";
      Y = te($, S, F), Y !== S && T.preventDefault();
    } else B === "Delete" && !E($[S]) ? Y = te($, S, "right") : B === "Backspace" && !E($[S]) && (Y = te($, S, "left"));
    Y !== S && q(M, Y, $), d(T), he(M, D);
  }, st = function(T) {
    var M = T.target, B = function() {
      var X = M.selectionStart, f = M.selectionEnd, $ = M.value;
      if ($ === void 0 && ($ = ""), X === f) {
        var S = te($, X);
        S !== X && q(M, S, $);
      }
    };
    B(), requestAnimationFrame(function() {
      B();
    }), u(T), he(M);
  }, He = function(T) {
    T.persist && T.persist();
    var M = T.target, B = T.currentTarget;
    P.current = M, R.current.focusTimeout = setTimeout(function() {
      var X = M.selectionStart, f = M.selectionEnd, $ = M.value;
      $ === void 0 && ($ = "");
      var S = te($, X);
      S !== X && !(X === 0 && f === $.length) && q(M, S, $), x(Object.assign(Object.assign({}, T), { currentTarget: B }));
    }, 0);
  }, it = function(T) {
    P.current = null, clearTimeout(R.current.focusTimeout), clearTimeout(R.current.setCaretTimeout), m(T);
  }, Ve = U && N1() ? "numeric" : void 0, Re = Object.assign({ inputMode: Ve }, H, {
    type: t,
    value: N,
    onChange: me,
    onKeyDown: ot,
    onMouseUp: st,
    onFocus: He,
    onBlur: it
  });
  if (n === "text")
    return s ? fe.createElement(fe.Fragment, null, s(N, H) || null) : fe.createElement("span", Object.assign({}, H, { ref: l }), N);
  if (o) {
    var Nt = o;
    return fe.createElement(Nt, Object.assign({}, Re, { ref: l }));
  }
  return fe.createElement("input", Object.assign({}, Re, { ref: l }));
}
function q1(e, t) {
  var n = t.format, o = t.allowEmptyFormatting, s = t.mask, l = t.patternChar;
  if (l === void 0 && (l = "#"), e === "" && !o)
    return "";
  for (var a = 0, c = n.split(""), h = 0, p = n.length; h < p; h++)
    n[h] === l && (c[h] = e[a] || lo(s, a), a += 1);
  return c.join("");
}
function W1(e, t, n) {
  t === void 0 && (t = A1(e));
  var o = n.format, s = n.patternChar;
  s === void 0 && (s = "#");
  var l = t.from, a = t.to, c = t.lastValue;
  c === void 0 && (c = "");
  var h = function(m) {
    return o[m] === s;
  }, p = function(m, v) {
    for (var b = "", E = 0; E < m.length; E++)
      h(v + E) && tt(m[E]) && (b += m[E]);
    return b;
  }, _ = function(m) {
    return m.replace(/[^0-9]/g, "");
  };
  if (!o.match(/\d/))
    return _(e);
  if ((c === "" || l.end - l.start === c.length) && e.length === o.length) {
    for (var g = "", i = 0; i < e.length; i++)
      if (h(i))
        tt(e[i]) && (g += e[i]);
      else if (e[i] !== o[i])
        return _(e);
    return g;
  }
  var d = c.substring(0, l.start), u = e.substring(a.start, a.end), x = c.substring(l.end);
  return "" + p(d, 0) + _(u) + p(x, l.end);
}
function U1(e, t) {
  var n = t.format, o = t.mask, s = t.patternChar;
  s === void 0 && (s = "#");
  var l = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), a = 0, c = -1, h = {};
  n.split("").forEach(function(i, d) {
    var u = void 0;
    i === s && (a++, u = lo(o, a - 1), c === -1 && e[d] === u && (c = d)), h[d] = u;
  });
  for (var p = function(i) {
    return n[i] === s && e[i] !== h[i];
  }, _ = 0, g = l.length; _ < g; _++)
    l[_] = _ === c || p(_) || p(_ - 1);
  return l[n.indexOf(s)] = !0, l;
}
function z1(e) {
  var t = e.mask;
  if (t) {
    var n = t === "string" ? t : t.toString();
    if (n.match(/\d/g))
      throw new Error("Mask " + t + " should not contain numeric character;");
  }
}
function G1(e, t) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && typeof e == "string" && (!!e.match(/^\d+$/) || e === "");
}
function Y1(e) {
  e.mask, e.allowEmptyFormatting;
  var t = e.format, n = e.inputMode;
  n === void 0 && (n = "numeric");
  var o = e.onKeyDown;
  o === void 0 && (o = Ne);
  var s = e.patternChar;
  s === void 0 && (s = "#");
  var l = e.value, a = e.defaultValue, c = e.valueIsNumericString, h = io(e, ["mask", "allowEmptyFormatting", "format", "inputMode", "onKeyDown", "patternChar", "value", "defaultValue", "valueIsNumericString"]);
  z1(e);
  var p = function(u) {
    return U1(u, e);
  }, _ = function(u) {
    var x = u.key, m = u.target, v = m.selectionStart, b = m.selectionEnd, E = m.value;
    if (v !== b) {
      o(u);
      return;
    }
    var O = v;
    if (x === "Backspace" || x === "Delete") {
      var H = "right";
      if (x === "Backspace") {
        for (; O > 0 && t[O - 1] !== s; )
          O--;
        H = "left";
      } else {
        for (var C = t.length; O < C && t[O] !== s; )
          O++;
        H = "right";
      }
      O = $t(E, O, p(E), H);
    } else t[O] !== s && x !== "ArrowLeft" && x !== "ArrowRight" && (O = $t(E, O + 1, p(E), "right"));
    O !== v && un(m, O), o(u);
  }, g = St(l) ? a : l, i = c ?? G1(g, t), d = Object.assign(Object.assign({}, e), { valueIsNumericString: i });
  return Object.assign(Object.assign({}, h), {
    value: l,
    defaultValue: a,
    valueIsNumericString: i,
    inputMode: n,
    format: function(u) {
      return q1(u, d);
    },
    removeFormatting: function(u, x) {
      return W1(u, x, d);
    },
    getCaretBoundary: p,
    onKeyDown: _
  });
}
function K1(e) {
  var t = Y1(e);
  return fe.createElement(V1, Object.assign({}, t));
}
const If = (e) => {
  const t = e.autoComplete ?? "off";
  return /* @__PURE__ */ r.jsx("input", { className: so.input, ...e, autoComplete: t });
}, Nf = ({ value: e, placeholder: t, format: n, onValueChange: o, type: s, spellCheck: l }) => /* @__PURE__ */ r.jsx(
  K1,
  {
    className: so.input,
    spellCheck: l,
    type: s,
    value: e,
    placeholder: t,
    format: n,
    onValueChange: o
  }
), X1 = "_validationMessage_bofj4_1", Z1 = {
  validationMessage: X1
}, Af = ({ children: e, isVisible: t }) => t ? /* @__PURE__ */ r.jsx("span", { className: Z1.validationMessage, children: e }) : /* @__PURE__ */ r.jsx(r.Fragment, {}), J1 = "_radio_1vo85_1", Q1 = "_bordered_1vo85_55", ed = "_checked_1vo85_76", Xt = {
  radio: J1,
  bordered: Q1,
  checked: ed
}, ao = {
  standard: "standard",
  bordered: "bordered"
}, Rf = ({
  name: e,
  children: t,
  checked: n = !1,
  onCheck: o = void 0,
  variant: s = ao.standard
}) => /* @__PURE__ */ r.jsxs("label", { className: `${Xt.radio} ${Xt[s]} ${n ? Xt.checked : ""}`, children: [
  /* @__PURE__ */ r.jsx(
    "input",
    {
      type: "radio",
      name: e,
      checked: n,
      onChange: () => {
        o !== void 0 && o();
      }
    }
  ),
  /* @__PURE__ */ r.jsx("span", { children: t })
] }), Ff = ({
  className: e,
  placeholder: t,
  onChange: n,
  isFirstResponder: o = !0,
  ariaLabel: s,
  value: l
}) => /* @__PURE__ */ r.jsx(
  "input",
  {
    className: e,
    type: "text",
    placeholder: t,
    autoComplete: "false",
    "aria-label": s,
    autoFocus: o,
    onFocus: ({ target: a }) => {
      n(a.value);
    },
    value: l,
    onChange: ({ target: a }) => n(a.value)
  }
), td = "_bordered_1qyul_35", nd = "_checked_1qyul_91", gt = {
  switch: "_switch_1qyul_1",
  bordered: td,
  checked: nd
}, Bf = ({
  checked: e,
  onChange: t,
  children: n,
  variant: o = ao.standard
}) => /* @__PURE__ */ r.jsxs("label", { className: `${gt.switch} ${gt[o]} ${e ? gt.checked : ""}`, children: [
  /* @__PURE__ */ r.jsx(
    "input",
    {
      type: "checkbox",
      checked: e,
      onChange: ({ target: s }) => {
        t(s.checked);
      }
    }
  ),
  /* @__PURE__ */ r.jsx("span", { className: gt.slider }),
  n
] }), Df = ({ children: e, className: t }) => {
  const { clientWidth: n } = document.body;
  return /* @__PURE__ */ r.jsx(Sr, { edge: ce.INVERTED_TOP, curveHeight: Math.min(n * 45 / 1440, 45), children: /* @__PURE__ */ r.jsx(Le, { type: Se.FLUID, className: t, children: /* @__PURE__ */ r.jsx(Le, { children: e }) }) });
}, ir = ({ clientX: e, clientY: t }) => {
  const n = document.elementFromPoint(e, t);
  if (n === null)
    return !1;
  const { parentElement: o } = n;
  return ![HTMLButtonElement, HTMLAnchorElement, HTMLInputElement, HTMLFormElement].some((l) => n instanceof l || o instanceof l);
}, lr = ({ clientY: e, clientX: t }, n) => {
  const o = document.elementFromPoint(t, e);
  return n !== void 0 ? n.some(({ current: s }) => s != null && (s === o || s.contains(o))) : !1;
}, Pf = ({
  hoverStyle: e,
  children: t,
  onClick: n,
  onMouseOver: o,
  onMouseLeave: s,
  defaultStyle: l = {},
  className: a = "",
  excludedElements: c
}) => {
  const [h, p] = A({}), _ = (d) => {
    o !== void 0 && o(d), ir(d) && !lr(d, c) ? p({ ...e, position: "relative", zIndex: 1e3 }) : p({});
  }, g = (d) => {
    s !== void 0 && s(d), p({});
  }, i = (d) => {
    ir(d) && !lr(d, c) && n();
  };
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      style: { ...l, ...h },
      className: a,
      onMouseOver: _,
      onMouseLeave: g,
      onClick: i,
      children: t
    }
  );
}, rd = "_header_1vy87_1", od = {
  header: rd
}, sd = "_headerContent_s9g5e_1", id = {
  headerContent: sd
}, ld = "_headerLogoLink_1kofq_1", ad = {
  headerLogoLink: ld
}, cd = ({ href: e, visLogoMedNavn: t }) => /* @__PURE__ */ r.jsx("a", { style: { display: "flex" }, className: ad.headerLogoLink, href: e, children: t ? /* @__PURE__ */ r.jsx(Bc, {}) : /* @__PURE__ */ r.jsx(Dc, {}) }), ud = ({
  children: e,
  visLogoMedNavn: t,
  visFikenMoto: n,
  containerType: o = Se.XL
}) => /* @__PURE__ */ r.jsx(Le, { type: o, className: id.headerContent, children: /* @__PURE__ */ r.jsxs(we, { children: [
  /* @__PURE__ */ r.jsxs(se, { types: [ue.AUTO], children: [
    /* @__PURE__ */ r.jsx(cd, { href: "/", visLogoMedNavn: t }),
    n ? /* @__PURE__ */ r.jsx(Pr, {}) : null
  ] }),
  /* @__PURE__ */ r.jsx(se, { types: [ue.COLUMN], children: e })
] }) }), Hf = ({
  isAuthenticated: e,
  visLogoMedNavn: t,
  visFikenMoto: n,
  backgroundColor: o = "var(--fiken-color-white-500)",
  containerType: s = Se.XL
}) => {
  const l = Ot("header-navigation");
  return /* @__PURE__ */ r.jsx("header", { className: od.header, style: { backgroundColor: o }, children: /* @__PURE__ */ r.jsxs(ud, { visLogoMedNavn: t, visFikenMoto: n, containerType: s, children: [
    e ? null : /* @__PURE__ */ r.jsx(Dr, { param: l }),
    /* @__PURE__ */ r.jsx(nc, { isAuthenticated: e })
  ] }) });
}, Vf = ({ title: e, description: t, ogType: n = "website", children: o }) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx("title", { children: e }),
  /* @__PURE__ */ r.jsx("meta", { content: t, name: "description" }),
  /* @__PURE__ */ r.jsx("meta", { property: "og:title", content: e }),
  /* @__PURE__ */ r.jsx("meta", { property: "og:type", content: n }),
  /* @__PURE__ */ r.jsx("meta", { property: "og:site_name", content: e }),
  /* @__PURE__ */ r.jsx("meta", { property: "og:locale", content: "nb_no" }),
  /* @__PURE__ */ r.jsx("meta", { property: "og:url", content: window.location.href }),
  /* @__PURE__ */ r.jsx("meta", { property: "og:description", content: t }),
  o !== void 0 ? o : null
] }), qf = typeof window < "u" ? Pe : G, Wf = ({ isSupport: e, prefixForName: t = "ansatte" }) => {
  G(() => {
    if (e) {
      const n = document.querySelectorAll("link[rel~='icon'], link[rel='apple-touch-icon'], link[rel='manifest']");
      for (const o of n) {
        const s = o.getAttribute("href");
        if (s !== null && !s.includes("ansatte")) {
          const l = s.split("/"), a = l.pop();
          a !== void 0 && o.setAttribute("href", `${l.join("/")}/${t}-${a}`);
        }
      }
    }
  }, [e, t]);
}, dd = (e, t) => {
  const n = e.slice(), o = n.length % t !== 0 ? n.pop() : void 0, s = n.length, l = s / t, a = [];
  for (let c = 0; c < s; c = c + l)
    a.push(n.slice(c, c + l));
  return o != null && a[0].push(o), a;
}, Uf = ({ data: e, render: t }) => {
  const n = dd(e, 2);
  return /* @__PURE__ */ r.jsx(Le, { children: /* @__PURE__ */ r.jsx(we, { children: n.map((o, s) => /* @__PURE__ */ r.jsx(se, { types: [on.SIX], children: o.map((l) => /* @__PURE__ */ r.jsx(r.Fragment, { children: t(l) })) }, s)) }) });
}, fd = "_youtubeLink_14wyn_1", hd = {
  youtubeLink: fd
}, zf = ({
  children: e,
  url: t,
  className: n = "",
  style: o = {},
  ...s
}) => /* @__PURE__ */ r.jsxs("a", { ...s, href: t, className: `${hd.youtubeLink} ${n}`, style: o, children: [
  /* @__PURE__ */ r.jsx("span", { children: e }),
  /* @__PURE__ */ r.jsxs(
    "svg",
    {
      "aria-label": "Ekstern lenke",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ r.jsx(
          "path",
          {
            d: "M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11",
            stroke: "#0539F7",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ r.jsx("path", { d: "M15 3H21V9", stroke: "#0539F7", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        /* @__PURE__ */ r.jsx("path", { d: "M10 14L21 3", stroke: "#0539F7", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
      ]
    }
  )
] }), pd = "_root_zxvs2_1", md = {
  root: pd
}, Gf = ({
  children: e,
  href: t,
  style: n = {},
  className: o = "",
  ...s
}) => /* @__PURE__ */ r.jsx("a", { ...s, href: `${t}`, className: `${md.root} ${o}`, style: n, children: e }), gd = "_root_1ffll_1", xd = "_control_1ffll_16", _n = {
  root: gd,
  control: xd
}, co = (e, t, n) => n === 1 ? wn(e.split("/side?")[0], { value: t.value }) : wn(e, { ...t, sidenummer: n }), vd = ({ label: e, url: t }) => /* @__PURE__ */ r.jsx("li", { className: _n.control, children: /* @__PURE__ */ r.jsxs(Ct, { to: t, children: [
  /* @__PURE__ */ r.jsx(
    "svg",
    {
      width: "9",
      height: "14",
      viewBox: "0 0 9 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: { transform: "rotate(180deg)" },
      children: /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M1.5 13L7.5 7L1.5 1",
          stroke: "var(--fiken-color-purple-800)",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  ),
  /* @__PURE__ */ r.jsx("span", { children: e })
] }) }), yd = ({ url: e, label: t }) => /* @__PURE__ */ r.jsx("li", { className: _n.control, children: /* @__PURE__ */ r.jsxs(Ct, { to: e, children: [
  /* @__PURE__ */ r.jsx("span", { children: t }),
  /* @__PURE__ */ r.jsx("svg", { width: "9", height: "14", viewBox: "0 0 9 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ r.jsx(
    "path",
    {
      d: "M1.5 13L7.5 7L1.5 1",
      stroke: "var(--fiken-color-purple-800)",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) })
] }) }), uo = Et(
  ({ previousLabel: e, nextLabel: t, route: n, currentPage: o, params: s, total: l, visiblePages: a }) => {
    const c = (h) => co(n, s, h);
    return /* @__PURE__ */ r.jsxs("ul", { className: _n.root, children: [
      o > 0 && /* @__PURE__ */ r.jsx(vd, { label: e, url: `${c(o)}` }),
      a.map((h) => /* @__PURE__ */ r.jsx("li", { "data-active": o === h, children: /* @__PURE__ */ r.jsx(Ct, { to: `${c(h + 1)}`, children: h + 1 }) }, h)),
      o < l - 1 && /* @__PURE__ */ r.jsx(yd, { label: t, url: `${c(o + 2)}` })
    ] });
  }
);
uo.displayName = "Pagination";
const kd = ({
  data: e,
  render: t,
  route: n,
  itemsPerPage: o,
  pageRangeDisplayed: s,
  nextLabel: l,
  previousLabel: a
}) => {
  const { sidenummer: c = "0" } = bn(), h = bn(), [p, _] = A(), g = Math.max(0, Number(c) - 1), i = Math.ceil(e.length / o), d = [...Array(i).keys()], u = g >= s, x = g - Math.floor(s / 2), m = g + Math.ceil(s / 2), v = Math.max(0, u ? x : 0), b = Math.min(i, u ? m : s), E = d.slice(v, b);
  return G(() => {
    const O = g * o;
    _(e.slice(O, O + o));
  }, [g, e, o]), c !== void 0 && !pa(c) || g >= i ? /* @__PURE__ */ r.jsx(go, { to: `${co(n, h, 1)}` }) : /* @__PURE__ */ r.jsxs("div", { children: [
    p != null && t(p),
    e.length > o && /* @__PURE__ */ r.jsx("nav", { style: { marginTop: "2.5rem" }, children: /* @__PURE__ */ r.jsx(
      uo,
      {
        params: h,
        visiblePages: E,
        total: i,
        nextLabel: l,
        previousLabel: a,
        route: n,
        currentPage: g
      }
    ) })
  ] });
}, Yf = Et(kd), _d = (e) => {
  let t = 0;
  for (const n of [...e])
    t += $r(n);
  return t;
}, Kf = ({
  data: e,
  defaultItemVisibleCount: t,
  render: n,
  className: o = "",
  style: s = {},
  expandButtonInnerText: l = "Se Alle"
}) => {
  const [a, c] = A({}), h = K(null), [p, _] = A(e.length > t), g = () => {
    const { current: i } = h;
    if (i !== null) {
      _(!1);
      const u = [...i.querySelectorAll("li")].slice(0, t + 1), x = () => {
        const m = _d(u), v = rt(i), b = { height: [`${m}px`, `${v}px`] };
        c({ height: `${v}px` });
        const E = {
          duration: 300,
          easing: "ease-out"
        }, O = new KeyframeEffect(i, b, E);
        new Animation(O, document.timeline).play();
      };
      window.requestAnimationFrame(x);
    }
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      "ul",
      {
        className: o,
        style: { ...s, ...a },
        ref: h,
        "data-lenght": e.length,
        "data-default": t,
        children: e.map((i, d) => /* @__PURE__ */ r.jsx(
          "li",
          {
            style: {
              display: p && d > t ? "none" : "list-item"
            },
            children: n(i)
          },
          d
        ))
      }
    ),
    p ? /* @__PURE__ */ r.jsx(Cr, { variant: be.PRIMARY, onClick: g, children: /* @__PURE__ */ r.jsx("span", { children: l }) }) : null
  ] });
}, jd = "_root_19ik2_1", wd = {
  root: jd
}, Xf = ({
  href: e,
  children: t,
  className: n = "",
  style: o = {},
  ...s
}) => /* @__PURE__ */ r.jsxs("a", { ...s, style: o, className: `${wd.root} ${n}`, href: e, children: [
  /* @__PURE__ */ r.jsxs("svg", { "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", children: [
    /* @__PURE__ */ r.jsx("path", { d: "M15.8332 10H4.1665", stroke: "#272727", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M9.99984 15.8337L4.1665 10.0003L9.99984 4.16699",
        stroke: "#272727",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] }),
  /* @__PURE__ */ r.jsx("span", { children: t })
] }), Zf = () => {
  let e = "prod";
  return hn.sanity.dataset === "test" && (e = "test"), `https://fiken.sanity.studio/${e}/desk/hjelpeartikkel`;
}, bd = "_root_k1jvs_1", Sd = {
  root: bd
}, Jf = ({ isLoading: e }) => {
  const [t, n] = A(!1);
  return G(() => {
    const o = setTimeout(() => {
      n(!0);
    }, 300);
    return e || clearTimeout(o), () => clearTimeout(o);
  }, [e]), t && e ? /* @__PURE__ */ r.jsx("div", { className: Sd.root }) : /* @__PURE__ */ r.jsx(r.Fragment, {});
};
let Zt = !1;
const Qf = (e, t) => {
  Zt || (e(), Zt = !0, setTimeout(() => {
    Zt = !1;
  }, t));
}, e0 = (e) => e.some((t) => {
  if (t.textContent !== null) {
    const n = t.textContent.toLowerCase().trim();
    return e.filter((o) => o !== t).some(({ textContent: o }) => o == null ? void 0 : o.toLowerCase().trim().includes(n));
  }
  return !1;
});
function t0(e, t) {
  return e.trim().toLowerCase() === t.trim().toLowerCase();
}
const $d = (e) => window.getComputedStyle(e).display === "none", n0 = (e = document.body) => {
  const o = [...e.querySelectorAll(`a[href], 
                     button,
                     input,
                     textarea,
                     select,
                     summary,
                     [tabindex]:not([tabindex="-1"])`)].filter(
    (s) => s instanceof HTMLElement && s.hasAttribute("disabled") !== null && s.getAttribute("aria-hidden") !== null && !$d(s)
  );
  return o.length > 0 ? o[0] : null;
}, r0 = (e) => Qe.samiskeBokstaver.test(e), o0 = (e) => {
  const { digitSpaceDigit: t } = Qe, n = document.createTreeWalker(e, NodeFilter.SHOW_TEXT), o = /* @__PURE__ */ new Set();
  for (; n.nextNode(); ) {
    const s = n.currentNode;
    if (s instanceof Text && s.wholeText.trim().length > 0 && t.test(s.wholeText)) {
      const { parentElement: l } = s;
      l !== null && o.add(l);
    }
  }
  for (e of o)
    e.innerHTML = e.innerHTML.replace(t, '<span style="white-space: nowrap">$1</span>');
};
function s0(e) {
  return `#${e.toLowerCase().trim().replace(/ /g, "_").replace(/\//g, "_").replace(/ø/g, "o").replace(/æ/g, "a").replace(/å/g, "a")}`;
}
const i0 = (e) => e.replace(/æ/g, "ae").replace(/ø/g, "oe").replace(/å/g, "aa").replace(/\s+/g, "-").replace(/[&/\\#,+()$~%.'":*?<>{}]/g, ""), l0 = (e) => e.toLowerCase().replace(/á/g, "a").replace(/đ/g, "d").replace(/č/g, "c").replace(/ŋ/g, "n").replace(/š/g, "s").replace(/ŧ/g, "t").replace(/ž/g, "z"), a0 = (e) => e.replaceAll(/[^\s\w]/g, " "), c0 = (e) => e.replaceAll("_", " ");
function u0(e) {
  return e.toLowerCase().trim().replace(/ø/g, "o").replace(/æ/g, "a").replace(/å/g, "a").replace(/\W/g, "-");
}
const d0 = (e) => {
  const t = /* @__PURE__ */ new Date(), n = typeof e == "string" ? new Date(e) : e;
  return n.getFullYear() === t.getFullYear() && n.getMonth() === t.getMonth() && n.getDate() === t.getDate();
}, f0 = (e) => {
  const t = /* @__PURE__ */ new Date(), n = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1), o = typeof e == "string" ? new Date(e) : e;
  return o.getFullYear() === n.getFullYear() && o.getMonth() === n.getMonth() && o.getDate() === n.getDate();
};
export {
  Lf as AddInputBar,
  Ga as Anchor,
  tf as AnchorButton,
  lc as AnimateHeightView,
  ra as ArticleBody,
  Ra as ArticleContent,
  ba as ArticleDescription,
  Ke as ArticleLinkMark,
  Ye as ArticleLinkType,
  xa as ArticleTemaTags,
  ml as AvbrytButton,
  Mt as Banner,
  Mc as BliMedPaWebinar,
  Te as BlockContent,
  Gi as BlogLink,
  Hc as Blogg,
  Id as Breakpoints,
  ve as BreakpointsContext,
  cf as BrukerRolles,
  Cr as Button,
  rf as ButtonLink,
  ye as ButtonSizes,
  be as ButtonVariants,
  Ar as CapitalizeFirstLetter,
  Tf as CheckboxInput,
  Td as CheckboxView,
  dn as Circle,
  ce as ClipPathEdges,
  se as Column,
  pe as ColumnLGTypes,
  on as ColumnMDTypes,
  Xd as ColumnSMTypes,
  Kd as ColumnXLTypes,
  ue as ColumnXSTypes,
  jo as Complete,
  Le as Container,
  Se as ContainerTypes,
  Al as CopyAnchorH2Link,
  ur as CopyAnchorLink,
  Sr as CurvedClipPath,
  fn as DetailsDisclosure,
  xl as DialogModal,
  vt as DialogModalTypes,
  Wl as DottedUnderline,
  yf as DropYMenu,
  Yn as DropYMenuDirections,
  Ec as Dropdown,
  jc as DropdownHeader,
  $c as DropdownItem,
  _f as DropdownItemNoResult,
  wc as DropdownSearchHeader,
  vi as DyplenkeReference,
  Rc as Enkelt,
  yi as EpostLink,
  Ha as ErrorBanner,
  zf as ExternalLink,
  ht as Figure,
  Mr as FigureContent,
  Pr as FikenMottoParagraph,
  Pc as FikenPromo,
  $f as FikenPromoCurvedContainer,
  Ci as Fil,
  Df as FluidContainerClipPath,
  Ef as Footer,
  zc as FooterBanner,
  Yl as Forklaring,
  Gl as ForklaringContent,
  Mf as FormGroup,
  Of as FormGroupDescription,
  Hr as FormGroupHeader,
  Vf as Head,
  Hf as Header,
  ud as HeaderContent,
  cd as HeaderLogoLink,
  Jd as HeadingOne,
  Xi as Highlight,
  Qc as Hjelp,
  Gc as HjelpOgKundeService,
  Vn as HjelpeArtikkelExpandCollapse,
  Fc as HvitLogoMedNavnetrekk,
  Sf as HvitLogosymbol,
  El as Image,
  Od as InProgress,
  Qd as InfoBanner,
  za as InfoButton,
  zn as Innhold,
  Jl as Innledning,
  If as Input,
  du as InputBar,
  uu as InputBarButton,
  Af as InputValidationMessage,
  Pf as InteractiveDivContainer,
  ji as KnappIBilde,
  Cf as Kontohjelp,
  Jf as LinearProgressIndicator,
  xn as LinkButton,
  Gf as LinkCard,
  Dr as LoggInnLinkButton,
  Bc as LogoMedNavnetrekk,
  Dc as Logosymbol,
  Xc as MailToFikenDescription,
  Zc as MailToFikenLink,
  Uf as MasonryGrid,
  su as MicrositesLink,
  ne as NoReferrerLink,
  Vi as NoreferrerAccentButtonLink,
  Yf as Page,
  uo as Pagination,
  Kf as PartialList,
  Nf as PatternInput,
  li as PlainSummaryContent,
  Fl as Portal,
  Rl as PortalContext,
  Rr as ProvFikenGratisLinkButton,
  Rf as Radio,
  Wn as RelatedArticles,
  Zd as RelativeContainer,
  we as Row,
  af as Sanity,
  rc as SanityContext,
  of as ScrollToTop,
  sf as SearchButton,
  Qa as SearchButtonStates,
  jf as SearchDropDown,
  ec as SearchIcon,
  Ff as SearchInput,
  di as SlikGarDuFrem,
  Lt as Spinner,
  lf as SpinnerButton,
  Be as SpinnerColor,
  Jc as SprOmHjelp,
  si as StyledSummary,
  ef as SuccessBanner,
  Bf as Switch,
  Ml as TableView,
  Si as TekstIBilde,
  ga as Temaer,
  nc as TilFikenLinkButton,
  Xf as TilbakeLink,
  tc as TilbakeTilFikenLinkButton,
  zi as Uthev,
  mi as VanligeSporsmal,
  Hl as VerticalTooltip,
  kf as VerticalTooltipContent,
  Md as Waiting,
  nf as WarningBanner,
  Ol as WhiteSpaceNoWrap,
  oc as WhoAmIContext,
  uf as WhoAmIView,
  bf as X,
  fl as XButton,
  Zs as Youtube,
  Ks as YoutubePlayer,
  $l as ZoomImageButton,
  bc as animateHeight,
  dt as articleLenkeType,
  Nd as articleType,
  ua as blacklistedEmailDomains,
  $r as calculateAbsoluteHeight,
  rt as calculateChildrenHeight,
  uc as calculateElementPosition,
  _d as calculateElementsHeight,
  el as calculateImageQuality,
  rn as calculateImageSize,
  Bl as calculateTooltipPosition,
  ca as capitalizeFirstLetter,
  ii as clamp,
  t0 as compareInsensitiveStrings,
  e0 as containsElementWithSameTextContent,
  dd as convertArrayOfObjectsToMatrix,
  Eo as copyText,
  Co as copyUrl,
  vf as dateStyle,
  tn as detailsDisclosureVariants,
  Ft as dialogPositions,
  vn as dropdownIcons,
  Ta as ekskluderteH2erFraInnhold,
  Gd as equals,
  Yd as erNorskMobilnummer,
  tl as extractWidthAndHeightFromRef,
  Ys as extractYoutubeId,
  $o as fallbackCopy,
  mt as fcErrorDisplayTypes,
  Ht as fcFormHasError,
  oi as generateCurvedClipPath,
  co as generateUrlForPage,
  n0 as getFirstFocusedElement,
  $d as hasDisplayNone,
  ta as highlight,
  zd as includes,
  r0 as inneholderSamiskeBokstaver,
  ao as inputVariants,
  xf as intlDateTimeFormat,
  Bd as isBlacklistedEmailDomain,
  fa as isBlank,
  ha as isEmail,
  da as isEmpty,
  Aa as isInRange,
  ma as isJson,
  Nr as isNil,
  ir as isNoneInteractiveElement,
  Rd as isNotBlank,
  Fd as isNotEmail,
  Ad as isNotEmpty,
  Ud as isNotJson,
  Hd as isNotNil,
  Dd as isNotNull,
  qd as isNotNullish,
  Pd as isNotUndefined,
  mn as isNull,
  Vd as isNullish,
  pa as isNumber,
  Wd as isString,
  d0 as isToday,
  f0 as isTomorrow,
  gn as isUndefined,
  Br as keyboardEventPropertyValues,
  Qf as leadingThrottle,
  s0 as makeUrlHash,
  o0 as noWrapDigits,
  i0 as norskifyText,
  Gs as pattern,
  Ir as portableTextComponents,
  Qe as regex,
  Or as removeNoneAscii,
  a0 as removePunctuation,
  l0 as replaceSamiWithAscii,
  aa as replaceSpaceWithUnderscore,
  c0 as replaceUnderscoreWithSpace,
  So as rippleAnimate,
  hn as sanityConfig,
  Zf as sanityHjelpeartikkelUrl,
  dr as scrollToDataHashElement,
  wa as sliceText,
  u0 as slugify,
  sc as smoothScrollToTop,
  Cc as throttle,
  gf as timeStyle,
  ai as toggleDetails,
  ft as urlForImage,
  pn as urlForSvg,
  Wf as useAnsatteFaviconHook,
  Fr as useClickListener,
  df as useClickOutsideListener,
  Er as useExpandDetails,
  wf as useFcForm,
  br as useGenerateCurvedClipPath,
  ci as useHeightLayoutEffect,
  na as useHighlight,
  qf as useIsomorphicLayoutEffect,
  ff as useOnScreen,
  hf as useResizeObserver,
  pr as useScrollToHashAnchorLink,
  mf as useScrollToOnParamChange,
  pf as useSmoothScrollToTop,
  ic as useToggleEffect,
  Ot as useUtmParams
};
